import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  FormLabel,
  Row,
  Table,
  FormControl,
} from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import {
  DEFAULT_VENDOR,
  DEFAULT_WAREHOUSE,
  DEMO_VALUE,
  DOCUMENT_CHANGED,
  NEW_ENTRY,
} from "../ds/App_Constants";
import { BaseBean, NodeData, RestReportBean } from "../ds/client_ds.js";
import {
  AddressBean,
  CustomerSearchCriteria,
  FabricStyleBean,
  FabricStyleImageBean,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  InventorySalesPurchasePositionCriteriaBean,
  MailInfoBean,
  PageListBean,
  PopupVendorOpenOrderSalesDetailPrintRequest,
  PurchaseOrderBean,
  PurchaseOrderDocumentBean,
  PurchaseOrderImageBean,
  PurchaseOrderLineAdjustmentBean,
  PurchaseOrderLineBean,
  PurchaseOrderLineLogisticsPlanUpdateBean,
  PurchaseOrderLineSearchCriteria,
  PurchaseOrderLogisticsPlanUpdateBean,
  PurchaseOrderModuleDependenciesBean,
  PurchaseOrderPrintRequest,
  PurchaseOrderSearchCriteria,
  PurchaseSourceSalesOrderDetailLineBean,
  PurchaseSourceSalesOrderLineDetailSearchCriteria,
  ReasonBean,
  RestAddressBean,
  RestCustomerListRequest,
  RestEntityUnLockRequest,
  RestFabricStyleListBeanRequest,
  RestFabricStyleListRequest,
  RestInvoiceMailInfoBeanRequest,
  RestPurchaseOrderBeanRequest,
  RestPurchaseOrderLineReasonRequest,
  RestPurchaseOrderLinesDataRequest,
  RestPurchaseOrderListRequest,
  RestPurchaseOrderReasonRequest,
  RestReadRequest,
  RestSalesOrderListRequest,
  RestVendorListRequest,
  RestVendorPurchaseOnOrderListRequest,
  SalesOrderSearchCriteria,
  VendorPurchaseOnOrderSearchCriteria,
  VendorSearchCriteria,
  VendorInvoicePaymentSearchCriteria,
  RestVendorInvoicePaymentListRequest,
  FabricStyleCostAndPriceMaintenanceBean,
} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import {
  CameraIcon,
  DeleteIcon,
  DropDwnDown,
  DropDwnUp,
  ExcelIcon,
  UploadDocIcon,
  Authentication,
  FaEye,
  FaEyeSlash,
  AddIcon,
} from "../gui_components/Icons.js";
import {
  AddressComponent,
  AlertToolBox,
  ColumnDefinition,
  DataGrid,
  DataGridColumnDefinition,
  DatePickerComponent,
  EditableDataGrid,
  InputCheckbox,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ReasonCaptureComponent,
  ShortCutMenuPopup,
  ShowError,
  DatePickerComponent_adv,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  toFormattedDate_v1,
} from "../gui_components/Util.js";
import noImage from "../images/no-image-icon-2.png";
import {
  PopupFabricInventoryPositionInq,
  PopupFabricPurchaseHistoryInq,
  PopupItemCurrentInventoryInq,
  PopupPurchaseAndSlesDetailsInq,
  PopupSalesPriceInq,
  PopupVendorOnOrderInq,
  PopupVendorPurchaseHistoryInq,
} from "../Inquiry/InquiryUtil.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { PurchaseOrderLookupHandler } from "../lookup/PurchaseOrderLookupHandler.js";
import { SalesOrderLookupHandler } from "../lookup/SalesOrderLookupHandler.js";
import { VendorLookupHandler } from "../lookup/VendorLookupHandler.js";
import {
  PopupFabricModule,
  PopupPurchaseReceiptModule,
  PopupSalesModule,
  PopupVendorModule,
  PurchaseModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { PurchaseOrderService } from "../services/PurchaseOrderService.js";
import { AccountPayableService } from "../services/AccountPayableService.js";
import { ReportService } from "../services/ReportService.js";
import { SalesOrderService } from "../services/SalesOrderService.js";
import { VendorService } from "../services/VendorService.js";
import {
  BaseInquiryToolBar,
  BaseNodeBar,
  BaseToolBar,
  ModuleToolBar,
} from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
import CustomTable from "../gui_components/CustomTable.js";
class PurchaseOrderList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.unapproveReasonDialogRef = React.createRef();
    this.cancelReasonDialogRef = React.createRef();
    this.lineCancelReasonDialogRef = React.createRef();
    this.colorCodeRef = React.createRef();
    this.vendorStyleRef = React.createRef();
    this.fabricStyleRef = React.createRef();
    this.state = {
      pageTitle: "Purchase Order Maintenance",
      purchaseOrderListData: [],
      pageList: new PageListBean(),
      criteria: new PurchaseOrderSearchCriteria(),
      purchaseOrderData: new PurchaseOrderBean(),
      purchaseOrderLineData: new PurchaseOrderLineBean(),
      dependenciesBean: new PurchaseOrderModuleDependenciesBean(),
      logisticData: new PurchaseOrderLogisticsPlanUpdateBean(),
      currentPageNumber: 0,
      totalCount: 0,
      error_list: [],
      nodeList: [],
      vendor_List: new Array(),
      fabricStyle_List: new Array(),
      fOBCities: new Array(),
      shipmentTerms: new Array(),
      wareHouses: new Array(),
      incoTerms: new Array(),
      paymentTerms: new Array(),
      vendorTerms: new Array(),
      transportTypes: new Array(),
      uoms: new Array(),
      shipVias: new Array(),
      isLoading: true,
      isDisableFields: false,
      isShowNodes: false,
      isShowNewButton: true,
      isShowBackButton: false,
      isShowSaveButton: false,
      isShowClearErrorButton: false,
      isShowPDFReportButton: false,
      isShowUnApproveButton: false,
      isShowApproveButton: false,
      isShowCancelButton: false,
      isPurchaseOrderListFormOpen: true,
      isPurchaseOrderEntryFormOpen: false,
      selectedNodeKey: "headerView",
      isPurchaseReceiptFormOpened: false,
      isPurchaseOrderHistoryFormOpened: false,
      isPurchaseOrderDetailFormOpened: false,
      currentFabricStyle: new FabricStyleBean(),
      currentFabricStyleSku: new FabricStyleSKUBean(),
      currentFabricStyleSkuList: new Array(),
      reasonData: new ReasonBean(),
      cancelReasons: [],
      unapprovalReasons: [],
      isResetModule: false,
      moduleForPopup: [],
      isShowPopup: false,
      simplePopupContent: [],
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isReadOnlyOrDisabled: false,
      isSpecialViewMode: false,
      purchaseOrderLookupHandler: null,
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      moduleOrderStatus: "",
      disablePurchaseOrderFormFields: false,
      disabled: false,
      isResetView: true,
      isFocus: false,
      isFocusLookup: true,
      isShowColorLookup: false,
      selectedExcelDataList: [],
      isShowExcelButton: false,
      isShowMailInvoicePopup: false,
      isShowAppproveAndPrintButton: false,
      isShowCopyPOButton: false,
      mailInfoData: new MailInfoBean(),
      isShowCopyPOPopup: false,
      copyPoCode: "",
      purchaseOrderLineAdjustmentData: new PurchaseOrderLineAdjustmentBean(),
      purchaseOrderLineAdjustmentDataList: new Array(),
      vendorPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      fabricColourPageListForAutoCompleteList: new Array(),
      shipViaPageListForAutoCompleteList: new Array(),
      showAutoCompleteShipViaList: false,
      vendorTermPageListForAutoCompleteList: new Array(),
      showAutoCompleteVendorTermList: false,
      shipmentTermPageListForAutoCompleteList: new Array(),
      showAutoCompleteShipmentTermList: false,
      locationPageListForAutoCompleteList: new Array(),
      showAutoCompleteLocationList: false,
      fobPageListForAutoCompleteList: new Array(),
      showAutoCompleteFOBList: false,
      showAutoCompleteList: true,
      showAutoCompleteFabricList: true,
      showAutoCompleteColourList: true,
      isMaintenanceMode: true,
      isDisabledFields: false,

      isShowProgressBarPopup: false,
      progressLoadingText: "",
      showAutoCompleteAdjReasonList: false,
      adjReasonPageListForAutoCompleteList: new Array(),
      adjReason: [],
      disableCancelButton: false,
      isShowAdjQtyButton: false,
      isShowAdjDeleteButton: false,
      isShowAdjustedQuantityPopup: false,
      isShowPopupAlert: false,
      isShowLineAlert: false,
      isShowLinePopup: false,
      isMiscDisable: false,
      miscellaneousReasons: new Array(),
      extraChargeReasons: new Array(),
      lineDatas: [],
      isSalesOrderAllocationPopup: false,
      isCustomerReserveAllocationPopup: false,
      isShowAlertLvl1: false,
      temp_selectedLineList: [],
      salesAlocationLines: [],
      purchaseSourceSalesOrderLineData:
        new PurchaseSourceSalesOrderDetailLineBean(),
      salesPageListForAutoCompleteList: new Array(),
      showAutoCompleteSOList: false,
      customerCodePageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: false,
      order: "asc",
      sortField: "",
      is3PL: false,
      isShowSalesModule: false,
      isShowReserveAllocation: false,
      isShowCancelReasonPopup: false,
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      isShowUnApproveReasonPopup: false,
      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
      isShowLineCancelReasonPopup: false,
      addressData: new AddressBean(),
      shippingAddressData: new AddressBean(),
      isShowAddressPopup: false,
      isShowShipAddressPopup: false,
      showAutoCompleteCityList: false,
      cityPageListForAutoCompleteList: new Array(),
      cityList: [],
      stateList: [],
      countryList: [],
      showAutoCompleteStateList: false,
      statePageListForAutoCompleteList: new Array(),
      showAutoCompleteCountryList: false,
      countryPageListForAutoCompleteList: new Array(),
      isDisableShippingAdd: false,
      purchaseOrderPageListForAutoCompleteList: new Array(),
      showAutoCompletePurchaseOrderList: false,
      isShowCopyPoAlert: false,
      poLinesList: [],
      isReseted: false,
      isViewMode: false,
      businessDivisions: new Array(),
      businessDivisionPageListForAutoCompleteList: new Array(),
      showAutoCompleteBusinessDivisionList: false,
      purchaseOrderTypes: new Array(),
      orderTypePageListForAutoCompleteList: new Array(),
      showAutoCompleteOrderTypeList: false,
      isShowOrderType: false,
      isTexco: false,

      //new
      images: [],
      imgUrl: [],
      url_temp: "",
      images_temp: [],
      documents: [],
      preview_Docs: [],
      isPurchaseOrderImageFormOpened: false,
      isPurchaseOrderDocumentFormOpened: false,
      isPurchaseOrderModelDocumentFormOpened: false,
      isPaymentDetailViewOpen: false,
      isAuthenticationPopup: false,
      authenticationPassword: "",
      isShowPriceChangable: false,
      isModifyCostCalculation: false,

      modifyCost: 0,

      isTexcoDiableUpdateFields: false,
      paymentDetailList: new Array(),

      fabricStyleCode: "",
      isAllowRead: false,
      isShowAddButton: false,

      isShowCostDetail: false,
      costData: new FabricStyleCostAndPriceMaintenanceBean(),
      isVendorInvoiceShow:false,
    };
    this.defaultVendor = DEFAULT_VENDOR;
  }
  code = NEW_ENTRY;
  isLocked = false;
  moduleCaption = "Purchase Order Maintenance";
  fetchAttributesFromLocalStorage = () => {
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };

    let fOBCities = attribute_cache.fOBCities;
    let fOBCities_temp = [];
    if (fOBCities != null || fOBCities != undefined) {
      fOBCities.map((attr) => {
        fOBCities_temp.push(attr);
        this.state.fOBCities = ModuleUtils.isActiveAttribute(fOBCities_temp);
      });
    }
    let shipmentTerms = attribute_cache.shipmentTerms;
    let shipmentTerms_temp = [];
    if (shipmentTerms != null || shipmentTerms != undefined) {
      shipmentTerms.map((attr) => {
        shipmentTerms_temp.push(attr);
        this.state.shipmentTerms =
          ModuleUtils.isActiveAttribute(shipmentTerms_temp);
      });
    }
    let warehouses = attribute_cache.warehouses;
    let warehouses_temp = [];
    if (warehouses != null || warehouses != undefined) {
      warehouses.map((attr) => {
        warehouses_temp.push(attr);
        this.state.wareHouses = ModuleUtils.isActiveAttribute(warehouses_temp);
      });
    }
    let incoTerms = attribute_cache.incoTerms;
    let incoTerms_temp = [];
    if (incoTerms != null || incoTerms != undefined) {
      incoTerms.map((attr) => {
        incoTerms_temp.push(attr);
        this.state.incoTerms = ModuleUtils.isActiveAttribute(incoTerms_temp);
      });
    }
    let paymentTerms = attribute_cache.paymentTerms;
    let paymentTerms_temp = [];
    if (paymentTerms != null || paymentTerms != undefined) {
      paymentTerms.map((attr) => {
        paymentTerms_temp.push(attr);
        this.state.paymentTerms =
          ModuleUtils.isActiveAttribute(paymentTerms_temp);
      });
    }
    let transportTypes = attribute_cache.transportTypes;
    let transportTypes_temp = [];
    if (transportTypes != null || transportTypes != undefined) {
      transportTypes.map((attr) => {
        transportTypes_temp.push(attr);
        this.state.transportTypes =
          ModuleUtils.isActiveAttribute(transportTypes_temp);
      });
    }

    let uoms = attribute_cache.uoms;
    let uoms_temp = [];
    if (uoms != null || uoms != undefined) {
      uoms.map((attr) => {
        uoms_temp.push(attr);
        this.state.uoms = ModuleUtils.isActiveAttribute(uoms_temp);
      });
    }
    let vendorTerms = attribute_cache.vendorTerms;
    let vendorTerms_temp = [];
    if (vendorTerms != null || vendorTerms != undefined) {
      vendorTerms.map((attr) => {
        vendorTerms_temp.push(attr);
        this.state.vendorTerms =
          ModuleUtils.isActiveAttribute(vendorTerms_temp);
      });
    }
    let shipVias = attribute_cache.vendorShipVias;
    let shipVias_temp = [];
    if (shipVias != null || shipVias != undefined) {
      shipVias.map((attr) => {
        shipVias_temp.push(attr);
        this.state.shipVias = ModuleUtils.isActiveAttribute(shipVias_temp);
      });
    }
    this.state.unapprovalReasons = [];
    let unapprovalReasons = attribute_cache.purchaseOrderUnApprovalReasons;
    let unapprovalReasons_temp = [];
    unapprovalReasons.map((ent) => {
      unapprovalReasons_temp.push(ent);
      this.state.unapprovalReasons = ModuleUtils.isActiveAttribute(
        unapprovalReasons_temp,
      );
    });
    this.state.cancelReasons = [];
    let cancelReasons = attribute_cache.purchaseOrderCancelReasons;
    let cancelReasons_temp = [];
    cancelReasons.map((ent) => {
      cancelReasons_temp.push(ent);
      this.state.cancelReasons =
        ModuleUtils.isActiveAttribute(cancelReasons_temp);
    });
    this.state.cityList = [];
    let cityList_temp = [];
    let cityList = attribute_cache.cities;
    cityList.map((ent) => {
      cityList_temp.push(ent);
      this.state.cityList = ModuleUtils.isActiveAttribute(cityList_temp);
    });

    this.state.stateList = [];
    let stateList_temp = [];
    let stateList = attribute_cache.states;
    stateList.map((ent) => {
      stateList_temp.push(ent);
      this.state.stateList = ModuleUtils.isActiveAttribute(stateList_temp);
    });
    this.state.countryList = [];
    let countryList_temp = [];
    let countryList = attribute_cache.countries;
    countryList.map((ent) => {
      countryList_temp.push(ent);
      this.state.countryList = ModuleUtils.isActiveAttribute(countryList_temp);
    });
    this.state.adjReason = [];
    let adjReason_temp = [];
    let adjReason = attribute_cache.inventoryAdjustmentReasons;
    if (adjReason != null || adjReason != undefined) {
      adjReason.map((attr) => {
        adjReason_temp.push(attr);
        this.state.adjReason = ModuleUtils.isActiveAttribute(adjReason_temp);
      });
    }
    let extraChargeReasons = attribute_cache.purchaseOrderExtraChargeReasons;
    let extraChargeReasons_temp = [];
    if (extraChargeReasons != null || extraChargeReasons != undefined) {
      extraChargeReasons.map((attr) => {
        extraChargeReasons_temp.push(attr);
        this.state.extraChargeReasons = ModuleUtils.isActiveAttribute(
          extraChargeReasons_temp,
        );
      });
    }
    let miscellaneousReasons = attribute_cache.purchaseOrderExtraChargeReasons;
    let miscellaneousReasons_temp = [];
    if (miscellaneousReasons != null || miscellaneousReasons != undefined) {
      miscellaneousReasons.map((attr) => {
        miscellaneousReasons_temp.push(attr);
        this.state.miscellaneousReasons = ModuleUtils.isActiveAttribute(
          miscellaneousReasons_temp,
        );
      });
    }
    let businessDivisions = attribute_cache.businessDivisions;
    let businessDivisions_temp = [];
    if (businessDivisions != null || businessDivisions != undefined) {
      businessDivisions.map((attr) => {
        businessDivisions_temp.push(attr);
        this.state.businessDivisions = ModuleUtils.isActiveAttribute(
          businessDivisions_temp,
        );
      });
    }

    let purchaseOrderTypes = attribute_cache.purchaseOrderTypes;
    let purchaseOrderTypes_temp = [];
    if (purchaseOrderTypes != null || purchaseOrderTypes != undefined) {
      purchaseOrderTypes.map((attr) => {
        purchaseOrderTypes_temp.push(attr);
        this.state.purchaseOrderTypes = ModuleUtils.isActiveAttribute(
          purchaseOrderTypes_temp,
        );
      });
    }
  };
  componentDidMount() {
    const { appData } = this.context;

    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.setState({ is3PL: true });
    }
    if (ConfigManager.purchaseOrderTypeValidationRequired()) {
      this.setState({ isShowOrderType: true });
    }
    if (ConfigManager.isTexcoFabricKey()) {
      this.state.isTexco = true;
      this.setState({
        isTexco: true,
      });
    }
    this.report_url = appData.reportURL;
    ModuleUtils.getPurchaseOrderStatusList();
    ModuleUtils.getPurchaseOrderReceiptStatusList();
    ModuleUtils.getPurchaseOrderLineStatusList();
    ModuleUtils.getPurchaseOrderPaymentStatusList();
    this.fetchAttributesFromLocalStorage();
    this.state.criteria = new PurchaseOrderSearchCriteria();
    this.state.criteria.companyCode = this.companyCode;
    this.state.pageList = new PageListBean();
    this.state.pageList.pageSize = 50;
    // this.state.pageList.currentPage = 1;
    this.getVendorList();
    this.getFabricStyleList();
    this.initLookupHandlers();
    // this.loadPage();
    //set readOnly components using view Modes && disable toolbars
    let isReadOnly = this.state.isReadOnlyOrDisabled;
    let isSpecialViewMode = this.state.isSpecialViewMode;
    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;
    }
    this.setState({
      isReadOnlyOrDisabled: isReadOnly,
      isSpecialViewMode: isSpecialViewMode,
    });
    if (this.props.code !== "" && this.props.code !== undefined) {
      this.code = this.props.code;
      this.editPurchaseOrder(this.props.code);
      // this.unlockPurchaseOrder(this.props.code, false);
      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isDisabledFields: true,
        disablePurchaseOrderFormFields: true,
        isViewMode: false,
      });
    } else {
      this.loadPage();
    }
  }
  initLookupHandlers = () => {
    let purchaseOrderLookupHandler = new PurchaseOrderLookupHandler(
      this.companyCode,
      "Purchase Order",
    );
    this.setState({ purchaseOrderLookupHandler: purchaseOrderLookupHandler });
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handleResponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  unlockPurchaseOrder = (code) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    if (SecurityAccessManager.PurchaseOrderMaintenance_IsAccessible()) {
      PurchaseOrderService.unLockPurchaseOrder(
        request,
        this.unlockPurchaseOrderResponse,
        this.unlockPurchaseOrderError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  unlockPurchaseOrderResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editPurchaseOrder(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        // this.isLocked = false; optional
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };
  unlockPurchaseOrderError = (error) => {
    ShowError("Error : ", error);
  };
  loadPage = (pageNumber) => {
    const currentPageList = this.state.pageList;
    const pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (currentPageList != null)
      pageInput.totalCount = currentPageList.totalCount;

    this.setState({ pageList: pageInput }, () => {
      this.loadPurchaseOrderPage();
    });
  };
  loadPurchaseOrderPage = () => {
    let requestInput = new RestPurchaseOrderListRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = this.state.criteria;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
      isResetView: false,
      isMaintenanceMode: false,
    });
    if (SecurityAccessManager.PurchaseOrderMaintenance_IsAccessible()) {
      PurchaseOrderService.getPurchaseOrderPageList(
        requestInput,
        this.loadPurchaseOrderResponse,
        this.loadPurchaseOrderError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadPurchaseOrderResponse = (response) => {
    if (response.data != null && response.data.purchaseOrderPageList != null) {
      const { purchaseOrders, totalCount, currentPage } =
        response.data.purchaseOrderPageList;

      if (!isEmptyArray(purchaseOrders)) {
        this.setState((prevState) => ({
          isLoading: false,
          purchaseOrderListData: purchaseOrders,
          pageList: {
            ...prevState.pageList,
            totalCount: totalCount,
            currentPage: currentPage,
          },
        }));
      } else {
        this.setState((prevState) => ({
          isLoading: false,
          purchaseOrderListData: [],
          pageList: {
            ...prevState.pageList,
            totalCount: 0,
            currentPage: 1,
          },
          alertMessage: ["No Records Found"],
          alertType: "danger",
          isShowAlert: true,
        }));
      }
    } else {
      this.setState({
        isLoading: false,
        purchaseOrderListData: [],
        alertMessage: ["No Records Found"],
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  loadPurchaseOrderError = (error) => {
    ShowError("Error : ", error);
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  loadVendorListResponse = (response) => {
    let vendor_List = [];
    if (response.data != null && response.data.vendorPageList != null) {
      if (!isEmptyArray(response.data.vendorPageList.vendors)) {
        vendor_List = response.data.vendorPageList.vendors;
      }
    }
    this.setState({ vendor_List: vendor_List });
  };
  getVendorList = () => {
    let criteria = new VendorSearchCriteria();
    criteria.companyCode = this.companyCode;
    let requestInput = new RestVendorListRequest();
    requestInput.pageInput = new PageListBean();
    requestInput.searchCriteria = criteria;
    VendorService.getVendorPageList(
      requestInput,
      this.loadVendorListResponse,
      this.errorCallBack,
    );
  };
  loadFabricListResponse = (response) => {
    let fabricStyle_List = [];
    if (response.data != null && response.data.fabricStylePageList != null) {
      if (!isEmptyArray(response.data.fabricStylePageList.fabricStyles)) {
        fabricStyle_List = response.data.fabricStylePageList.fabricStyles;
      }
    }
    this.setState({ fabricStyle_List: fabricStyle_List });
  };
  getFabricStyleList = () => {
    let criteria = new FabricStyleSearchCriteria();
    criteria.companyCode = this.companyCode;
    let requestInput = new RestFabricStyleListRequest();
    requestInput.pageInput = new PageListBean();
    requestInput.searchCriteria = criteria;
    this.loadFabricStyleList(requestInput);
  };
  loadFabricStyleList = (requestInput) => {
    FabricStyleService.getFabricStylePageList(
      requestInput,
      this.loadFabricListResponse,
      this.errorCallBack,
    );
  };
  getEmptyView() {
    return <div></div>;
  }
  getNodeList = () => {
    let nodeList = [];
    let poData = this.state.purchaseOrderData;
    let headerObject = this.getEmptyView();
    let orderDetailObject = this.getEmptyView();
    let orderHistoryObject = this.getEmptyView();
    let orderReceiptObject = this.getEmptyView();
    let orderImageObject = this.getEmptyView();
    let orderDocumentObject = this.getEmptyView();
    let paymentDetailObject = this.getEmptyView();
    let headerNode = new NodeData("headerView", "Header", headerObject);
    let orderDetailNode = new NodeData(
      "orderDetailView",
      "OrderDetails",
      orderDetailObject,
    );
    let orderHistoryNode = new NodeData(
      "orderHistoryView",
      "History",
      orderHistoryObject,
    );
    let orderReceiptNode = new NodeData(
      "orderReceiptView",
      "Receipts",
      orderReceiptObject,
    );
    let orderImageNode = new NodeData(
      "orderImageView",
      "Image",
      orderImageObject,
    );
    let orderDocumentNode = new NodeData(
      "orderDocumentView",
      "Documents",
      orderDocumentObject,
    );
    let orderModelDocumentNode = new NodeData(
      "orderModelDocumentView",
      "Model Document",
    );
    nodeList["headerView"] = headerNode;
    nodeList["orderDetailView"] = orderDetailNode;

    let paymentDetailNode = new NodeData(
      "paymentDetailView",
      "Payment Detail",
      paymentDetailObject,
    );

    if (poData.isFetched == true) {
      nodeList["orderHistoryView"] = orderHistoryNode;
      nodeList["orderReceiptView"] = orderReceiptNode;
      nodeList["orderImageView"] = orderImageNode;
      nodeList["orderDocumentView"] = orderDocumentNode;
      nodeList["paymentDetailView"] = paymentDetailNode;

      // nodeList["orderModelDocumentView"] = orderModelDocumentNode;
    }
    this.setState({ nodeList: nodeList });
  };
  closeAllNodeViews = () => {
    this.setState({
      isShowSaveButton: false,
      isPurchaseOrderListFormOpen: false,
      isPurchaseOrderEntryFormOpen: false,
      isPurchaseReceiptFormOpened: false,
      isPurchaseOrderDetailFormOpened: false,
      isPurchaseOrderHistoryFormOpened: false,
      isPurchaseOrderImageFormOpened: false,
      isPurchaseOrderDocumentFormOpened: false,
      isPurchaseOrderModelDocumentFormOpened: false,
      isPaymentDetailViewOpen: false,
    });
  };
  save = () => {
    this.savePurchaseOrder();
  };
  back = () => {
    this.closeEntryForm();
    this.loadPage(1);
  };
  closeEntryForm = () => {
    this.closeAllNodeViews();
    let pageTitle = this.moduleCaption;
    this.setState({
      isPurchaseOrderListFormOpen: true,
      isPurchaseOrderEntryFormOpen: false,
      isCollapsible_open: false,
      isShowSaveButton: false,
      isShowNewButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      isShowPDFReportButton: false,
      isShowUnApproveButton: false,
      isShowApproveButton: false,
      isShowCancelButton: false,
      isShowNodes: false,
      pageTitle: pageTitle,
      moduleKeyCode: NEW_ENTRY,
      isShowModuleSearchContainer: false,
      disabled: false,
      isResetView: false,
      isMaintenanceMode: false,
      isShowAppproveAndPrintButton: false,
      isDisabledFields: false,
      isDisableShippingAdd: false,
      isViewMode: false,
      isSpecialViewMode: false,
    });
  };
  openEntryForm = () => {
    this.closeAllNodeViews();
    this.getNodeList();
    this.setState({
      isPurchaseOrderListFormOpen: false,
      isPurchaseOrderEntryFormOpen: true,
      isCollapsible_open: false,
      isShowSaveButton: true,
      isShowNewButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowPDFReportButton: false,
      isShowUnApproveButton: false,
      isShowApproveButton: false,
      isShowCancelButton: false,
      isShowNodes: true,
      isShowModuleSearchContainer: true,
      isResetView: false,
      customerCodePageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: false,
      isShowReserveAllocation: false,
      showAutoCompleteFabricList: false,
      fabricPageListForAutoCompleteList: [],
    });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        isCustomerListFormOpen: false,
        disabled: false,
        isDisableNodeFields: false,
        isDisabledFields: false,
        disablePurchaseOrderFormFields: false,
        isDisableShippingAdd: false,
        isTexcoDiableUpdateFields: false,
      });
    } else {
      this.setState({
        isDisabledFields: true,
        disablePurchaseOrderFormFields: true,
        isShowReserveAllocation: false,
        disabled: true,
        isDisableShippingAdd: true,
        isTexcoDiableUpdateFields: true,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
    let purchaseOrderData = this.state.purchaseOrderData;
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let orderStatus = ModuleUtils.getPurchaseOrderStatusCaption(
      this.state.purchaseOrderData.orderStatus,
    );
    if (orderStatus !== undefined && orderStatus !== null) {
      moduleOrderStatus = orderStatus;
    }
    this.setState({ moduleOrderStatus: moduleOrderStatus });
    if (purchaseOrderData) {
      if (
        purchaseOrderData.orderStatus ==
        LogicConstants.PURCHASE_ORDER_APPROVE_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: true,
          isShowCancelButton: true,
          isShowApproveButton: false,
          disablePurchaseOrderFormFields: true,
          isShowSaveButton: true,
          isShowExcelButton: true,
          isShowMailButton: true,
          isShowAppproveAndPrintButton: false,
          isShowCopyPOButton: false,
          disableCancelButton: false,
          isShowAdjQtyButton: false,
          isMiscDisable: true,
          isShowPDFReportButton: true,
          isShowReserveAllocation: true,
          isDisableShippingAdd: true,
          isTexcoDiableUpdateFields: true,
        });
      }
      if (
        purchaseOrderData.orderStatus ==
        LogicConstants.PURCHASE_ORDER_RECEIVED_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: true,
          isShowApproveButton: false,
          isShowClearErrorButton: true,
          isShowSaveButton: false,
          disablePurchaseOrderFormFields: true,
          isShowExcelButton: true,
          isShowMailButton: true,
          isShowAppproveAndPrintButton: false,
          isShowCopyPOButton: false,
          disableCancelButton: true,
          isShowAdjQtyButton: false,
          isMiscDisable: true,
          isShowPDFReportButton: true,
          isShowReserveAllocation: false,
          isDisableShippingAdd: true,
          isTexcoDiableUpdateFields: true,
        });
      }
      if (
        purchaseOrderData.orderStatus ==
        LogicConstants.PURCHASE_ORDER_UNAPPROVE_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: false,
          isShowApproveButton: true,
          disablePurchaseOrderFormFields: false,
          isShowSaveButton: true,
          isShowExcelButton: true,
          isShowMailButton: true,
          isShowAppproveAndPrintButton: true,
          isShowCopyPOButton: false,
          disableCancelButton: false,
          isShowAdjQtyButton: true,
          isMiscDisable: false,
          isShowPDFReportButton: true,
          isShowReserveAllocation: false,
          isDisableShippingAdd: false,
          isTexcoDiableUpdateFields: false,
        });
      }
      if (
        purchaseOrderData.orderStatus ==
        LogicConstants.PURCHASE_ORDER_CANCEL_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: false,
          isShowApproveButton: false,
          disablePurchaseOrderFormFields: true,
          isShowSaveButton: false,
          isShowExcelButton: true,
          isShowMailButton: true,
          isShowAppproveAndPrintButton: false,
          isShowCopyPOButton: false,
          disableCancelButton: true,
          isShowAdjQtyButton: false,
          isMiscDisable: true,
          isShowPDFReportButton: true,
          isShowReserveAllocation: false,
          isDisabledFields: true,
          isDisableShippingAdd: true,
          isTexcoDiableUpdateFields: true,
        });
      }
      if (
        purchaseOrderData.orderStatus ==
        LogicConstants.PURCHASE_ORDER_FORCE_CLOSED_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: false,
          isShowApproveButton: false,
          disablePurchaseOrderFormFields: true,
          isShowSaveButton: false,
          isShowExcelButton: true,
          isShowMailButton: true,
          isShowAppproveAndPrintButton: false,
          isShowCopyPOButton: false,
          disableCancelButton: true,
          isShowAdjQtyButton: false,
          isMiscDisable: true,
          isShowPDFReportButton: true,
          isShowReserveAllocation: false,
          isDisabledFields: true,
          isDisableShippingAdd: true,
          isTexcoDiableUpdateFields: true,
        });
      }
      if (
        purchaseOrderData.orderStatus ==
        LogicConstants.PURCHASE_ORDER_PARTIALLY_RECEIVED_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: true,
          isShowApproveButton: false,
          disablePurchaseOrderFormFields: true,
          isShowSaveButton: false,
          isShowExcelButton: true,
          isShowMailButton: true,
          isShowAppproveAndPrintButton: false,
          isShowCopyPOButton: false,
          isShowAdjQtyButton: false,
          isMiscDisable: true,
          isShowPDFReportButton: true,
          isShowReserveAllocation: true,
          isDisableShippingAdd: false,
          isTexcoDiableUpdateFields: true,
        });
      }
      if (!purchaseOrderData.isFetched == true) {
        this.setState({
          isShowUnApproveButton: false,
          isShowExcelButton: false,
          isShowMailButton: false,
          isShowAppproveAndPrintButton: true,
          isShowCopyPOButton: true,
          disablePurchaseOrderFormFields: false,
          isMiscDisable: false,
          isShowPDFReportButton: false,
          isShowAdjQtyButton: true,
          isDisabledFields: false,
          isDisableShippingAdd: false,
          isTexcoDiableUpdateFields: false,
        });
      }
      if (this.isModifyPosible === true) {
        this.setState({
          isShowSaveButton: true,
          isShowAddIcon: true,
        });
      }
    }
    if (this.state.isViewMode || this.state.isSpecialViewMode) {
      let pageTitle = this.moduleCaption + " - VIEW";
      this.setState({
        disabled: true,
        pageTitle: pageTitle,
        disablePurchaseOrderFormFields: true,
        disableCancelButton: true,
        isMiscDisable: true,
        isDisabledFields: true,
        isDisableShippingAdd: true,
        isTexcoDiableUpdateFields: true,
      });
    }
  };
  isModifyPosible = () => {
    let isModify = false;
    let purchaseOrderData = this.state.purchaseOrderData;
    if (
      purchaseOrderData.orderStatus ==
        LogicConstants.PURCHASE_ORDER_APPROVE_STATUS ||
      purchaseOrderData.orderStatus ==
        LogicConstants.PURCHASE_ORDER_PARTIALLY_RECEIVED_STATUS ||
        LogicConstants.PURCHASE_ORDER_RECEIVED_STATUS
    ) {
      isModify = true;
    }
    return isModify;
  };
  editPurchaseOrder = (code) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    let isLockRequired = false;
    if (this.props.isSpecialViewMode) {
      isLockRequired = false;
    } else {
      isLockRequired = NEW_ENTRY === code ? false : true;
    }
    readrestInput.isLockRequired = isLockRequired;
    this.setState({
      isLoading: true,
      loadingText: "Loading..",
    });
    if (SecurityAccessManager.PurchaseOrderMaintenanceView_IsAccessible) {
      PurchaseOrderService.initPurchaseOrderModule(
        readrestInput,
        this.editPurchaseOrderResponse,
        this.editPurchaseOrderError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isLoading: false,
      });
    }
  };
  editPurchaseOrderResponse = (response) => {
    let dependenciesBean = null;
    if (response.data.dependenciesResponse != null) {
      dependenciesBean = response.data.dependenciesResponse.dependenciesBean;
    }
    if (response.data.lockResponse != null) {
      if (!isEmpty(response.data.lockResponse.errors)) {
        this.showErrorMessage(response.data.lockResponse);
        this.state.isViewMode = true;
      }
    }
    if (response.data.purchaseOrderResponse != null) {
      let poBean = response.data.purchaseOrderResponse.purchaseOrder;
     
      if(poBean.orderStatus == LogicConstants.PURCHASE_ORDER_APPROVE_STATUS || poBean.orderStatus == LogicConstants.PURCHASE_ORDER_UNAPPROVE_STATUS ){
      
        this.setState({
            isVendorInvoiceShow:false
          })
      }else{
         this.setState({
            isVendorInvoiceShow:true
          })
      }
      if (poBean != null) {
        let logisticData = this.state.logisticData;
        if (
          poBean.currentLogisticsPlanUpdate != null &&
          poBean.logisticsPlanUpdates != null
        ) {
          poBean.currentLogisticsPlanUpdate.fetched = false;
          poBean.currentLogisticsPlanUpdate.isFetched = false;

          logisticData = poBean.currentLogisticsPlanUpdate;
        }
        if (poBean.shippingAddress === null) {
          poBean.shippingAddress = new AddressBean();
        }
        let pageTitle = this.moduleCaption + " - EDIT";
        let moduleKeyCode = poBean.code;

        if (
          !isEmptyArray(
            response.data.purchaseOrderResponse.purchaseOrder.orderImages,
          )
        ) {
          const imagesList =
            response.data.purchaseOrderResponse.purchaseOrder.orderImages;
          let url = this.getImageURL();
          let url_list = [];
          imagesList.map((urlIndex) => {
            let imgUrl = url + urlIndex.imageName;

            url_list.push(imgUrl);
          });
          this.setState({
            preview_Url: url_list,
            images: imagesList,
          });
        } else {
          this.setState({
            imgUrl: "",
            images: [],
            preview_Url: [],
          });
        }

        if (!isEmptyArray(poBean.purchaseOrderDocuments)) {
          const preview_Docs = poBean.purchaseOrderDocuments;
          let url = this.getDocURL();
          let urlDoc_list = [];
          preview_Docs.map((urlIndex) => {
            urlDoc_list.push(url + urlIndex.documentName);
          });
          this.setState({
            documents: preview_Docs,
            preview_Docs: urlDoc_list,
          });
        } else {
          this.setState({
            preview_Docs: [],
            documents: [],
          });
        }

        this.setState(
          {
            purchaseOrderData: poBean,
            poLinesList: poBean.lines,
            pageTitle: pageTitle,
            isNewPurchaseOrderLineAdded: true,
            isEditedPurchaseOrder: true,
            dependenciesBean: dependenciesBean,
            isFocusLookup: false,
            isFocus: true,
            moduleKeyCode: moduleKeyCode,
            isLoading: false,

            logisticData: logisticData,
            selectedNodeKey: "headerView",
          },
          () => {
            this.openEntryForm();
          },
        );
        this.isLocked = true;
        this.getNodeList();
        // this.openEntryForm();
        this.readCustomer(poBean.customerCode);
      } else {
        this.addNewEntry();
      }
    }
    this.setState({
      isLoading: false,
    });
  };
  editPurchaseOrderError = (error) => {
    ShowError("Error :", error);
    this.setState({
      isLoading: false,
    });
  };
  generatePDF = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating PDF",
    });
    this.downloadReport(1, this.state.purchaseOrderData.code);
  };
  generateExcel = (e) => {
    if (e.detail == 1) {
      this.setState({
        isLoading: true,
        loadingText: "Generating Excel",
      });
      this.downloadReport(2, this.state.purchaseOrderData.code);
    }
  };
  downloadReportResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
  };
  downloadReportError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  downloadReport = (reportType, code) => {
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let requestInput = new PurchaseOrderPrintRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.purchaseOrderNumber = code;
    requestInput.reportBean = reportBean;
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.PurchaseOrderMaintenancePDFReport_IsAccessible()
      ) {
        ReportService.generatePurchaseOrderPrintReport(
          requestInput,
          this.downloadReportResponse,
          this.downloadReportError,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.PurchaseOrderMaintenanceExcelReport_IsAccessible()
      ) {
        ReportService.generatePurchaseOrderPrintReport(
          requestInput,
          this.downloadReportResponse,
          this.downloadReportError,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  sendPOMail = (e) => {
    if (e.detail == 1) {
      this.setState({
        isLoading: true,
        loadingText: "Sending Mail",
      });
      let purchaseOrderData = this.state.purchaseOrderData;
      let request = new RestReadRequest();
      request.companyCode = this.companyCode;
      request.code = purchaseOrderData.code;
      if (SecurityAccessManager.PurchaseOrderMaintenance_IsAccessible()) {
        PurchaseOrderService.fetchPurchaseOrderMailDefaultInfoBean(
          request,
          this.mailInvoiceResponse,
          this.mailInvoiceError,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  mailInvoiceResponse = (response) => {
    if (!isEmpty(response.data.mailDefaultInfo)) {
      let mailInfo = response.data.mailDefaultInfo;
      this.setState({
        mailInfoData: mailInfo,
        isShowMailInvoicePopup: true,
        isLoading: false,
        loadingText: "",
      });
    }
  };
  mailInvoiceError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  mailInvoiceContinue = (e) => {
    if (e.detail == 1) {
      let request = new RestInvoiceMailInfoBeanRequest();
      let reportData = new RestReportBean();
      let mailInfoData = this.state.mailInfoData;
      reportData.reportType = 1;
      let purchaseOrderData = this.state.purchaseOrderData;
      request.companyCode = this.companyCode;
      request.code = purchaseOrderData.code;
      request.inputReportBean = reportData;
      request.infoBean = mailInfoData;
      if (
        SecurityAccessManager.PurchaseOrderMaintenanceSendMailReport_IsAccessible()
      ) {
        PurchaseOrderService.sendPurchaseOrderMail(
          request,
          this.mailInvoiceContinueResponse,
          this.mailInvoiceContinueError,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  mailInvoiceContinueResponse = (response) => {
    this.closeAlertModalCallBack(false);
  };
  mailInvoiceContinueError = (error) => {};
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowMailInvoicePopup: isShowPopup,
      isShowCopyPOPopup: isShowPopup,
    });
  };
  approveAndPrintPO = (e) => {
    if (e.detail == 1) {
      this.setState({
        isLoading: true,
        loadingText: "Approving & Printing PO",
      });
      let purchaseOrderData = this.state.purchaseOrderData;
      let isValidData = false;
      isValidData = this.validatePurchaseData(purchaseOrderData);
      let request = new RestPurchaseOrderBeanRequest();
      let reportData = new RestReportBean();
      reportData.reportType = 1;
      request.purchaseOrderBean = this.state.purchaseOrderData;
      if (purchaseOrderData.isFetched) {
        request.isLockReleaseRequired = true;
      } else {
        request.isLockReleaseRequired = false;
      }
      request.inputReportBean = reportData;
      if (isValidData) {
        if (purchaseOrderData.isFetched) {
          if (
            SecurityAccessManager.PurchaseOrderMaintenanceEdit_IsAccessible()
          ) {
            PurchaseOrderService.updateAndApprovePurchaseOrderThenGeneratePurchaseOrderReport(
              request,
              this.approveAndPrintPOResponse,
              this.approveAndPrintPOError,
            );
          } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);
            this.setState({
              alertMessage: errList,
              alertType: "danger",
              isShowAlert: true,
            });
          }
        } else {
          if (
            SecurityAccessManager.PurchaseOrderMaintenanceCreate_IsAccessible()
          ) {
            PurchaseOrderService.createAndApprovePurchaseOrderThenGeneratePurchaseOrderReport(
              request,
              this.approveAndPrintPOResponse,
              this.approveAndPrintPOError,
            );
          } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);
            this.setState({
              alertMessage: errList,
              alertType: "danger",
              isShowAlert: true,
            });
          }
        }
      } else {
        this.setState({
          isLoading: false,
          loadingText: "",
        });
      }
    }
  };
  approveAndPrintPOResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    if (response.data != null && response.data.mainOperationResponse != null) {
      const purchaseOrderBean =
        response.data.mainOperationResponse.purchaseOrder;
      this.handleResponse(response.data.mainOperationResponse);
      if (purchaseOrderBean != null) {
        let pageTitle = this.moduleCaption + " - EDIT";
        this.setState({
          purchaseOrderData: purchaseOrderBean,
          pageTitle: pageTitle,
        });
        this.editPurchaseOrder(purchaseOrderBean.code);
      }
      this.downloadApproveReportResponse(response);
    }
  };
  approveAndPrintPOError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  copyPO = (e) => {
    if (e.detail == 1) {
      this.setState({
        isShowCopyPOPopup: true,
        copyPoCode: "",
      });
    }
  };
  downloadApproveReportResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.reportResult != null &&
      response.data.reportResult.reportResult != null
    ) {
      if (
        !isEmptyString(response.data.reportResult.reportResult.reportFileID)
      ) {
        let reportFilePath =
          response.data.reportResult.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    // this.handleResponse(response.data);
    // if(response.data != null && response.data.reportResult != null && response.data.reportResult.reportResult != null){
    // let reportFilePath = response.data.reportResult.reportResult.reportFileID;
    // // this.handleResponse(response.data.reportResult);
    // window.open(this.report_url + reportFilePath);
    // }
  };
  addressOnChange = (e) => {
    let tempPurchaseOrderData = this.state.purchaseOrderData;
    tempPurchaseOrderData[e.target.label] = e.target.value;
    this.setState({
      purchaseOrderData: tempPurchaseOrderData,
    });
  };
  onChange = (e) => {
    let val = e.target.name;
    let tempPurchaseOrderData = this.state.purchaseOrderData;
    tempPurchaseOrderData[val] =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ purchaseOrderData: tempPurchaseOrderData });
    if (
      val == "miscellaneousCharge" ||
      val == "shipmentChargesAmount" ||
      val == "extraCharge"
    ) {
      this.calculatePurchaseOrderAmounts();
    }
  };
  calculatePurchaseOrderAmounts = () => {
    let purchaseOrderData = this.state.purchaseOrderData;
    if (purchaseOrderData) {
      let subTotalAmount = 0;
      if (
        purchaseOrderData.lines != null &&
        purchaseOrderData.lines != "undefined"
      ) {
        purchaseOrderData.lines.map((line) => {
          subTotalAmount = subTotalAmount + parseFloat(line.lineTotalAmount);
        });
      }
      // let grandTotalAmount =
      //   subTotalAmount + Number(purchaseOrderData.miscellaneousCharge);
      // grandTotalAmount =
      //   Number(grandTotalAmount) + Number(purchaseOrderData.extraCharge);
      // grandTotalAmount =
      //   Number(grandTotalAmount) - Number(purchaseOrderData.discountAmount);
      // purchaseOrderData.orderSubTotal = subTotalAmount;
      // purchaseOrderData.grandTotalAmount = grandTotalAmount;
      let grandTotalAmount =
        subTotalAmount + parseFloat(purchaseOrderData.miscellaneousCharge);
      grandTotalAmount =
        parseFloat(grandTotalAmount) +
        parseFloat(purchaseOrderData.extraCharge);
      grandTotalAmount =
        parseFloat(grandTotalAmount) -
        parseFloat(purchaseOrderData.discountAmount);
      purchaseOrderData.orderSubTotal = subTotalAmount;
      purchaseOrderData.grandTotalAmount =
        parseFloat(grandTotalAmount).toFixed(2);
      this.setState({
        purchaseOrderData: purchaseOrderData,
      });
    }
  };
  onDateChange = (e) => {
    let purchaseOrderData = this.state.purchaseOrderData;
    purchaseOrderData[e.target.name] = e.target.value;
    let lines = purchaseOrderData.lines;
    if (lines) {
      lines.map((line) => {
        line.orderStartDate = purchaseOrderData.orderStartDate;
        line.orderStopDate = purchaseOrderData.orderStopDate;
        // line.cutDate = purchaseOrderData.orderStopDate;
      });
      purchaseOrderData.lines = lines;
    }
    this.setState({ purchaseOrderData: purchaseOrderData });
  };
  onLogisticOnChange = (e) => {
    let logisticData = this.state.logisticData;
    logisticData[e.target.name] = e.target.value;
    this.setState({ logisticData: logisticData });
  };
  onShipViaCodeChange = (e) => {
    let shipViaCode = e.target.value;
    this.state.showAutoCompleteShipViaList = true;
    let tempPurchaseOrderData = this.state.purchaseOrderData;
    let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
    if (isEmpty(shipViaCode)) {
      this.state.showAutoCompleteShipViaList = false;
      let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
      let tempPurchaseOrderData = this.state.purchaseOrderData;
      tempPurchaseOrderData.shipViaCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        purchaseOrderData: tempPurchaseOrderData,
        shipViaPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && shipViaCode !== "") {
      this.readShipViaBySearchString(shipViaCode);
    }
    if (e.target.name == "shipViaCode") {
      tempPurchaseOrderData[e.target.name] = e.target.value;
      let shipViaList = this.state.shipVias;
      shipViaList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          tempPurchaseOrderData["shipViaCode"] = pdtType.code;
          this.state.showAutoCompleteShipViaList = false;
          let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
          this.setState({ showAutoCompleteShipViaList: showAutoCompleteList });
        }
      });
    }
    this.setState({
      purchaseOrderData: tempPurchaseOrderData,
    });
  };
  readShipViaBySearchString(searchString) {
    let shipViaData = this.state.shipVias;
    let simpleAutoCompleteList = new Array();
    if (shipViaData.length > 0 && shipViaData != null) {
      shipViaData.map((shipVias) => {
        let simpleItemBean = {
          code: shipVias.code,
          description: shipVias.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteShipViaLists) =>
        simpleAutoCompleteShipViaLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ shipViaPageListForAutoCompleteList: filteredSuggestions });
  }
  shipViaEnterKeyEventHandler = (e) => {
    let purchaseOrderData = this.state.purchaseOrderData;
    purchaseOrderData["shipViaCode"] = e.target.value;
    let shipViaList = this.state.shipVias;
    let shipViaBean = null;
    shipViaList.map((ship) => {
      if (ship.code == e.target.value) {
        shipViaBean = ship;
      }
    });
    if (!isEmpty(shipViaBean)) {
      purchaseOrderData.shipViaCode = shipViaBean.code;

      this.setState({
        purchaseOrderData: purchaseOrderData,
        shipViaPageListForAutoCompleteList: new Array(),
      });
    }
  };
  onVendorTermChange = (e) => {
    let vendorTerm = e.target.value;
    this.state.showAutoCompleteVendorTermList = true;
    let tempPurchaseOrderData = this.state.purchaseOrderData;
    let showAutoCompleteList = this.state.showAutoCompleteVendorTermList;
    if (isEmpty(vendorTerm)) {
      this.state.showAutoCompleteVendorTermList = false;
      let showAutoCompleteList = this.state.showAutoCompleteVendorTermList;
      let tempPurchaseOrderData = this.state.purchaseOrderData;
      tempPurchaseOrderData.buyingTermsCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        purchaseOrderData: tempPurchaseOrderData,
        vendorTermPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && vendorTerm !== "") {
      this.readVendorTermBySearchString(vendorTerm);
    }
    if (e.target.name == "buyingTermsCode") {
      tempPurchaseOrderData[e.target.name] = e.target.value;
      let buyingTermsCodeList = this.state.vendorTerms;
      buyingTermsCodeList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          tempPurchaseOrderData["buyingTermsCode"] = pdtType.code;
          this.state.showAutoCompleteVendorTermList = false;
          let showAutoCompleteList = this.state.showAutoCompleteVendorTermList;
          this.setState({
            showAutoCompleteVendorTermList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({
      purchaseOrderData: tempPurchaseOrderData,
    });
  };
  readVendorTermBySearchString(searchString) {
    let vendorTermData = this.state.vendorTerms;
    let simpleAutoCompleteList = new Array();
    if (vendorTermData.length > 0 && vendorTermData != null) {
      vendorTermData.map((vendorTerms) => {
        let simpleItemBean = {
          code: vendorTerms.code,
          description: vendorTerms.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteVendorTermLists) =>
        simpleAutoCompleteVendorTermLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      vendorTermPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  vendorTermEnterKeyEventHandler = (e) => {
    let purchaseOrderData = this.state.purchaseOrderData;
    purchaseOrderData["buyingTermsCode"] = e.target.value;
    let vendorTermList = this.state.vendorTerms;
    let vendorTermBean = null;
    vendorTermList.map((vt) => {
      if (vt.code == e.target.value) {
        vendorTermBean = vt;
      }
    });
    if (!isEmpty(vendorTermBean)) {
      purchaseOrderData.buyingTermsCode = vendorTermBean.code;

      this.setState({
        purchaseOrderData: purchaseOrderData,
        vendorTermPageListForAutoCompleteList: new Array(),
      });
    }
  };
  onShipmentTermChange = (e) => {
    let shipmentTerm = e.target.value;
    this.state.showAutoCompleteShipmentTermList = true;
    let tempPurchaseOrderData = this.state.purchaseOrderData;
    let showAutoCompleteList = this.state.showAutoCompleteShipmentTermList;
    if (isEmpty(shipmentTerm)) {
      this.state.showAutoCompleteShipmentTermList = false;
      let showAutoCompleteList = this.state.showAutoCompleteShipmentTermList;
      let tempPurchaseOrderData = this.state.purchaseOrderData;
      tempPurchaseOrderData.shipmentTermsCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        purchaseOrderData: tempPurchaseOrderData,
        shipmentTermPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && shipmentTerm !== "") {
      this.readShipmentTermBySearchString(shipmentTerm);
    }
    if (e.target.name == "shipmentTermsCode") {
      tempPurchaseOrderData[e.target.name] = e.target.value;
      let shipmentTermsCodeList = this.state.shipmentTerms;
      shipmentTermsCodeList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          tempPurchaseOrderData["shipmentTermsCode"] = pdtType.code;
          this.state.showAutoCompleteShipmentTermList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteShipmentTermList;
          this.setState({
            showAutoCompleteShipmentTermList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({
      purchaseOrderData: tempPurchaseOrderData,
    });
  };
  readShipmentTermBySearchString(searchString) {
    let shipmentTermData = this.state.shipmentTerms;
    let simpleAutoCompleteList = new Array();
    if (shipmentTermData.length > 0 && shipmentTermData != null) {
      shipmentTermData.map((shipmentTerms) => {
        let simpleItemBean = {
          code: shipmentTerms.code,
          description: shipmentTerms.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteShipmentTermLists) =>
        simpleAutoCompleteShipmentTermLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      shipmentTermPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  shipmentTermEnterKeyEventHandler = (e) => {
    let purchaseOrderData = this.state.purchaseOrderData;
    purchaseOrderData["shipmentTermsCode"] = e.target.value;
    let shipmentTermList = this.state.shipmentTerms;
    let shipmentTermBean = null;
    shipmentTermList.map((ship) => {
      if (ship.code == e.target.value) {
        shipmentTermBean = ship;
      }
    });
    if (!isEmpty(shipmentTermBean)) {
      purchaseOrderData.shipmentTermsCode = shipmentTermBean.code;

      this.setState({
        purchaseOrderData: purchaseOrderData,
        shipmentTermPageListForAutoCompleteList: new Array(),
      });
    }
  };
  onLocationChange = (e) => {
    let location = e.target.value;
    this.state.showAutoCompleteLocationList = true;
    let tempPurchaseOrderData = this.state.purchaseOrderData;
    let showAutoCompleteList = this.state.showAutoCompleteLocationList;
    if (isEmpty(location)) {
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      let tempPurchaseOrderData = this.state.purchaseOrderData;
      tempPurchaseOrderData.locationCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        purchaseOrderData: tempPurchaseOrderData,
        locationPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && location !== "") {
      this.readLocationBySearchString(location);
    }
    if (e.target.name == "locationCode") {
      tempPurchaseOrderData[e.target.name] = e.target.value;
      let locationCodeList = this.state.wareHouses;
      locationCodeList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          tempPurchaseOrderData["locationCode"] = pdtType.code;
          this.state.showAutoCompleteLocationList = false;
          let showAutoCompleteList = this.state.showAutoCompleteLocationList;
          this.setState({ showAutoCompleteLocationList: showAutoCompleteList });
        }
      });
    }
    this.setState({
      purchaseOrderData: tempPurchaseOrderData,
    });
  };
  readLocationBySearchString(searchString) {
    let locationData = this.state.wareHouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((locations) => {
        let simpleItemBean = {
          code: locations.code,
          description: locations.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ locationPageListForAutoCompleteList: filteredSuggestions });
  }
  locationEnterKeyEventHandler = (e) => {
    let purchaseOrderData = this.state.purchaseOrderData;
    purchaseOrderData["locationCode"] = e.target.value;
    let locationList = this.state.wareHouses;
    let locationBean = null;
    locationList.map((lc) => {
      if (lc.code == e.target.value) {
        locationBean = lc;
      }
    });
    if (!isEmpty(locationBean)) {
      purchaseOrderData.locationCode = locationBean.code;

      this.setState({
        purchaseOrderData: purchaseOrderData,
        locationPageListForAutoCompleteList: new Array(),
      });
    }
  };
  onFOBChange = (e) => {
    let fob = e.target.value;
    this.state.showAutoCompleteFOBList = true;
    let tempPurchaseOrderData = this.state.purchaseOrderData;
    let showAutoCompleteList = this.state.showAutoCompleteFOBList;
    if (isEmpty(fob)) {
      this.state.showAutoCompleteFOBList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFOBList;
      let tempPurchaseOrderData = this.state.purchaseOrderData;
      tempPurchaseOrderData.fOBCity = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        purchaseOrderData: tempPurchaseOrderData,
        fobPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && fob !== "") {
      this.readFOBBySearchString(fob);
    }
    if (e.target.name == "fOBCity") {
      tempPurchaseOrderData[e.target.name] = e.target.value;
      let fOBCityList = this.state.fOBCities;
      fOBCityList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          tempPurchaseOrderData["fOBCity"] = pdtType.code;
          this.state.showAutoCompleteFOBList = false;
          let showAutoCompleteList = this.state.showAutoCompleteFOBList;
          this.setState({ showAutoCompleteFOBList: showAutoCompleteList });
        }
      });
    }
    this.setState({
      purchaseOrderData: tempPurchaseOrderData,
    });
  };
  readFOBBySearchString(searchString) {
    let fobData = this.state.fOBCities;
    let simpleAutoCompleteList = new Array();
    if (fobData.length > 0 && fobData != null) {
      fobData.map((fobs) => {
        let simpleItemBean = { code: fobs.code, description: fobs.description };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteFOBLists) =>
        simpleAutoCompleteFOBLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ fobPageListForAutoCompleteList: filteredSuggestions });
  }
  fobEnterKeyEventHandler = (e) => {
    let purchaseOrderData = this.state.purchaseOrderData;
    purchaseOrderData["fOBCity"] = e.target.value;
    let fobList = this.state.fOBCities;
    let fobBean = null;
    fobList.map((fb) => {
      if (fb.code == e.target.value) {
        fobBean = fb;
      }
    });
    if (!isEmpty(fobBean)) {
      purchaseOrderData.fOBCity = fobBean.code;

      this.setState({
        purchaseOrderData: purchaseOrderData,
        fobPageListForAutoCompleteList: new Array(),
      });
    }
  };
  onVendorCodeChange = (e) => {
    let vendorCode = e.target.value;
    let tempPurchaseOrderData = this.state.purchaseOrderData;
    tempPurchaseOrderData[e.target.name] = e.target.value;
    let showAutoCompleteList = this.state.showAutoCompleteList;
    this.state.showAutoCompleteList = true;
    if (isEmpty(vendorCode)) {
      this.state.showAutoCompleteList = false;
      let showAutoCompleteList = this.state.showAutoCompleteList;
      let purchaseOrderData = this.state.purchaseOrderData;
      purchaseOrderData.vendorCode = "";
      purchaseOrderData.vendorName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        purchaseOrderData: purchaseOrderData,
        vendorPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "vendorCode" &&
      showAutoCompleteList === true &&
      vendorCode !== ""
    ) {
      this.state.showAutoCompleteList = true;
      this.readVendorBySearchString(e.target.value);
    }
    if (e.target.name == "vendorCode") {
      tempPurchaseOrderData["vendorCode"] = e.target.value;
      let vendor_List = this.state.vendor_List;
      vendor_List.map((vendor) => {
        if (
          vendor.code == e.target.value ||
          vendor.description == e.target.value
        ) {
          tempPurchaseOrderData["vendorCode"] = vendor.code;
          this.state.showAutoCompleteList = false;
          let showAutoCompleteList = this.state.showAutoCompleteList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
          // this.setVendorDetails(vendor);
        }
      });
    }
    this.setState({
      purchaseOrderData: tempPurchaseOrderData,
    });
  };
  readVendorBySearchString(searchString) {
    let searchCriteria = new VendorSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.vendorCodeStartsWith = searchString;
    searchCriteria.vendorNameContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestVendorListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    VendorService.getVendorPageList(
      input,
      this.readByVendorCodeResponse,
      this.readByVendorCodeResponseError,
    );
  }
  readByVendorCodeResponse = (response) => {
    let vendorCodeData = response.data.vendorPageList.vendors;
    let simpleAutoCompleteList = new Array();
    if (vendorCodeData.length > 0 && vendorCodeData != null) {
      vendorCodeData.map((vendorCode) => {
        let simpleItemBean = {
          code: vendorCode.code,
          description: vendorCode.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      vendorPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readByVendorCodeResponseError = (error) => {
    ShowError("Error : ", error);
  };
  displayAutoCompleteLocationList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteLocationList: showAutoCompleteList });
  };
  displayAutoCompleteShipmentTermList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteShipmentTermList: showAutoCompleteList });
  };
  displayAutoCompleteVendorTermList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteVendorTermList: showAutoCompleteList });
  };
  displayAutoCompleteFobList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFOBList: showAutoCompleteList });
  };
  displayAutoCompleteShipViaList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteShipViaList: showAutoCompleteList });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  displayAutoCompleteColourList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteColourList: showAutoCompleteList });
  };
  vendorCodeEnterKeyEventHandler = (e) => {
    let tempPurchaseOrderData = this.state.purchaseOrderData;
    tempPurchaseOrderData[e.target.name] = e.target.value;
    tempPurchaseOrderData["vendorCode"] = e.target.value;
    let vendor_List = this.state.vendor_List;
    vendor_List.map((vendor) => {
      if (
        vendor.code == e.target.value ||
        vendor.description == e.target.value
      ) {
        tempPurchaseOrderData["vendorCode"] = vendor.code;
        tempPurchaseOrderData["vendorName"] = vendor.description;
        this.setVendorDetails(vendor);
      }
    });
    this.setState({ vendorPageListForAutoCompleteList: new Array() });
  };
  onLineChange = (e, row) => {
    let tempLineData = { ...this.state.purchaseOrderLineData };

    tempLineData[e.target.name] =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;

    let orderQuantity = parseFloat(tempLineData.orderQuantity) || 0;
    let cost = parseFloat(tempLineData.cost) || 0;

    tempLineData.lineTotalAmount = (orderQuantity * cost).toFixed(2);

    if (e.target.name === "orderQuantity" || e.target.name === "cost") {
      this.calculatePurchaseOrderAmounts();
    }

    if (e.target.name === "fabricStyleCode") {
      tempLineData["fabricStyleCode"] = e.target.value;
    }

    if (e.target.name === "colorCode") {
      this.fabricStyleColorSelected(e.target.value);
    }

    this.setState({ purchaseOrderLineData: tempLineData });
  };

  authClick = (e) => {
    if (e.detail === 1) {
      this.setState({
        isAuthenticationPopup: true,
        authenticationPassword: "",
        isShowPriceChangable: false,
      });
    }
  };
  priceOncontinue = (e) => {
    if (this.state.modifyCost > 0) {
      let purchaseOrderLineData = { ...this.state.purchaseOrderLineData };
      purchaseOrderLineData.cost = this.state.modifyCost;
      this.setState({
        purchaseOrderLineData: purchaseOrderLineData,
        isAuthenticationPopup: false,
        purchaseOrderLineData: purchaseOrderLineData,
        modifyCost: 0,
        authenticationPassword: "",
        isModifyCostCalculation: true,
      });
    } else {
      let errMsg = "Cost Required";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlertLvl1: true,
      });
    }
  };
  checkAuthentication = (e) => {
    if (e.detail === 1) {
      let authenticationPassword = this.state.authenticationPassword;
      if (authenticationPassword === ConfigManager.getCostChangeCode()) {
        this.setState({
          isShowPriceChangable: true,
        });
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlertLvl1: true,
        });
      }
    }
  };
  clearAuthetication = (e) => {
    if (e.detail === 1) {
      let authentication = "";
      this.setState({ authenticationPassword: authentication });
    }
  };
  hideAlertCallBackLvl1 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl1: isDisplayed, error_list: [] });
  };
  authOnChange = (e) => {
    let authenticationPassword = this.state.authenticationPassword;
    authenticationPassword = e.target.value;
    this.setState({ authenticationPassword: authenticationPassword });
  };
  costOnChange = (e) => {
    let modifyCost = this.state.modifyCost;
    modifyCost = e.target.value;
    this.setState({ modifyCost: modifyCost });
  };
  onFabricCodeChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempLineData = this.state.purchaseOrderLineData;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let poLine = this.state.purchaseOrderLineData;
      poLine.fabricStyleCode = "";
      poLine.fabricStyleName = "";
      poLine.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        purchaseOrderLineData: poLine,
        fabricPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempLineData[e.target.name] = e.target.value;
    this.setState({ purchaseOrderLineData: tempLineData });
    // this.readSelectedFabricStyle(fabricStyleCode);
  };
  fabricCodeEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.readSelectedFabricStyle(fabricStyleCode);
    this.setState({
      fabricPageListForAutoCompleteList: new Array(),
      fabricStyleCode: fabricStyleCode,
    });
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading FabricStyle...",
    });
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.readByFabricCodeResponseError,
    );
  }
  readByFabricCodeResponse = (response) => {
    let purchaseOrderData = this.state.purchaseOrderData;
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData = fabricStyleData.filter((item) => item.isActive);
      fabricStyleData.map((fabricStyle) => {
        if (this.state.is3PL) {
          if (fabricStyle.customerCode == purchaseOrderData.customerCode) {
            let simpleItemBean = {
              code: fabricStyle.fabricStyleCode,
              description: fabricStyle.fabricStyleName,
            };
            simpleAutoCompleteList.push(simpleItemBean);
          }
        } else {
          let simpleItemBean = {
            code: fabricStyle.fabricStyleCode,
            description: fabricStyle.fabricStyleName,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        }
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readByFabricCodeResponseError = (error) => {
    ShowError("Error : ", error);
  };
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(e.target.value);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  onFabricColourCodeChange = (e) => {
    this.setState({
      fabricStyleColorCode: "",
      isAllowReadColor: false,
    });
    this.state.showAutoCompleteColourList = true;
    let colorCode = e.target.value;

    let showAutoCompleteList = this.state.showAutoCompleteColourList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteColourList = false;
      let showAutoCompleteList = this.state.showAutoCompleteColourList;
      let poLine = this.state.purchaseOrderLineData;
      poLine.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        salesOrderLineData: poLine,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && colorCode !== "") {
      this.readFabricColourBySearchString(e.target.value);
    }
    this.fabricStyleColorSelected(e.target.value);
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.currentFabricStyle;
    let poLine = this.state.purchaseOrderLineData;
    let skuBean = new FabricStyleSKUBean();
    fabricStyle.fabricStyleSkus.map((sku) => {
      if (
        sku.fabricStyleCode == poLine.fabricStyleCode &&
        sku.fabricStyleColorCode == searchString
      )
        skuBean = sku;
    });
    poLine.colorCode = searchString;
    let colors = fabricStyle.colors;
    let finalColorList = [];
    colors.map((ent) => {
      if (ent.isActive) {
        let colorBean = new BaseBean();
        colorBean.code = ent.fabricStyleColorCode;
        colorBean.description = ent.fabricStyleColorName;
        finalColorList.push(colorBean);
      }
    });
    let simpleAutoCompleteColorList = new Array();
    finalColorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.currentFabricStyle;
    let poLine = this.state.purchaseOrderLineData;
    let skuBean = new FabricStyleSKUBean();
    fabricStyle.fabricStyleSkus.map((sku) => {
      if (
        sku.fabricStyleCode == poLine.fabricStyleCode &&
        sku.fabricStyleColorCode == colorCode
      )
        skuBean = sku;
    });
    poLine.colorCode = colorCode;
    if (!isEmpty(skuBean)) {
      poLine.skuNumber = skuBean.skuNumber;
      poLine.uomCode = skuBean.uomCode;
    }
    this.state.purchaseOrderLineData = poLine;
    this.setState({ purchaseOrderLineData: poLine });
  };
  readSelectedFabricStyle = (fabricStyleCode) => {
    let requestInput = new RestReadRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.code = fabricStyleCode;
    requestInput.lockRequired = false;
    requestInput.loadChildren = true;
    if (SecurityAccessManager.PurchaseOrderMaintenance_IsAccessible) {
      FabricStyleService.readFabricStyle(
        requestInput,
        this.readFabricStyleResponse,
        this.readFabricStyleError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readFabricStyleResponse = (response) => {
    let fabricStyleBean = response.data.fabricStyle;
    let poLine = this.state.purchaseOrderLineData;
    let currentFabricStyleSkuList = new Array();
    if (fabricStyleBean != null) {
      if (fabricStyleBean.fabricStyleSkus) {
        fabricStyleBean.fabricStyleSkus.map((sku) => {
          currentFabricStyleSkuList.push(sku);
        });
        poLine.fabricStyleCode = "";
        poLine.fabricStyleName = "";
        // poLine.colorCode = "";
      }
      if (this.vendorStyleRef.current != null) {
        this.vendorStyleRef.current.focus();
      }
      // this.state.currentFabricStyle = fabricStyleBean;
      // this.state.currentFabricStyleSkuList = currentFabricStyleSkuList;
      this.setState(
        {
          currentFabricStyle: fabricStyleBean,
          currentFabricStyleSkuList: currentFabricStyleSkuList,
          isShowColorLookup: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        },
        () => {
          this.setFabricStyleDefaultValues(fabricStyleBean);
        },
      );
    }
  };
  readFabricStyleError = (error) => {
    ShowError("Error : ", error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  setFabricStyleDefaultValues = (tempCurrentFabricStyle) => {
    // let tempCurrentFabricStyle = this.state.currentFabricStyle;
    let tempCurrentFabricStyleSku = this.state.currentFabricStyleSku;
    let purchaseOrderLineData = this.state.purchaseOrderLineData;
    let purchaseOrderData = this.state.purchaseOrderData;
    purchaseOrderLineData.fabricStyleCode = tempCurrentFabricStyle.code;
    purchaseOrderLineData.fabricStyleName = tempCurrentFabricStyle.description;
    if (tempCurrentFabricStyle.defaultLocationCode != null) {
      purchaseOrderLineData.locationCode =
        tempCurrentFabricStyle.defaultLocationCode;
    } else {
      purchaseOrderLineData.locationCode =
        ConfigManager.isDefaultWarehouse() || DEFAULT_WAREHOUSE;
      //purchaseOrderLineData.locationCode = DEFAULT_WAREHOUSE;
    }
    purchaseOrderLineData.cost = tempCurrentFabricStyle.standardCost;
    // purchaseOrderLineData.widthCode = tempCurrentFabricStyle.width;
    if (this.colorCodeRef.current != null) {
      this.colorCodeRef.current.focus();
    }
    if (this.state.is3PL) purchaseOrderLineData.widthCode = DEMO_VALUE;
    else purchaseOrderLineData.widthCode = tempCurrentFabricStyle.width;
    purchaseOrderLineData.lineStatus =
      LogicConstants.PURCHASE_ORDER_LINE_OPEN_STATUS;
    purchaseOrderLineData.uomConversionRate = 1;
    purchaseOrderLineData.inventoryUomCode =
      tempCurrentFabricStyle.inventoryUomCode;
    let colors = tempCurrentFabricStyle.colors;

    let isShowColorLookup = true;
    let finalColorList = [];
    let colorLookupHandler = null;
    if (!isEmpty(colors)) {
      if (colors.length == 1) {
        if (colors[0].isActive) {
          purchaseOrderLineData.colorCode = colors[0].fabricStyleColorCode;
          this.fabricStyleColorSelected(purchaseOrderLineData.colorCode);
          isShowColorLookup = false;
        }
      } else {
        colors.map((ent) => {
          if (ent.isActive) {
            let colorBean = new BaseBean();
            colorBean.code = ent.fabricStyleColorCode;
            colorBean.description = ent.fabricStyleColorName;
            finalColorList.push(colorBean);
          }
        });
      }
    }

    if (finalColorList != null) {
      colorLookupHandler = new GenericAttributeLookupHandler(
        finalColorList,
        "Color",
      );
    }
    this.setState(
      {
        purchaseOrderLineData: purchaseOrderLineData,
        purchaseOrderData: purchaseOrderData,
        colorLookupHandler: colorLookupHandler,
        isShowColorLookup: isShowColorLookup,
      },
      () => {
        if (tempCurrentFabricStyle.colors.length === 1) {
          if (this.vendorStyleRef.current) {
            this.vendorStyleRef.current.focus();
          }
        }
      },
    );
  };
  nodeOnSelect = (selectedNode) => {
    this.setState({ selectedNodeKey: selectedNode });
    if (selectedNode == "headerView") {
      this.setPurchaseOrderHeaderView();
    } else if (selectedNode == "orderDetailView") {
      this.setPurchaseOrderDetailView();
    } else if (selectedNode == "orderHistoryView") {
      this.setPurchaseOrderHistoryView();
    } else if (selectedNode == "orderReceiptView") {
      this.setPurchaseOrderReceiptView();
    } else if (selectedNode == "orderImageView") {
      this.setPurchaseOrderImageView();
    } else if (selectedNode == "orderDocumentView") {
      this.setPurchaseOrderDocumentView();
    } else if (selectedNode == "paymentDetailView") {
      this.setPaymentDetailView();
    }
    //  else if (selectedNode == "orderModelDocumentView") {
    //   this.setPurchaseOrderModelDocumentView();
    // }
  };
  setPurchaseOrderHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isPurchaseOrderListFormOpen: false,
      isPurchaseOrderEntryFormOpen: true,
      isPurchaseReceiptFormOpened: false,
      isPurchaseOrderHistoryFormOpened: false,
      isPurchaseOrderDetailFormOpened: false,
      isPurchaseOrderImageFormOpened: false,
      isPurchaseOrderDocumentFormOpened: false,
      isPurchaseOrderModelDocumentFormOpened: false,
      isPaymentDetailViewOpen: false,
    });
  };
  setPurchaseOrderDetailView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isPurchaseOrderListFormOpen: false,
      isPurchaseOrderEntryFormOpen: false,
      isPurchaseReceiptFormOpened: false,
      isPurchaseOrderHistoryFormOpened: false,
      isPurchaseOrderDetailFormOpened: true,
      isPurchaseOrderImageFormOpened: false,
      isPurchaseOrderModelDocumentFormOpened: false,
      isPurchaseOrderDocumentFormOpened: false,
      isPaymentDetailViewOpen: false,
    });
  };
  setPurchaseOrderHistoryView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isPurchaseOrderListFormOpen: false,
      isPurchaseOrderEntryFormOpen: false,
      isPurchaseReceiptFormOpened: false,
      isPurchaseOrderHistoryFormOpened: true,
      isPurchaseOrderDetailFormOpened: false,
      isPurchaseOrderImageFormOpened: false,
      isPurchaseOrderModelDocumentFormOpened: false,
      isPurchaseOrderDocumentFormOpened: false,
      isPaymentDetailViewOpen: false,
    });
  };
  setPurchaseOrderReceiptView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isPurchaseOrderListFormOpen: false,
      isPurchaseOrderEntryFormOpen: false,
      isPurchaseReceiptFormOpened: true,
      isPurchaseOrderHistoryFormOpened: false,
      isPurchaseOrderDetailFormOpened: false,
      isPurchaseOrderImageFormOpened: false,
      isPurchaseOrderModelDocumentFormOpened: false,
      isPurchaseOrderDocumentFormOpened: false,
      isPaymentDetailViewOpen: false,
    });
  };
  setPurchaseOrderImageView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isPurchaseOrderListFormOpen: false,
      isPurchaseOrderEntryFormOpen: false,
      isPurchaseReceiptFormOpened: false,
      isPurchaseOrderHistoryFormOpened: false,
      isPurchaseOrderDetailFormOpened: false,
      isPurchaseOrderImageFormOpened: true,
      isPurchaseOrderModelDocumentFormOpened: false,
      isPurchaseOrderDocumentFormOpened: false,
      isPaymentDetailViewOpen: false,
    });
  };
  setPurchaseOrderDocumentView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isPurchaseOrderListFormOpen: false,
      isPurchaseOrderEntryFormOpen: false,
      isPurchaseReceiptFormOpened: false,
      isPurchaseOrderHistoryFormOpened: false,
      isPurchaseOrderDetailFormOpened: false,
      isPurchaseOrderImageFormOpened: false,
      isPurchaseOrderModelDocumentFormOpened: false,
      isPurchaseOrderDocumentFormOpened: true,
      isPaymentDetailViewOpen: false,
    });
  };
  setPurchaseOrderModelDocumentView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isPurchaseOrderListFormOpen: false,
      isPurchaseOrderEntryFormOpen: false,
      isPurchaseReceiptFormOpened: false,
      isPurchaseOrderHistoryFormOpened: false,
      isPurchaseOrderDetailFormOpened: false,
      isPurchaseOrderImageFormOpened: false,
      isPurchaseOrderDocumentFormOpened: false,
      isPurchaseOrderModelDocumentFormOpened: true,
      isPaymentDetailViewOpen: false,
    });
  };
  setPaymentDetailView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isPurchaseOrderListFormOpen: false,
      isPurchaseOrderEntryFormOpen: false,
      isPurchaseReceiptFormOpened: false,
      isPurchaseOrderHistoryFormOpened: false,
      isPurchaseOrderDetailFormOpened: false,
      isPurchaseOrderImageFormOpened: false,
      isPurchaseOrderDocumentFormOpened: false,
      isPurchaseOrderModelDocumentFormOpened: false,
      isPaymentDetailViewOpen: true,
    });
  };
  savePurchaseOrder = () => {
    this.setState({
      isLoading: true,
      loadingText: "Saving ..",
    });
    let poBean = this.state.purchaseOrderData;
    let logisticData = this.state.logisticData;
    let isValidData = false;
    isValidData = this.validatePurchaseData(poBean);

    if (this.state.isTexco) {
      poBean.isAllowZeroCostFlag = true;
    }

    if (!poBean.isFetched) {
      poBean.currentLogisticsPlanUpdate = logisticData;
      poBean.logisticsPlanUpdates.push(logisticData);
    }
    if (isValidData) {
      if (poBean.isFetched) {
        if (
          poBean.orderStatus == LogicConstants.PURCHASE_ORDER_UNAPPROVE_STATUS
        ) {
          if (
            SecurityAccessManager.PurchaseOrderMaintenanceEdit_IsAccessible()
          ) {
            PurchaseOrderService.updatePurchaseOrder(
              poBean,
              this.savePurchaseOrderResponse,
              this.savePurchaseOrderError,
            );
          } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);

            this.setState({
              alertMessage: errList,
              alertType: "danger",
              isShowAlert: true,
            });
          }
        } else if (
          poBean.orderStatus == LogicConstants.PURCHASE_ORDER_APPROVE_STATUS ||
          poBean.orderStatus == LogicConstants.PURCHASE_ORDER_PARTIALLY_RECEIVED_STATUS ||
            LogicConstants.PURCHASE_ORDER_RECEIVED_STATUS
        ) {
          if (
            SecurityAccessManager.PurchaseOrderMaintenanceEdit_IsAccessible()
          ) {
            PurchaseOrderService.updatePurchaseOrderAfterApproval(
              poBean,
              this.savePurchaseOrderResponse,
              this.savePurchaseOrderError,
            );
          } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);

            this.setState({
              alertMessage: errList,
              alertType: "danger",
              isShowAlert: true,
            });
          }
        }
      } else {
        if (
          SecurityAccessManager.PurchaseOrderMaintenanceCreate_IsAccessible()
        ) {
          PurchaseOrderService.createPurchaseOrder(
            poBean,
            this.savePurchaseOrderResponse,
            this.savePurchaseOrderError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    } else {
      this.setState({
        isLoading: false,
      });
    }
  };
  savePurchaseOrderResponse = (response) => {
    this.setState({ isLoading: false });

    this.handleResponse(response.data);
    if (response.data != null && response.data.purchaseOrder != null) {
      const purchaseOrderBean = response.data.purchaseOrder;
      if (response.data.success == true) {
        if (purchaseOrderBean != null) {
          let pageTitle = this.moduleCaption + " - EDIT";
          this.setState(
            {
              purchaseOrderData: purchaseOrderBean,
              pageTitle: pageTitle,
              isLoading: false,
              loadingText: "",
            },
            () => {
              this.uploadMultiDocsToServer();
              this.uploadToServer();
            });
              
              // this.unlockPurchaseOrder(purchaseOrderBean.code, false);
              // this.editPurchaseOrder(response.data.purchaseOrder.code);
              if (!this.isLocked) {
                this.editPurchaseOrder(response.data.purchaseOrder.code);
              } else {
                this.code = purchaseOrderBean.code;
                this.unlockPurchaseOrder(purchaseOrderBean.code);
              }
            
          
        }
      }
    }
  };
  savePurchaseOrderError = (error) => {
    this.setState({ isLoading: false, loadingText: "" });
    ShowError("Error : " + error);
  };
  handleApproveResponse = (response) => {
    let success = false;
    let infoMsg = "";
    let errMsg = "";
    let errList = [];
    if (!isEmpty(response.mainOperationResponse)) {
      if (!isEmptyArray(response.mainOperationResponse.errors)) {
        response.mainOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          ),
        );
        success = false;
      }
      if (!isEmptyArray(response.mainOperationResponse.infos)) {
        response.mainOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription),
        );
        success = true;
      }
    }
    if (!isEmpty(response.additionalOperationResponse)) {
      if (!isEmptyArray(response.additionalOperationResponse.errors)) {
        response.additionalOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          ),
        );
        success = false;
      }
      if (!isEmptyArray(response.additionalOperationResponse.infos)) {
        response.additionalOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription),
        );
        success = true;
      }
    }
    if (!isEmptyArray(errList) && errList.length > 0) success = false;
    if (!isEmptyString(infoMsg) && !isEmptyString(errMsg)) {
      let msg = infoMsg + errMsg;
      let successMsg = [];
      successMsg.push(msg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyString(infoMsg)) {
      let successMsg = [];
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyString(errMsg)) {
      let errorMsg = [];
      errorMsg.push(errMsg);
      this.setState({
        alertMessage: errorMsg,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({ error_list: errList });
    return success;
  };
  approvePurchaseOrder = (e) => {
    if (e.detail == 1) {
      this.setState({
        isLoading: true,
        loadingText: "Approving Purchase Order",
      });
      let poBean = this.state.purchaseOrderData;

      let isValidData = false;
      isValidData = this.validatePurchaseData(poBean);
      let input = new RestPurchaseOrderBeanRequest();

      input.purchaseOrderBean = poBean;
      if (poBean.isFetched) {
        input.isLockReleaseRequired = true;
      } else {
        input.isLockReleaseRequired = false;
      }

      if (this.state.isTexco) {
        poBean.isAllowZeroCostFlag = true;
      }

      if (isValidData) {
        if (poBean.isFetched) {
          if (
            SecurityAccessManager.PurchaseOrderMaintenanceApprove_IsAccessible()
          ) {
            PurchaseOrderService.updateAndApprovePurchaseOrder(
              input,
              this.approvePurchaseOrderResponse,
              this.approvePurchaseOrderError,
            );
          } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);
            this.setState({
              alertMessage: errList,
              alertType: "danger",
              isShowAlert: true,
            });
          }
        } else {
          if (
            SecurityAccessManager.PurchaseOrderMaintenanceApprove_IsAccessible()
          ) {
            PurchaseOrderService.createAndApprovePurchaseOrder(
              input,
              this.approvePurchaseOrderResponse,
              this.approvePurchaseOrderError,
            );
          } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);
            this.setState({
              alertMessage: errList,
              alertType: "danger",
              isShowAlert: true,
            });
          }
        }
      } else {
        this.setState({ isLoading: false, loadingText: "" });
      }
    }
  };

  approvePurchaseOrderResponse = (response) => {
    this.setState({ isLoading: false, loadingText: "" });
    let isSuccess = this.handleApproveResponse(response.data);
    if (isSuccess) {
      if (
        !isEmpty(response.data) &&
        !isEmpty(response.data.mainOperationResponse)
      ) {
        let purchaseOrderData =
          response.data.mainOperationResponse.purchaseOrder;
        // if (!this.isLocked) {
        //   this.editPurchaseOrder(purchaseOrderData.code);
        // } else {
        //   this.code = purchaseOrderData.code;
        //   this.unlockPurchaseOrder(purchaseOrderData.code);
        // }
        this.editPurchaseOrder(purchaseOrderData.code);
      }
    }
  };
  approvePurchaseOrderError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  saveUnApprovePurchaseOrder = () => {
    this.setState({
      isLoading: true,
      loadingText: "UnApproving Purchase Order",
    });
    let poBean = this.state.purchaseOrderData;
    let purchaseRequest = new RestPurchaseOrderReasonRequest();
    purchaseRequest.purchaseOrderBean = poBean;
    purchaseRequest.reason = this.state.reasonData;
    if (
      SecurityAccessManager.PurchaseOrderMaintenanceUnApprove_IsAccessible()
    ) {
      PurchaseOrderService.unApprovePurchaseOrder(
        purchaseRequest,
        this.unApprovePurchaseOrderResponse,
        this.unApprovePurchaseOrderError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  unApprovePurchaseOrderResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleResponse(response.data);
    if (!isEmpty(response.data) && !isEmpty(response.data.purchaseOrder)) {
      const purchaseOrderBean = response.data.purchaseOrder;
      if (purchaseOrderBean != null) {
        let pageTitle = this.moduleCaption + " - EDIT";
        this.setState({
          purchaseOrderData: purchaseOrderBean,
          pageTitle: pageTitle,
          disablePurchaseOrderFormFields: false,
          isTexcoDiableUpdateFields: false,
        });
        // this.unlockPurchaseOrder(purchaseOrderBean.code, false);
        // this.editPurchaseOrder(purchaseOrderBean.code);
        if (this.isLocked) {
          this.code = purchaseOrderBean.code;
          this.unlockPurchaseOrder(purchaseOrderBean.code);
        }
      }
    }
  };
  unApprovePurchaseOrderError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  onUnApproveReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteUnApproveReasonList = true;

    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteUnApproveReasonList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteUnApproveReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteUnApproveReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteUnApproveReasonList: showAutoCompleteList,
        reasonData: reason,
        unApproveReasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readUnApproveReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.unapprovalReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteUnApproveReasonList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteUnApproveReasonList;
          this.setState({
            showAutoCompleteUnApproveReasonList: showAutoCompleteList,
          });
        }
      });
    }

    this.setState({ reasonData: reasonData });
  };
  readUnApproveReasonBySearchString(searchString) {
    let reasonData = this.state.unapprovalReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      unApproveReasonPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  unApproveReasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    let code = e.target.value;

    reasonData["code"] = e.target.value;
    let reasonList = this.state.unapprovalReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        unApproveReasonPageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompleteUnApproveReasonList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteUnApproveReasonList: showAutoCompleteList,
    });
  };
  unApprovePurchaseOrder = (e) => {
    if (e.detail == 1) this.openReasonCapture(2);
  };

  onUnApproveReasonContinue = () => {
    this.saveUnApprovePurchaseOrder();
    this.closeReasonModelCallBack();
  };
  savePurchaseOrderLineCancel = () => {
    let purchaseOrderData = this.state.purchaseOrderData;
    let poLine = this.state.purchaseOrderLineData;
    let input = new RestPurchaseOrderLineReasonRequest();
    let criteria = new PurchaseOrderLineSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.vendorCode = purchaseOrderData.vendorCode;
    criteria.fabricStyleCode = poLine.fabricStyleCode;
    criteria.orderStatus = purchaseOrderData.orderStatus;
    criteria.purchaseOrderNumber = purchaseOrderData.code;
    criteria.lineNumber = poLine.lineNumber;
    criteria.lineStatus = poLine.lineStatus;
    // criteria.toOrderStopDate = purchaseOrderData.orderStopDate;
    // criteria.orderDate = purchaseOrderData.orderDate;
    input.companyCode = this.companyCode;
    input.searchCriteria = criteria;
    input.reason = this.state.reasonData;
    if (SecurityAccessManager.SalesOrderMaintenanceCancel_IsAccessible()) {
      PurchaseOrderService.cancelPurchaseOrderLine(
        input,
        this.savePurchaseOrderLineCancelResponse,
        this.savePurchaseOrderLineCancelError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  savePurchaseOrderLineCancelResponse = (response) => {
    this.setState({
      isLoading: false,
    });
    let success = response.data.success;
    this.handleResponse(response.data);
    if (success) {
      if (!isEmpty(response.data) && !isEmpty(response.data.purchaseOrder)) {
        // this.unlockPurchaseOrder(response.data.purchaseOrder.code, false);
        // this.editPurchaseOrder(response.data.purchaseOrder.code);
        if (this.isLocked) {
          this.code = response.data.purchaseOrder.code;
          this.unlockPurchaseOrder(response.data.purchaseOrder.code);
        }
      }
    }
  };
  savePurchaseOrderLineCancelError = (error) => {
    ShowError("Error cancel line: " + error);
  };
  saveCancelPurchaseOrder = () => {
    this.setState({
      isLoading: true,
      loadingText: "Cancelling Puurchase Order",
    });
    let poBean = this.state.purchaseOrderData;
    let purchaseRequest = new RestPurchaseOrderReasonRequest();
    purchaseRequest.purchaseOrderBean = poBean;
    purchaseRequest.reason = this.state.reasonData;
    if (SecurityAccessManager.PurchaseOrderMaintenanceCancel_IsAccessible()) {
      PurchaseOrderService.cancelPurchaseOrder(
        purchaseRequest,
        this.cancelPurchaseOrderResponse,
        this.cancelPurchaseOrderError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isLoading: false,
        loadingText: "",
      });
    }
  };
  cancelPurchaseOrderResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleResponse(response.data);
    if (!isEmpty(response.data) && !isEmpty(response.data.purchaseOrder)) {
      const purchaseOrderBean = response.data.purchaseOrder;
      if (purchaseOrderBean != null) {
        let pageTitle = this.moduleCaption + " - EDIT";
        this.setState({
          purchaseOrderData: purchaseOrderBean,
          pageTitle: pageTitle,
          disablePurchaseOrderFormFields: true,
        });
        // this.unlockPurchaseOrder(purchaseOrderBean.code, false);
        // this.editPurchaseOrder(purchaseOrderBean.code);
        if (this.isLocked) {
          this.code = response.data.purchaseOrder.code;
          this.unlockPurchaseOrder(purchaseOrderBean.code);
        }
      }
    }
  };
  cancelPurchaseOrderError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  onLineCancelReasonContinue = () => {
    // const poline = this.state.purchaseOrderLineData;
    // const purchaseOrderData = this.state.purchaseOrderData;

    // const index = purchaseOrderData.lines.findIndex(
    //   (ln) => ln.skuNumber === poline.skuNumber
    // );
    // if (index != -1) {
    //   purchaseOrderData.lines.splice(index, 1);
    // }
    // this.setState({ purchaseOrderData: purchaseOrderData });
    // this.state.purchaseOrderData = purchaseOrderData;
    this.savePurchaseOrderLineCancel();
    this.closeReasonModelCallBack();
  };
  onReasonDescChange = (e) => {
    let reasonData = this.state.reasonData;
    reasonData[e.target.name] = e.target.value;
    this.setState({ reasonData: reasonData });
  };
  onReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteReasonList = true;

    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteReasonList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteReasonList: showAutoCompleteList,
        reasonData: reason,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.cancelReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteReasonList = false;
          let showAutoCompleteList = this.state.showAutoCompleteReasonList;
          this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
        }
      });
    }

    this.setState({ reasonData: reasonData });
  };
  readReasonBySearchString(searchString) {
    let reasonData = this.state.cancelReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ reasonPageListForAutoCompleteList: filteredSuggestions });
  }
  reasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    let code = e.target.value;

    reasonData["code"] = e.target.value;
    let reasonList = this.state.cancelReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        reasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteReasonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
  };
  closeReasonModelCallBack = () => {
    this.setState({
      isShowCancelReasonPopup: false,
      reasonData: new ReasonBean(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      isShowUnApproveReasonPopup: false,
      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
      isShowLineCancelReasonPopup: false,
    });
  };
  openReasonCapture = (type) => {
    if (type === 1) {
      this.setState({
        isShowCancelReasonPopup: true,
      });
    } else if (type === 2) {
      this.setState({
        isShowUnApproveReasonPopup: true,
      });
    } else if (type == 3) {
      this.setState({
        isShowLineCancelReasonPopup: true,
      });
    }
    this.setState({
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
    });
  };
  onCancelReasonContinue = () => {
    this.saveCancelPurchaseOrder();
    this.closeReasonModelCallBack();
  };
  cancelPurchaseOrder = (e) => {
    if (e.detail == 1) this.openReasonCapture(1);
  };
  readByVendorResponse = (response) => {
    if (response.data != null && response.data.vendor != null) {
      const vendor = response.data.vendor;
      let purchaseOrderData = this.state.purchaseOrderData;
      purchaseOrderData.vendorCode = vendor.code;
      purchaseOrderData.vendorName = vendor.description;
      this.setState(
        {
          purchaseOrderData: purchaseOrderData,
        },
        () => this.setVendorDetails(vendor),
      );
    }
  };
  readByVendorError = (error) => {
    this.ShowError(error);
  };
  readvendor = () => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = this.defaultVendor;
    VendorService.readVendor(
      input,
      this.readByVendorResponse,
      this.readByVendorError,
    );
  };
  readandsetVendor = () => {
    this.readvendor();
  };
  addNewEntry = () => {
    let poBean = new PurchaseOrderBean();
    let logisticData = this.state.logisticData;
    poBean.companyCode = this.companyCode;
    poBean.orderStatus = LogicConstants.PURCHASE_ORDER_UNAPPROVE_STATUS;
    // poBean.vendorCode = "TESTVEN";
    // poBean.vendorName = "TEST VENDOR";
    poBean.currencyCode = "USD";
    if (this.state.isTexco) poBean.purchaseOrderType = "IMPORTS";
    else poBean.purchaseOrderType = "STANDARD";
    poBean.shipToName = this.companyCode;
    poBean.orderStartDate = toFormattedDate_v1(new Date());
    poBean.orderDate = new Date();
    // poBean.locationCode = ConfigManager.isDefaultWarehouse() === ""
    //     ? DEFAULT_WAREHOUSE : ConfigManager.isDefaultWarehouse();
    if (this.state.isTexco) {
      poBean.locationCode =
        ConfigManager.isDefaultWarehouse() || DEFAULT_WAREHOUSE;
    } else {
      poBean.locationCode = DEFAULT_WAREHOUSE;
    }
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.readandsetVendor();
    }
    let newDate = new Date();
    var next_month = new Date(newDate.setMonth(newDate.getMonth() + 2));
    next_month = next_month.setDate(next_month.getDate() - 3 * 7 + 1);
    let stpDate = new Date(next_month);
    poBean.orderStopDate = toFormattedDate_v1(stpDate);
    logisticData.companyCode = this.companyCode;
    logisticData.purchaseOrderNumber = poBean.code;
    logisticData.xFactoryDate = poBean.orderStopDate;
    let incon = new Date(stpDate);
    let incon1 = incon.setDate(incon.getDate() + 10);
    incon1 = new Date(incon1);
    //let finalConsDate = incon1.toLocaleDateString("sv-SE");
    logisticData.inConsolidatorDCDate = toFormattedDate_v1(incon1);
    let inDc = new Date(incon1);
    let inDc1 = inDc.setDate(inDc.getDate() + 15);
    inDc1 = new Date(inDc1);
    let finalInDcDate = inDc1.toLocaleDateString("sv-SE");
    logisticData.inDCDate = finalInDcDate;
    let eta = new Date(inDc1);
    let inEta1 = eta.setDate(eta.getDate() + 5);
    inEta1 = new Date(inEta1);
    let finalEtaDate = inEta1.toLocaleDateString("sv-SE");
    poBean.etaDate = finalEtaDate;

    let pageTitle = this.moduleCaption + " - NEW";
    if (!isEmptyString(this.state.moduleKeyCode)) {
      poBean.code = this.state.moduleKeyCode;
      if (this.state.moduleKeyCode == NEW_ENTRY) {
        this.isLocked = false;
      } else {
        this.isLocked = true;
      }
    } else poBean.code = NEW_ENTRY;
    poBean.customerName = "";

    this.setState({
      purchaseOrderData: poBean,
      isPurchaseReceiptFormOpened: false,
      pageTitle: pageTitle,
      isLoading: false,

      logisticData: logisticData,
      poLinesList: [],
    });
    this.state.isDisableFields = false;

    if (this.state.isTexco) {
      this.state.purchaseOrderData.isAllowZeroCostFlag = true;
    }
    this.state.purchaseOrderData = poBean;
    this.openEntryForm();
  };
  setNewPurchaseOrderDefaultData = (purchaseOrderData) => {
    this.closeAllNodeViews();
    let poBean = purchaseOrderData;
    poBean.companyCode = this.companyCode;
    poBean.orderStatus = "O";
    poBean.currencyCode = "USD";
    poBean.code = NEW_ENTRY;

    if (this.state.isTexco) poBean.purchaseOrderType = "IMPORTS";
    else poBean.purchaseOrderType = "STANDARD";
    this.setState({
      purchaseOrderData: poBean,
    });
  };
  setVendorDetails(vendor) {
    let purchaseOrderData = this.state.purchaseOrderData;
    if (vendor != null && vendor != undefined) {
      let vendorAddress = vendor.address;
      if (vendorAddress != null && vendorAddress != undefined) {
        let address = new RestAddressBean();
        address.address1 = vendorAddress.address1;
        address.address2 = vendorAddress.address2;
        address.address3 = vendorAddress.address3;
        address.address4 = vendorAddress.address4;
        address.city = vendorAddress.city;
        address.state = vendorAddress.state;
        address.country = vendorAddress.country;
        address.zip = vendorAddress.zip;
        if (!address.zip) address.zip = "36";
        address.email = vendorAddress.email;
        address.mobilePhone = vendorAddress.mobilePhone;
        address.phone1 = vendorAddress.phone1;
        address.phone2 = vendorAddress.phone2;
        address.fax = vendorAddress.fax;
        address.website = vendorAddress.website;
        address.contactPerson = vendor.code;
        purchaseOrderData.address = address;
        purchaseOrderData.shippingAddress = address;
      }
      purchaseOrderData.factoryCode = "F1001";
      purchaseOrderData.fOBCity = vendor.fOBCity;
      purchaseOrderData.currencyCode = vendor.currencyCode;
      purchaseOrderData.shipViaCode = vendor.shipViaCode;
      purchaseOrderData.shipServiceLevel = vendor.shipServiceLevel;
      purchaseOrderData.transportType = vendor.transportType;
      purchaseOrderData.daysToFrightForwarding = vendor.daysToFrightForwarding;
      purchaseOrderData.incoterm = vendor.incoterm;
      let addressData = new AddressBean();
      this.setState({
        purchaseOrderData: purchaseOrderData,
        addressData: addressData,
      });
    }
  }
  onLineClick = (row) => {
    // this.readSelectedFabricStyle(row.fabricStyleCode);
    let rowData = { ...row };
    let purchaseOrderData = this.state.purchaseOrderData;
    if (
      purchaseOrderData.orderStatus ===
      LogicConstants.PURCHASE_ORDER_UNAPPROVE_STATUS
    ) {
      this.setState({ isShowAdjQtyButton: true });
    }
    this.setState({ purchaseOrderLineData: rowData });
  };
  getpoLinebySKUNumber = (lineNumber) => {
    let poLine = null;
    if (this.state.purchaseOrderData === null) return poLine;
    else if (this.state.purchaseOrderData.lines === null) return poLine;
    else {
      this.state.purchaseOrderData.lines.map((line) => {
        if (line.lineNumber === lineNumber) {
          poLine = line;
          return poLine;
        }
      });
    }
    return poLine;
  };
  reArrangePoLineNumbers = (lineList) => {
    let maxLineNumber = 0;
    lineList.map((line) => {
      ++maxLineNumber;
      line.lineNumber = maxLineNumber;
    });
  };
  cancelPurchaseOrderLine = (poLine) => {
    let purchaseOrderData = this.state.purchaseOrderData;
    let existingLine = this.getpoLinebySKUNumber(poLine.lineNumber);
    this.state.purchaseOrderLineData = { ...poLine };
    if (!isEmpty(existingLine)) {
      if (!existingLine.isFetched) {
        const index = purchaseOrderData.lines.findIndex(
          (ln) => ln.lineNumber === existingLine.lineNumber,
        );
        if (index != -1) {
          purchaseOrderData.lines.splice(index, 1);
        }
        this.reArrangePoLineNumbers(purchaseOrderData.lines);
        this.setState({
          purchaseOrderData: purchaseOrderData,
          poLinesList: purchaseOrderData.lines,
        });
      } else {
        this.openReasonCapture(3);
      }
    }
  };

  copyPreviousLine = () => {
    let maxLineNumber = this.state.purchaseOrderLineData.lineNumber;
    let lines = new Array();
    let poLineData = new PurchaseOrderLineBean();
    if (!isEmptyArray(this.state.purchaseOrderData.lines)) {
      lines = this.state.purchaseOrderData.lines;

      poLineData = { ...lines[maxLineNumber - 2] };
      poLineData.lineNumber = maxLineNumber;

      this.setState({
        purchaseOrderLineData: poLineData,
      });
    }
  };
  delSoLine = (lineDatas) => {
    let purchaseOrderLineData = this.state.purchaseOrderLineData;
    purchaseOrderLineData.sourceSalesOrderLines = lineDatas;
    this.setState({
      purchaseOrderLineData: purchaseOrderLineData,
    });
  };
  uploadExcelFile = (e) => {
    let file = e.target.files[0];
    let fileName = file.name;
    let fileData = new File([file], `${fileName}`, { type: file.type });
    let formData = new FormData();
    formData.append("file", fileData);
    this.setState({ fileName: fileName });
    if (SecurityAccessManager.PurchaseOrderMaintenance_IsAccessible()) {
      PurchaseOrderService.purchaseOrderInputExcelUpload(
        formData,
        this.uploadExcelResponse,
        this.uploadExcelError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  uploadExcelResponse = (response) => {
    if (response.data != null) {
      if (response.data.success == true) {
        this.getExcelData();
      }
    }
  };
  uploadExcelError = (error) => {};
  getExcelData = () => {
    this.setState({
      isLoading: true,
      loadingText: "Loading Excel Data",
    });
    let purchaseOrderData = this.state.purchaseOrderData;
    let request = new RestPurchaseOrderLinesDataRequest();
    request.companyCode = this.companyCode;
    request.excelFileName = this.state.fileName;
    request.vendorCode = purchaseOrderData.vendorCode;
    if (SecurityAccessManager.PurchaseOrderMaintenance_IsAccessible()) {
      PurchaseOrderService.getPurchaseOrderLinesDatasFromExcel(
        request,
        this.getExcelDataResponse,
        this.getExcelDataError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getExcelDataResponse = (response) => {
    this.showErrorMessage(response.data);
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let purchaseOrderData = this.state.purchaseOrderData;
    let poLinesList = new Array();
    if (response.data != null) {
      if (response.data.einputBean != null) {
        let poList = response.data.einputBean.poLines;
        let selectedExcelDataList = poList;
        let purchaseOrderData = this.state.purchaseOrderData;
        if (selectedExcelDataList != null) {
          var lineNumber = this.getPODataMaxLineNumber();
          for (let list of selectedExcelDataList) {
            let purchaseOrderLineData = new PurchaseOrderLineBean();
            purchaseOrderLineData.companyCode = this.companyCode;
            purchaseOrderLineData.fabricStyleCode = list.fabricStyleCode;
            this.readSelectedFabricStyle(list.fabricStyleCode);
            purchaseOrderLineData.lineNumber = ++lineNumber;
            purchaseOrderLineData.fabricStyleName = list.fabricStyleName;
            purchaseOrderLineData.colorCode = list.colorCode;
            purchaseOrderLineData.fabricStyleColorCode = list.colorCode;
            purchaseOrderLineData.lineStatus = list.lineStatus;
            purchaseOrderLineData.uomCode = list.uomCode;
            purchaseOrderLineData.orderQuantity = list.orderQuantity;
            purchaseOrderLineData.cost = list.cost;
            purchaseOrderLineData.lineTotalAmount = list.lineTotalAmount;
            purchaseOrderLineData.orderStartDate =
              purchaseOrderData.orderStartDate;
            purchaseOrderLineData.uomConversionRate = 1;
            purchaseOrderLineData.inventoryUomCode = list.uomCode;
            purchaseOrderLineData.widthCode = list.widthCode;
            purchaseOrderLineData.locationCode = DEFAULT_WAREHOUSE;
            purchaseOrderData.lines.push(purchaseOrderLineData);
            poLinesList = purchaseOrderData.lines;
          }
        }
      }
    }
    this.setState({
      purchaseOrderData: purchaseOrderData,
      poLinesList: poLinesList,
    });
  };
  getPODataMaxLineNumber() {
    let maxLineNumber = 0;
    let lines = this.state.purchaseOrderData.lines;
    if (lines.length > 0)
      lines.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  }
  getExcelDataError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  addNewPOLine = () => {
    let purchaseOrderData = this.state.purchaseOrderData;
    let logisticData = this.state.logisticData;
    let lineNumber = 0;
    let lines = purchaseOrderData.lines;
    lines.map((line) => {
      if (line.lineNumber > lineNumber) {
        lineNumber = line.lineNumber;
      }
    });

    lineNumber++;
    let purchaseOrderLineData = new PurchaseOrderLineBean();
    purchaseOrderLineData.purchaseOrderNumber = purchaseOrderData.code;
    purchaseOrderLineData.lineNumber = lineNumber;
    purchaseOrderLineData.companyCode = this.companyCode;
    purchaseOrderLineData.orderStartDate = purchaseOrderData.orderStartDate;
    purchaseOrderLineData.orderStopDate = purchaseOrderData.orderStopDate;
    purchaseOrderLineData.currencyCode = purchaseOrderData.currencyCode;
    let logisticLineData = new PurchaseOrderLineLogisticsPlanUpdateBean();
    logisticLineData.companyCode = this.companyCode;
    logisticLineData.purchaseOrderNumber = purchaseOrderData.code;
    logisticLineData.purchaseOrderLineNumber = purchaseOrderLineData.lineNumber;
    logisticLineData.xFactoryDate = logisticData.xFactoryDate;
    logisticLineData.inConsolidatorDCDate = logisticData.inConsolidatorDCDate;
    logisticLineData.comments = logisticData.comments;
    purchaseOrderLineData.currentLogisticsPlanUpdate = logisticLineData;
    purchaseOrderLineData.logisticsPlanUpdates.push(logisticLineData);
    this.setState({
      purchaseOrderLineData: purchaseOrderLineData,
      isShowAdjQtyButton: true,
      currentFabricStyle: new FabricStyleBean(),
      isShowAddButton: true,
    });
  };
  addOrUpdateLineChange = (e) => {
    let purchaseOrderLineData = this.state.purchaseOrderLineData;
    purchaseOrderLineData.openQuantity = purchaseOrderLineData.orderQuantity;
    let purchaseOrderData = this.state.purchaseOrderData;
    let purchaseOrderLinesList = this.state.purchaseOrderData.lines;

    // FIX: block zero-cost lines when isAllowZeroCostFlag is false
    const cost = parseFloat(purchaseOrderLineData.cost) || 0;
    if (!purchaseOrderData.isAllowZeroCostFlag && cost === 0) {
      this.setState({
        alertMessage: [
          "Cost cannot be zero when 'Allow Zero Cost' is disabled.",
        ],
        alertType: "danger",
        isShowPopupAlert: true,
      });
      return; // stop — do not add/update the line
    }

    if (this.state.isModifyCostCalculation) {
      purchaseOrderLinesList.map((list, i) => {
        if (purchaseOrderLineData.fabricStyleCode == list.fabricStyleCode) {
          purchaseOrderLinesList[i].cost = purchaseOrderLineData.cost;
          let lineAmount =
            parseFloat(purchaseOrderLinesList[i].orderQuantity) *
            parseFloat(purchaseOrderLinesList[i].cost);
          purchaseOrderLinesList[i].lineTotalAmount = lineAmount.toFixed(2);
        }
      });
    }

    let isValid = false;
    isValid = this.validateLineData(purchaseOrderLineData);
    if (isValid) {
      let isLineFound = false;
      purchaseOrderLinesList.map((line, i) => {
        if (line.lineNumber == purchaseOrderLineData.lineNumber) {
          purchaseOrderLinesList[i] = purchaseOrderLineData;
          isLineFound = true;
        }
      });
      if (!isLineFound) purchaseOrderLinesList.push(purchaseOrderLineData);
      purchaseOrderData.lines = purchaseOrderLinesList;
      this.setState({
        purchaseOrderData: purchaseOrderData,
        poLinesList: purchaseOrderLinesList,
        isModifyCostCalculation: false,
      });
      this.calculatePurchaseOrderAmounts();
      this.closeAlertLinePopupModalCallBack(false);
    }
  };
  handleItemAutocompleteSearch = (searchString) => {
    let criteria = new FabricStyleSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCodeContainingText = searchString;
    criteria.fabricStyleNameContainingText = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let requestInput = new RestFabricStyleListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;

    this.loadFabricStyleList(requestInput);
  };
  getPurchaseReceiptFormView = () => {
    return (
      <PurchaseReceiptForm
        purchaseOrderData={this.state.purchaseOrderData}
        dependenciesBean={this.state.dependenciesBean}
      />
    );
  };
  filterPurchaseOrder = () => {
    this.loadPage(1);
  };
  resetFilteredPurchaseOrder = () => {
    const criteria = new PurchaseOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.setState({ criteria: criteria }, () => {
      this.loadPage(1);
    });
  };
  onCriteriaChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  getAdjusmentLinesMaxLineNumber() {
    let maxLineNumber = 0;
    let adjData = [];
    if (!isEmptyArray(this.state.purchaseOrderLineData.adjustmentLines)) {
      adjData = this.state.purchaseOrderLineData.adjustmentLines;
    } else {
      adjData = this.state.purchaseOrderLineAdjustmentDataList;
    }
    if (adjData != null) {
      if (adjData.length > 0)
        adjData.map((line) => {
          if (line.adjustmentLineNumber > maxLineNumber) {
            maxLineNumber = line.adjustmentLineNumber;
          }
        });
    }
    return maxLineNumber;
  }
  addOrUpdateAdjustedLine = () => {
    let purchaseOrderLineAdjustmentData =
      this.state.purchaseOrderLineAdjustmentData;
    let purchaseOrderLineData = this.state.purchaseOrderLineData;
    let purchaseOrderData = this.state.purchaseOrderData;
    let purchaseOrderLineAdjustmentDataList =
      this.state.purchaseOrderLineAdjustmentDataList;
    let isValidAdj = false;
    isValidAdj = this.validateAdj(purchaseOrderLineAdjustmentData);
    if (isValidAdj) {
      let lineNumber = this.getAdjusmentLinesMaxLineNumber();
      let isLineFound = false;
      if (purchaseOrderLineData != null) {
        let adjLines = purchaseOrderLineData.adjustmentLines;
        if (!isEmptyArray(adjLines)) {
          adjLines.map((adjLine, i) => {
            if (
              adjLine.adjustmentLineNumber ==
              purchaseOrderLineAdjustmentData.adjustmentLineNumber
            ) {
              adjLine.code = purchaseOrderLineAdjustmentData.code;
              adjLine.adjustedQuantity =
                purchaseOrderLineAdjustmentData.adjustedQuantity;
              adjLine.uomCode = purchaseOrderLineAdjustmentData.uomCode;
              adjLine.description = purchaseOrderLineAdjustmentData.description;

              isLineFound = true;
            }
          });
          if (!isLineFound) {
            purchaseOrderLineAdjustmentData.adjustmentLineNumber = ++lineNumber;
            let temp_purchaseOrderLineAdjustmentDataList = [];
            let adjLines = [];
            if (purchaseOrderLineData.adjustmentLines != null) {
              adjLines = purchaseOrderLineData.adjustmentLines;
              purchaseOrderLineAdjustmentDataList.push(
                purchaseOrderLineAdjustmentData,
              );
              temp_purchaseOrderLineAdjustmentDataList = adjLines.concat(
                purchaseOrderLineAdjustmentDataList,
              );
            }
            purchaseOrderLineAdjustmentDataList =
              temp_purchaseOrderLineAdjustmentDataList;
          }
        } else {
          let newLineFound = false;
          if (!isEmptyArray(purchaseOrderLineAdjustmentDataList)) {
            purchaseOrderLineAdjustmentDataList.map((line, i) => {
              if (
                line.adjustmentLineNumber ==
                purchaseOrderLineAdjustmentData.adjustmentLineNumber
              ) {
                line.code = purchaseOrderLineAdjustmentData.code;
                line.adjustedQuantity =
                  purchaseOrderLineAdjustmentData.adjustedQuantity;
                line.uomCode = purchaseOrderLineAdjustmentData.uomCode;
                line.description = purchaseOrderLineAdjustmentData.description;

                newLineFound = true;
              }
            });
            if (!newLineFound) {
              purchaseOrderLineAdjustmentData.adjustmentLineNumber =
                ++lineNumber;
              let temp_purchaseOrderLineAdjustmentDataList = [];
              let adjLines = [];
              if (!isEmptyArray(purchaseOrderLineAdjustmentDataList)) {
                adjLines = purchaseOrderLineAdjustmentDataList;
                purchaseOrderLineAdjustmentDataList.push(
                  purchaseOrderLineAdjustmentData,
                );
              }
            }
          } else {
            purchaseOrderLineAdjustmentData.adjustmentLineNumber = ++lineNumber;
            purchaseOrderLineAdjustmentDataList.push(
              purchaseOrderLineAdjustmentData,
            );
          }
        }
      }
      this.setState({
        purchaseOrderLineAdjustmentData: new PurchaseOrderLineAdjustmentBean(),
        purchaseOrderLineAdjustmentDataList:
          purchaseOrderLineAdjustmentDataList,
      });
    }
  };
  poLineAdjustmentPopupContinueClick = () => {
    let purchaseOrderLineData = this.state.purchaseOrderLineData;
    let purchaseOrderLineAdjustmentDataList =
      this.state.purchaseOrderLineAdjustmentDataList;
    purchaseOrderLineData.adjustmentLines = purchaseOrderLineAdjustmentDataList;
    this.setState({
      purchaseOrderLineData: purchaseOrderLineData,
    });
    this.calculateAdjQuanity(purchaseOrderLineData);
    this.closeAdjutedQuantityAlertModalCallBack(false);
  };
  closeAdjutedQuantityAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowAdjustedQuantityPopup: false,
      purchaseOrderLineAdjustmentDataList: new Array(),
      isShowLineAlert: isShowPopup,
      isShowPopupAlert: isShowPopup,
    });
  };

  adjustedQuantityClick = () => {
    let purchaseOrderLineData = this.state.purchaseOrderLineData;
    let isValidADQty = false;
    isValidADQty = this.validADQty(purchaseOrderLineData);
    if (isValidADQty) {
      this.setState({
        isShowAdjustedQuantityPopup: true,
      });
    }
  };
  calculateAdjQuanity = (purchaseOrderLineData) => {
    var adjquantity = 0;
    purchaseOrderLineData.adjustmentLines.map((quantity) => {
      adjquantity += parseInt(quantity.adjustedQuantity);
    });
    let lineData = this.state.purchaseOrderData;
    lineData.lines.map((line) => {
      if ((purchaseOrderLineData.lineNumber = line.lineNumber)) {
        line.adjustedQuantity = adjquantity;
      }
    });
    let poLineData = this.state.purchaseOrderLineData;
    poLineData.adjustedQuantity = adjquantity;
    this.setState({ purchaseOrderLineData: poLineData });
  };
  onAdjLineChange = (e) => {
    let tempPurchaseOrderLineAdjustmentData =
      this.state.purchaseOrderLineAdjustmentData;
    tempPurchaseOrderLineAdjustmentData[e.target.name] = e.target.value;
    this.setState({
      purchaseOrderLineAdjustmentData: tempPurchaseOrderLineAdjustmentData,
    });
  };

  onAdjLineClick = (rowDatas) => {
    let rowData = { ...rowDatas };
    let adjData = this.state.purchaseOrderLineAdjustmentData;
    adjData.adjustmentLineNumber = rowData.adjustmentLineNumber;
    adjData.description = rowData.description;
    adjData.code = rowData.code;
    adjData.uomCode = rowData.uomCode;
    adjData.adjustedQuantity = rowData.adjustedQuantity;
    this.setState({
      purchaseOrderLineAdjustmentData: adjData,
    });
  };
  deleteAdjustment = (rowData) => {
    let purchaseOrderLineData = this.state.purchaseOrderLineData;
    let purchaseOrderLineAdjustmentData =
      this.state.purchaseOrderLineAdjustmentData;
    let dataList = this.state.purchaseOrderLineAdjustmentDataList;
    let adjLine = purchaseOrderLineData.adjustmentLines;
    if (rowData.isFetched === false) {
      if (!isEmptyArray(dataList)) {
        var index = dataList.indexOf(rowData);
        if (index > -1) {
          dataList.splice(index, 1);
        }
      } else {
        if (!isEmptyArray(adjLine)) {
          var index = dataList.indexOf(rowData);
          if (index > -1) {
            dataList.splice(index, 1);
          }
        }
      }
    }
    this.setState({ purchaseOrderLineData: purchaseOrderLineData });
  };
  showLookup = () => {
    this.setState({
      isShowLinePopup: true,
      showAutoCompleteFabricList: false,
      fabricPageListForAutoCompleteList: [],
    });
  };
  closeLookup = () => {
    this.setState({ isShowLinePopup: false });
  };
  closeAlertLinePopupModalCallBack = (isShowPopup) => {
    this.setState({
      isShowLinePopup: isShowPopup,
      isShowPopupAlert: isShowPopup,
      isShowColorLookup: false,
      showAutoCompleteFabricList: false,
      fabricPageListForAutoCompleteList: [],
      isModifyCostCalculation: false,
    });
  };
  onSelectedChange = (eve, rowData) => {
    let selectedLine = this.state.temp_selectedLineList;
    rowData.isActive = eve.target.value;
    if (rowData.isActive == true) {
      rowData.purchaseOrderNumber = this.state.purchaseOrderData.code;
      rowData.purchaseOrderLineNumber =
        this.state.purchaseOrderLineData.lineNumber;
      selectedLine.push(rowData);
      this.setState({ temp_selectedLineList: selectedLine });
    } else {
      let selectedList = this.state.temp_selectedLineList;
      let rollList = [];
      selectedList.map((ln) => {
        if (ln.salesOrderNumber != rowData.salesOrderNumber) {
          rollList.push(ln);
        }
      });
      this.setState({ temp_selectedLineList: rollList });
    }
  };
  selectAll = (e) => {
    if (e.detail == 1) {
      let list = this.state.salesAlocationLines;
      let isSelectedAll; //= e.target.value == true;
      list.map((line, i) => {
        line.isActive = true;
      });
      this.setState({ temp_selectedLineList: list });
    }
  };
  unSelectAll = (e) => {
    if (e.detail == 1) {
      let list = this.state.salesAlocationLines;
      list.map((line, i) => {
        line.isActive = false;
      });
      this.setState({ temp_selectedLineList: [] });
    }
  };
  salesOrderAlocation = () => {
    let purchaseOrderLineData = this.state.purchaseOrderLineData;

    let isValid = false;
    isValid = this.validateSOAlocation(purchaseOrderLineData);
    if (isValid) {
      if (purchaseOrderLineData.sourceSalesOrderLines != null) {
        let lineDatas = [];
        lineDatas = purchaseOrderLineData.sourceSalesOrderLines;
        this.setState({
          isSalesOrderAllocationPopup: true,
          lineDatas: lineDatas,
        });
      } else {
        let lineDatas = [];
        this.setState({
          isSalesOrderAllocationPopup: true,
          lineDatas: lineDatas,
        });
      }
      this.setState({
        isSalesOrderAllocationPopup: true,
      });
    }
  };
  closeSalesOrderAllocationAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isSalesOrderAllocationPopup: isShowPopup,
    });
  };
  openCustomerReserveAllocationPopup = (e) => {
    if (e.detail == 1)
      this.setState({
        isCustomerReserveAllocationPopup: true,
      });
  };
  closeAlertModalCallBackLvl2 = (isShowPopup) => {
    this.setState({
      isCustomerReserveAllocationPopup: isShowPopup,
      isShowAlertLvl1: isShowPopup,
      isAuthenticationPopup: isShowPopup,
    });
  };
  handleSortingPoLinesChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handlePoLineSorting(sortField, sortOrder);
  };
  handlePoLineSorting = (sortField, sortOrder) => {
    let purchaseOrderList = this.state.poLinesList;
    if (sortField && !isEmptyArray(purchaseOrderList)) {
      const sorted = [...purchaseOrderList].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ poLinesList: sorted });
    }
  };
  loadLines = () => {
    let criteria = new PurchaseSourceSalesOrderLineDetailSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.skuNumber = this.state.purchaseOrderLineData.skuNumber;
    if (SecurityAccessManager.PurchaseOrderMaintenance_IsAccessible()) {
      PurchaseOrderService.getPurchaseSourceSalesOrderLineDetails(
        criteria,
        this.getPurchaseSourceSOResponse,
        this.getPurchaseSourceError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getPurchaseSourceSOResponse = (response) => {
    let data = response.data.resultBean.sourceSalesOrderDetailLines;
    let data1 = this.state.lineDatas;
    if (data != null) {
      this.setState({
        salesAlocationLines: data,
      });
    } else {
      let tempArray = [];
      this.setState({ lineDatas: tempArray });
    }
  };
  getPurchaseSourceError = () => {
    let emptyArray = [];
    let purchaseOrderLineData = this.state.purchaseOrderLineData;
    purchaseOrderLineData.sourceSalesOrderLines = emptyArray;
    this.setState({
      purchaseOrderLineData: purchaseOrderLineData,
    });
  };
  multipleLines = () => {
    let purchaseOrderLineData = this.state.purchaseOrderLineData;
    purchaseOrderLineData.customerCode = "";
    this.setState({
      temp_selectedLineList: [],
      purchaseOrderLineData: purchaseOrderLineData,
    });
    let salesAlocationLines = this.state.salesAlocationLines;
    if (
      !isEmptyArray(salesAlocationLines) &&
      !isEmptyArray(purchaseOrderLineData.sourceSalesOrderLines)
    ) {
      salesAlocationLines.map((ln) => {
        purchaseOrderLineData.sourceSalesOrderLines.map((lines) => {
          if (ln.salesOrderNumber == lines.salesOrderNumber) {
            ln.isActive = true;
          }
        });
      });
    }
  };
  salesLinesContinue = () => {
    let purchaseOrderLineData = this.state.purchaseOrderLineData;
    let selectedLineList = this.state.temp_selectedLineList;
    let selectedArray = [];
    selectedLineList.map((ln) => {
      if (ln.isActive == true) {
        selectedArray.push(ln);
      }
    });
    let lineDatas = [];
    let lines = this.state.purchaseOrderLineData.sourceSalesOrderLines;
    lines.map((ln) => {
      lineDatas.push(ln);
    });
    var result = selectedLineList.filter(function (o1) {
      return lineDatas.every(function (o2) {
        return o1.salesOrderNumber !== o2.salesOrderNumber; // return the ones with equal id
      });
    });
    let final = [];
    final = result.concat(lineDatas);
    purchaseOrderLineData.sourceSalesOrderLines = final;
    this.setState({
      purchaseOrderLineData: purchaseOrderLineData,
    });
  };
  deleteLine = (rowData) => {
    let purchaseOrderLineData = this.state.purchaseOrderLineData;
    let lineDatas = purchaseOrderLineData.sourceSalesOrderLines;
    let existingLine = this.getBodyLineByLineNumber(rowData.salesOrderNumber);
    this.state.purchaseOrderLineAdjustmentData = { ...existingLine };
    const index = purchaseOrderLineData.sourceSalesOrderLines.findIndex(
      (ln) => ln.salesOrderNumber === rowData.salesOrderNumber,
    );
    if (index != -1) {
      purchaseOrderLineData.sourceSalesOrderLines.splice(index, 1);
    }
    this.setState({
      lineDatas: lineDatas,
    });
    let data = { ...rowData };
    let salesAlocationLines = this.state.salesAlocationLines;
    salesAlocationLines.map((ln) => {
      if (ln.salesOrderNumber == data.salesOrderNumber) {
        ln.isActive = false;
      }
    });
  };
  onSalesAllocationChange = (e) => {
    let tempPurchaseSourceSalesOrderLineData =
      this.state.purchaseSourceSalesOrderLineData;
    tempPurchaseSourceSalesOrderLineData[e.target.name] = e.target.value;
    this.setState({
      purchaseSourceSalesOrderLineData: tempPurchaseSourceSalesOrderLineData,
    });
  };
  filterSoLines = (e) => {
    if (e.detail == 1) {
      let purchaseOrderLineData = this.state.purchaseOrderLineData;
      let salesAlocationLines = this.state.salesAlocationLines;
      let finalSalesAlocationLines = [];
      salesAlocationLines.map((ln) => {
        if (ln.customerCode == purchaseOrderLineData.customerCode) {
          finalSalesAlocationLines.push(ln);
        }
      });
      this.setState({
        salesAlocationLines: finalSalesAlocationLines,
      });
    }
  };
  onSoCustomerChange = (e) => {
    let temp_purchaseOrderLineData = this.state.purchaseOrderLineData;
    temp_purchaseOrderLineData[e.target.name] = e.target.value;
    this.setState({
      purchaseOrderLineData: temp_purchaseOrderLineData,
    });
  };
  onSalesOrderChange = (e) => {
    let salesOrder = e.target.value;
    this.state.showAutoCompleteSOList = true;
    let lineData = this.state.purchaseSourceSalesOrderLineData;
    let showAutoCompleteList = this.state.showAutoCompleteSOList;
    if (isEmpty(salesOrder)) {
      this.state.showAutoCompleteSOList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSOList;
      let lineData = this.state.purchaseSourceSalesOrderLineData;
      lineData.salesOrderNumber = "";
      lineData.customerCode = "";
      lineData.customerName = "";
      lineData.customerPurchaseOrderNumber = "";
      lineData.orderStartDate = "";
      lineData.orderStopDate = "";
      lineData.orderQuantity = 0;

      let suggestion = [];
      this.setState({
        showAutoCompleteSOList: showAutoCompleteList,
        purchaseSourceSalesOrderLineData: lineData,
        salesPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "salesOrderNumber" &&
      showAutoCompleteList === true &&
      salesOrder !== ""
    ) {
      this.readSalesBySearchString(e.target.value);
    }
    lineData[e.target.name] = e.target.value;
    this.setState({ purchaseSourceSalesOrderLineData: lineData });
    this.readandsetSalesOrderDetail(salesOrder);
  };
  readSalesBySearchString = (searchString) => {
    let purchaseOrderLineData = this.state.purchaseOrderLineData;
    let fabricStyleCode = purchaseOrderLineData.fabricStyleCode;
    let colorCode = purchaseOrderLineData.colorCode;
    let orderStatus = "A";
    let searchCriteria = new SalesOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.salesOrderNumberStartsWith = searchString;
    searchCriteria.salesOrderNumberContains = searchString;
    searchCriteria.fabricStyleCode = fabricStyleCode;
    searchCriteria.fabricStyleColorCode = colorCode;
    searchCriteria.orderStatus = orderStatus;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestSalesOrderListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    SalesOrderService.getSalesOrderPageList(
      input,
      this.readBySalesOrderResponse,
      this.readBySalesOrderResponseError,
    );
  };
  readBySalesOrderResponse = (response) => {
    let salesData = response.data.salesOrderPageList.salesOrders;
    let simpleAutoCompleteList = new Array();
    if (salesData.length > 0 && salesData != null) {
      salesData.map((salesCode) => {
        let simpleItemBean = {
          code: salesCode.code,
          description: salesCode.customerCode,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      salesPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readBySalesOrderResponseError = (error) => {
    ShowError("Error : ", error);
  };
  salesCodeEnterKeyEventHandler = (e) => {
    let salesCode = e.target.value;
    this.readandsetSalesOrderDetail(salesCode);
    this.setState({
      salesPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteSalesList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteSOList: showAutoCompleteList });
  };
  clearSOLines = () => {
    let lines = new PurchaseSourceSalesOrderDetailLineBean();
    this.setState({ purchaseSourceSalesOrderLineData: lines });
  };
  readandsetSalesOrderDetail = (salesOrder) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = salesOrder;
    readrestInput.isLockRequired = true;
    if (SecurityAccessManager.PurchaseOrderMaintenance_IsAccessible()) {
      SalesOrderService.initSalesOrderModule(
        readrestInput,
        this.editSalesOrderResponse,
        this.editSalesOrderError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  editSalesOrderResponse = (response) => {
    let purchaseSourceSalesOrderLineData =
      this.state.purchaseSourceSalesOrderLineData;
    if (
      response.data.salesOrderResponse != null &&
      response.data.salesOrderResponse.salesOrder != null
    ) {
      const salesOrder = response.data.salesOrderResponse.salesOrder;
      purchaseSourceSalesOrderLineData.salesOrderNumber = salesOrder.code;
      purchaseSourceSalesOrderLineData.customerCode = salesOrder.customerCode;
      purchaseSourceSalesOrderLineData.customerName = salesOrder.customerName;
      purchaseSourceSalesOrderLineData.customerPurchaseOrderNumber =
        salesOrder.customerPurchaseOrderNumber;
      purchaseSourceSalesOrderLineData.orderStartDate =
        salesOrder.orderStartDate;
      purchaseSourceSalesOrderLineData.orderStopDate = salesOrder.orderStopDate;
      purchaseSourceSalesOrderLineData.orderQuantity =
        salesOrder.totalOrderedQuantity;
      this.setState({
        purchaseSourceSalesOrderLineData: purchaseSourceSalesOrderLineData,
      });
    }
  };
  editSalesOrderError = (error) => {
    ShowError("Error :", +error);
  };
  validateSoLine = (soLineData) => {
    let isValidSOLine = false;
    let err_list = [];
    let errorMessage = "";

    if (soLineData == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(soLineData.salesOrderNumber)) {
        let errMsg = "salesOrderNumber is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (soLineData.orderQuantity <= 0) {
        let errMsg = "Quantity is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(soLineData.customerCode)) {
        let errMsg = "customerCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(soLineData.customerName)) {
        let errMsg = "customerName is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(soLineData.customerPurchaseOrderNumber)) {
        let errMsg = "customerPO is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(soLineData.orderStartDate)) {
        let errMsg = "OrderStartDate is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(soLineData.orderStopDate)) {
        let errMsg = "OrderStopDate is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidSOLine = false;
      this.setState({ errorList: err_list });
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: false,
        isShowLineAlert: true,
      });
    } else {
      isValidSOLine = true;
      this.setState({ isShowAlert: false, isShowLineAlert: false });
    }
    return isValidSOLine;
  };
  addOrUpdateSoLines = (e) => {
    if (e.detail == 1) {
      let purchaseOrderLineData = this.state.purchaseOrderLineData;
      let soLineData = this.state.purchaseSourceSalesOrderLineData;
      let purchaseOrderData = this.state.purchaseOrderData;
      let lineDatas = this.state.lineDatas;
      let isLineFound = false;
      let isValid = false;
      isValid = this.validateSoLine(soLineData);
      if (isValid) {
        lineDatas.map((line, i) => {
          if (line.salesOrderNumber == soLineData.salesOrderNumber) {
            line.orderQuantity = soLineData.orderQuantity;
            lineDatas[i] = line;
            isLineFound = true;
          }
        });
        if (!isLineFound) lineDatas.push(soLineData);
        purchaseOrderLineData.sourceSalesOrderLines = lineDatas;
        this.setState({
          lineDatas: lineDatas,
          purchaseOrderLineData: purchaseOrderLineData,
        });
        this.clearSOLines();
      }
    }
  };
  getBodyLineByLineNumber = (salesOrderNumber) => {
    let bodyLine = null;
    if (this.state.lineDatas === null) return bodyLine;
    else {
      this.state.lineDatas.map((line) => {
        if (line.salesOrderNumber === salesOrderNumber) {
          bodyLine = line;
          return bodyLine;
        }
      });
    }
    return bodyLine;
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readCustomerCode(customerCode);
    this.setState({
      customerCodePageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteCustomerList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  onCustomerCodeChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let temppurchaseOrderLineData = this.state.purchaseOrderLineData;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let soLine = this.state.purchaseOrderLineData;
      soLine.customerCode = "";
      soLine.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        salesOrderLineData: soLine,
        customerCodePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerCodeBySearchString(e.target.value);
    }
    temppurchaseOrderLineData[e.target.name] = e.target.value;
    this.setState({ purchaseOrderLineData: temppurchaseOrderLineData });
    this.readCustomerCode(customerCode);
  };
  readCustomerCode = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    readrestInput.isLoadChildren = true;
    CustomerService.readCustomerWithChildren(
      readrestInput,
      this.readCustomerCodeResponse,
      this.readCustomerError,
    );
  };
  readCustomerCodeResponse = (response) => {
    let customerData = response.data.customer;
    if (customerData != null) {
      let purchaseOrderLineData = this.state.purchaseOrderLineData;
      purchaseOrderLineData.customerCode = customerData.code;
      purchaseOrderLineData.customerName = customerData.description;
      this.setState({
        purchaseOrderLineData: purchaseOrderLineData,
      });
    }
  };
  readCustomerError = (error) => {};
  readCustomerCodeBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.readItemByCustomerCodeError,
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerCodePageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readItemByCustomerCodeError = (error) => {
    ShowError("Error : " + error);
  };
  incotermOnChange = (e) => {
    let incoTerms = e.target.value;
    this.state.showAutoCompleteincoTermsList = true;
    let tempPurchaseOrderData = this.state.purchaseOrderData;
    let showAutoCompleteList = this.state.showAutoCompleteincoTermsList;
    if (isEmpty(incoTerms)) {
      this.state.showAutoCompleteincoTermsList = false;
      let showAutoCompleteList = this.state.showAutoCompleteincoTermsList;
      let tempPurchaseOrderData = this.state.purchaseOrderData;
      tempPurchaseOrderData.incoterm = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        purchaseOrderData: tempPurchaseOrderData,
        incoTermsPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && incoTerms !== "") {
      this.readincoTermsBySearchString(incoTerms);
    }
    if (e.target.name == "incoterm") {
      tempPurchaseOrderData[e.target.name] = e.target.value;
      let incoTermsList = this.state.incoTerms;
      incoTermsList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          tempPurchaseOrderData["incoterm"] = pdtType.code;
          this.state.showAutoCompleteincoTermsList = false;
          let showAutoCompleteList = this.state.showAutoCompleteincoTermsList;
          this.setState({
            showAutoCompleteincoTermsList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({
      purchaseOrderData: tempPurchaseOrderData,
    });
  };
  readincoTermsBySearchString(searchString) {
    let incoTermsData = this.state.incoTerms;
    let simpleAutoCompleteList = new Array();
    if (incoTermsData.length > 0 && incoTermsData != null) {
      incoTermsData.map((incoTerms) => {
        let simpleItemBean = {
          code: incoTerms.code,
          description: incoTerms.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteincoTermsLists) =>
        simpleAutoCompleteincoTermsLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      incoTermsPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  incoTermsEnterKeyEventHandler = (e) => {
    let purchaseOrderData = this.state.purchaseOrderData;
    purchaseOrderData["incoterm"] = e.target.value;
    let incoTermList = this.state.incoTerms;
    let incoTermBean = null;
    incoTermList.map((inco) => {
      if (inco.code == e.target.value) {
        incoTermBean = inco;
      }
    });
    if (!isEmpty(incoTermBean)) {
      purchaseOrderData.incoterm = incoTermBean.code;

      this.setState({
        purchaseOrderData: purchaseOrderData,
        incoTermsPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteincoTermsList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteincoTermsList: showAutoCompleteList });
  };
  loadPaymentdetail = (e) => {
    let PaymentCriteria = new VendorInvoicePaymentSearchCriteria();

    let purchaseOrderData = this.state.purchaseOrderData;

    PaymentCriteria.companyCode = this.companyCode;
    PaymentCriteria.purchaseOrderNumber = purchaseOrderData.code;
    PaymentCriteria.vendorCode = purchaseOrderData.vendorCode;
    let inputRequest = new RestVendorInvoicePaymentListRequest();
    inputRequest.searchCriteria = PaymentCriteria;
    let pageList = new PageListBean();
    inputRequest.pageInput = pageList;

    this.getPaymentLines(inputRequest);
  };
  getPaymentLines = (inputRequest) => {
    AccountPayableService.getVendorInvoicePaymentDetailsList(
      inputRequest,
      this.getPaymentDetailsPageResponse,
      this.errorCallBack,
    );
  };
  getPaymentDetailsPageResponse = (response) => {
    if (
      response.data != null &&
      response.data.vendorInvoicePaymentDetailPageList != null &&
      response.data.vendorInvoicePaymentDetailPageList
        .vednorInvoicePaymentDetails != null
    ) {
      let PurchasePaymentDetalis =
        response.data.vendorInvoicePaymentDetailPageList
          .vednorInvoicePaymentDetails;
      let PurchasePayment = PurchasePaymentDetalis.map((ln) => {
        // let AmountDue =new Array();
        let AmountDue = ln.approvedAmount - ln.paymentAmount;

        return {
          ...ln,
          AmountDue,
        };
      });
      this.setState({
        paymentDetailList: PurchasePayment,
      });
    }
  };

  /*********************** Cost Options *************************/

  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCostDetail: isOpen,
      moduleForPopup: [],
    });
  };

  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };

  openAllVendorCostDetailsInq = (e, val, rowData) => {
    let temp = { ...rowData };
    if (
      e.detail == 1 &&
      temp.fabricStyleCode != null &&
      temp.fabricStyleCode != ""
    ) {
      this.setState({
        isShowCostDetail: true,
        moduleForPopup: (
          <PopupPurchaseAndSlesDetailsInq
            fabricStyleCode={temp.fabricStyleCode}
            vendorCode={""}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };

  openVendorCostDetailsInq = (e, val, rowData) => {
    let purchaseOrderData = { ...this.state.purchaseOrderData };
    let temp = { ...rowData };
    if (
      e.detail == 1 &&
      temp.fabricStyleCode != null &&
      temp.fabricStyleCode != ""
    ) {
      this.setState({
        isShowCostDetail: true,
        moduleForPopup: (
          <PopupPurchaseAndSlesDetailsInq
            fabricStyleCode={temp.fabricStyleCode}
            vendorCode={purchaseOrderData.vendorCode}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };

  getHeaderView() {
    return (
      <PurchaseOrderForm
        {...this.state}
        isFocus={this.state.isFocus}
        back={this.back}
        save={this.save}
        clearError={this.clearError}
        savePurchaseOrder={this.savePurchaseOrder}
        onChange={this.onChange}
        onDateChange={this.onDateChange}
        onLogisticOnChange={this.onLogisticOnChange}
        onVendorCodeChange={this.onVendorCodeChange}
        purchaseOrderData={this.state.purchaseOrderData}
        addressOnChange={this.addressOnChange}
        vendorPageListForAutoCompleteList={
          this.state.vendorPageListForAutoCompleteList
        }
        vendorCodeEnterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
        onShipViaCodeChange={this.onShipViaCodeChange}
        shipViaEnterKeyEventHandler={this.shipViaEnterKeyEventHandler}
        shipViaPageListForAutoCompleteList={
          this.state.shipViaPageListForAutoCompleteList
        }
        showAutoCompleteShipViaList={this.state.showAutoCompleteShipViaList}
        onVendorTermChange={this.onVendorTermChange}
        vendorTermEnterKeyEventHandler={this.vendorTermEnterKeyEventHandler}
        vendorTermPageListForAutoCompleteList={
          this.state.vendorTermPageListForAutoCompleteList
        }
        showAutoCompleteVendorTermList={
          this.state.showAutoCompleteVendorTermList
        }
        onShipmentTermChange={this.onShipmentTermChange}
        shipmentTermEnterKeyEventHandler={this.shipmentTermEnterKeyEventHandler}
        shipmentTermPageListForAutoCompleteList={
          this.state.shipmentTermPageListForAutoCompleteList
        }
        showAutoCompleteShipmentTermList={
          this.state.showAutoCompleteShipmentTermList
        }
        onLocationChange={this.onLocationChange}
        locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
        locationPageListForAutoCompleteList={
          this.state.locationPageListForAutoCompleteList
        }
        showAutoCompleteLocationList={this.state.showAutoCompleteLocationList}
        onFOBChange={this.onFOBChange}
        fobEnterKeyEventHandler={this.fobEnterKeyEventHandler}
        fobPageListForAutoCompleteList={
          this.state.fobPageListForAutoCompleteList
        }
        showAutoCompleteFOBList={this.state.showAutoCompleteFOBList}
        displayAutoCompleteShipmentTermList={
          this.displayAutoCompleteShipmentTermList
        }
        displayAutoCompleteVendorTermList={
          this.displayAutoCompleteVendorTermList
        }
        displayAutoCompleteShipViaList={this.displayAutoCompleteShipViaList}
        displayAutoCompleteFobList={this.displayAutoCompleteFobList}
        displayAutoCompleteLocationList={this.displayAutoCompleteLocationList}
        displayAutoCompleteList={this.displayAutoCompleteList}
        showAutoCompleteList={this.state.showAutoCompleteList}
        isModifyPosible={this.isModifyPosible}
        extraChargeReasonCodeEnterKeyEventHandler={
          this.extraChargeReasonCodeEnterKeyEventHandler
        }
        onextraChargeReasonCodeChange={this.onextraChargeReasonCodeChange}
        displayAutoCompleteextraChargeReasonCodeList={
          this.displayAutoCompleteextraChargeReasonCodeList
        }
        onmiscellaneousChargeReasonCodeChange={
          this.onmiscellaneousChargeReasonCodeChange
        }
        miscellaneousChargeReasonCodeEnterKeyEventHandler={
          this.miscellaneousChargeReasonCodeEnterKeyEventHandler
        }
        displayAutoCompletemiscellaneousChargeReasonCodeList={
          this.displayAutoCompletemiscellaneousChargeReasonCodeList
        }
        customerOnChange={this.customerOnChange}
        customerEnterKeyEventHandler={this.customerEnterKeyEventHandler}
        displayAutoCustomerCompleteList={this.displayAutoCustomerCompleteList}
        incotermOnChange={this.incotermOnChange}
        incoTermsEnterKeyEventHandler={this.incoTermsEnterKeyEventHandler}
        displayAutoCompleteincoTermsList={this.displayAutoCompleteincoTermsList}
        addressClickHandler={this.addressClickHandler}
        shippingAddressClickHandler={this.shippingAddressClickHandler}
        onbusinessDivisionChange={this.onbusinessDivisionChange}
        businessDivisionEnterKeyEventHandler={
          this.businessDivisionEnterKeyEventHandler
        }
        displayAutoCompleteBusinessDivisionList={
          this.displayAutoCompleteBusinessDivisionList
        }
        onorderTypeChange={this.onorderTypeChange}
        orderTypeEnterKeyEventHandler={this.orderTypeEnterKeyEventHandler}
        displayAutoCompleteOrderTypeList={this.displayAutoCompleteOrderTypeList}
      isVendorInvoiceShow={this.state.isVendorInvoiceShow}
      />
    );
  }
  getOrderDetailsView() {
    return (
      <PurchaseOrderDetailsForm
        {...this.state}
        back={this.back}
        save={this.save}
        clearError={this.clearError}
        savePurchaseOrder={this.savePurchaseOrder}
        onChange={this.onChange}
        onFabricCodeChange={this.onFabricCodeChange}
        fabricCodeEnterKeyEventHandler={this.fabricCodeEnterKeyEventHandler}
        onFabricColourCodeChange={this.onFabricColourCodeChange}
        fabricColourEnterKeyEventHandler={this.fabricColourEnterKeyEventHandler}
        displayAutoCompleteColourList={this.displayAutoCompleteColourList}
        showAutoCompleteColourList={this.state.showAutoCompleteColourList}
        fabricColourPageListForAutoCompleteList={
          this.state.fabricColourPageListForAutoCompleteList
        }
        displayAutoCompleteList={this.displayAutoCompleteList}
        showAutoCompleteList={this.state.showAutoCompleteList}
        clearLineValues={this.clearLineValues}
        enterKeyEventHandler={this.enterKeyEventHandler}
        readSelectedFabricStyle={this.readSelectedFabricStyle}
        onDateChange={this.onDateChange}
        onLogisticOnChange={this.onLogisticOnChange}
        onVendorCodeChange={this.onVendorCodeChange}
        onLineChange={this.onLineChange}
        onLineClick={this.onLineClick}
        cancelPurchaseOrderLine={this.cancelPurchaseOrderLine}
        addOrUpdateLineChange={this.addOrUpdateLineChange}
        handleItemAutocompleteSearch={this.handleItemAutocompleteSearch}
        addNewPOLine={this.addNewPOLine}
        copyPreviousLine={this.copyPreviousLine}
        delSoLine={this.delSoLine}
        uploadExcelFile={this.uploadExcelFile}
        addOrUpdateAdjustedLine={this.addOrUpdateAdjustedLine}
        poLineAdjustmentPopupContinueClick={
          this.poLineAdjustmentPopupContinueClick
        }
        closeAdjutedQuantityAlertModalCallBack={
          this.closeAdjutedQuantityAlertModalCallBack
        }
        onAdjLineChange={this.onAdjLineChange}
        onAdjLineReasonChange={this.onAdjLineReasonChange}
        reasonEnterKeyEventHandler={this.adjReasonEnterKeyEventHandler}
        displayAutoCompleteAdjReasonList={this.displayAutoCompleteAdjReasonList}
        isModifyPosible={this.isModifyPosible}
        onAdjLineClick={this.onAdjLineClick}
        deleteAdjustment={this.deleteAdjustment}
        getPoLineImagePathMain={this.getPoLineImagePathMain}
        getPoLineImagePathWeb={this.getPoLineImagePathWeb}
        getPoLineImagePathFront={this.getPoLineImagePathFront}
        getPoLineImagePathBack={this.getPoLineImagePathBack}
        adjustedQuantityClick={this.adjustedQuantityClick}
        validADQty={this.validADQty}
        validateSOAlocation={this.validateSOAlocation}
        validateAddLineSOAlocation={this.validateAddLineSOAlocation}
        hideAlertCallBack={this.hideAlertCallBack}
        clearAdjLines={this.clearAdjLines}
        showLookup={this.showLookup}
        closeLookup={this.closeLookup}
        closeAlertLinePopupModalCallBack={this.closeAlertLinePopupModalCallBack}
        onSelectedChange={this.onSelectedChange}
        salesLinesContinue={this.salesLinesContinue}
        multipleLines={this.multipleLines}
        loadLines={this.loadLines}
        salesOrderAlocation={this.salesOrderAlocation}
        closeSalesOrderAllocationAlertModalCallBack={
          this.closeSalesOrderAllocationAlertModalCallBack
        }
        salesAlocationLines={this.state.salesAlocationLines}
        unSelectAll={this.unSelectAll}
        selectAll={this.selectAll}
        deleteLine={this.deleteLine}
        onSalesAllocationChange={this.onSalesAllocationChange}
        purchaseSourceSalesOrderLineData={
          this.state.purchaseSourceSalesOrderLineData
        }
        addOrUpdateSoLines={this.addOrUpdateSoLines}
        onSalesOrderChange={this.onSalesOrderChange}
        salesCodeEnterKeyEventHandler={this.salesCodeEnterKeyEventHandler}
        displayAutoCompleteSalesList={this.displayAutoCompleteSalesList}
        salesPageListForAutoCompleteList={
          this.state.salesPageListForAutoCompleteList
        }
        showAutoCompleteSOList={this.state.showAutoCompleteSOList}
        filterSoLines={this.filterSoLines}
        onSoCustomerChange={this.onSoCustomerChange}
        // customerLookupHandler={this.state.customerLookupHandler}
        customerCodeEnterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
        customerCodePageListForAutoCompleteList={
          this.state.customerCodePageListForAutoCompleteList
        }
        displayAutoCompleteCustomerList={this.displayAutoCompleteCustomerList}
        showAutoCompleteCustomerList={this.state.showAutoCompleteCustomerList}
        onCustomerCodeChange={this.onCustomerCodeChange}
        closeAlertModalCallBackLvl2={this.closeAlertModalCallBackLvl2}
        openCustomerReserveAllocationPopup={
          this.openCustomerReserveAllocationPopup
        }
        handleSortingPoLinesChange={this.handleSortingPoLinesChange}
        authClick={this.authClick}
        authOnChange={this.authOnChange}
        checkAuthentication={this.checkAuthentication}
        clearAuthetication={this.clearAuthetication}
        priceOncontinue={this.priceOncontinue}
        costOnChange={this.costOnChange}
        hideAlertCallBackLvl1={this.hideAlertCallBackLvl1}
        colorCodeRef={this.colorCodeRef}
        fabricStyleRef={this.fabricStyleRef}
        vendorStyleRef={this.vendorStyleRef}
        onfabricBlur={this.onfabricBlur}
        onfabricKeyDown={this.onfabricKeyDown}
        addorUpdateMultiplePOLine={this.addorUpdateMultiplePOLine}
        onKeyPress={this.onKeyPress}
        openAllVendorCostDetailsInq={this.openAllVendorCostDetailsInq}
        openVendorCostDetailsInq={this.openVendorCostDetailsInq}
      />
    );
  }
  getOrderHistoryView() {
    return (
      <PurchaseOrderHistoryDetailsForm
        {...this.state}
        purchaseOrderData={this.state.purchaseOrderData}
      />
    );
  }
  getOrderReceiptView() {
    return (
      <PurchaseReceiptForm
        {...this.state}
        purchaseOrderData={this.state.purchaseOrderData}
        dependenciesBean={this.state.dependenciesBean}
      />
    );
  }
  getImageFormView = () => {
    return (
      <Images
        {...this.state}
        showToast={this.showToast}
        setMultiImageUrl={this.setMultiImageUrl}
        setMultiImgData={this.setMultiImgData}
        uploadMutiImage={this.uploadMutiImage}
        deleteMutipleImage={this.deleteMutipleImage}
        addImageLines={this.addImageLines}
        clearImageLines={this.clearImageLines}
      />
    );
  };

  getDocumentMutipleFormView = () => {
    return (
      <MutilpleDocuments
        {...this.state}
        purchaseOrderData={this.state.purchaseOrderData}
        documents={this.state.documents}
        // onChange={this.onChange}
        showToast={this.showToast}
        uploadMutiDouments={this.uploadMutiDouments}
        uploadMutiDoumentsUrl={this.uploadMutiDoumentsUrl}
        deleteMultiDocument={this.deleteMultiDocument}
      />
    );
  };
  getPaymentDetailView() {
    return (
      <PurchaseInvoicePaymentDetailsForm
        {...this.state}
        loadPaymentdetail={this.loadPaymentdetail}
        // loadPaymentdetail={this.loadPaymentdetail}
        paymentDetailList={this.state.paymentDetailList}
        // isPaymentDetailsDatasFound={this.state.isPaymentDetailsDatasFound}
      />
    );
  }
  showToast = (msg, type) => {
    let errList = [];
    if (type === 1) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (type === 2) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  uploadMutiImage = (images) => {
    let purchaseOrderData = this.state.purchaseOrderData;
    let orderImages = new Array();
    let imageData = null;
    for (const img of images) {
      if (!img.isFetched && !img.isDeleted) {
        imageData = new PurchaseOrderImageBean();
        if (!isEmpty(img.imageCode)) {
          imageData.imageCode = img.imageCode;
          imageData.imageName = img.name;
          imageData.imageOritinalname = img.name;
          imageData.isFetched = true;
          imageData.isApplied = true;
        } else {
          imageData.imageOritinalname = img.name;
          imageData.imageName = img.name;
        }
        imageData.companyCode = this.companyCode;
        imageData.purchaseOrderNumber = purchaseOrderData.code;
        orderImages.push(imageData);
      } else {
        if (img.isFetched == true) {
          orderImages.push(img);
        }
      }
    }
    purchaseOrderData.orderImages = orderImages;
    this.setState({
      purchaseOrderData: purchaseOrderData,
      images: images,
    });
  };
  deleteMutipleImage = (tempIndex) => {
    let orderImages = this.state.purchaseOrderData.orderImages;
    if (!isEmptyArray(orderImages)) {
      for (let j = 0; j < orderImages.length; j++) {
        if (j === tempIndex) {
          if (orderImages[j].isFetched == true) {
            orderImages[j].deleted = true; // Change the value at index 2
            orderImages[j].isDeleted = true;
          } else {
            orderImages.splice(j, 1); // Change the value at index 2
            this.state.images.splice(j, 1);
          }
        }
      }
    }
    this.state.purchaseOrderData.orderImages = orderImages;
  };
  addImageLines = (imageEntity) => {
    let poData = this.state.purchaseOrderData;
    poData.orderImages.map((det) => {
      if (det.imageName == imageEntity.imageName) {
        det.tags = imageEntity.tags;
        det.notesCommunication = imageEntity.notesCommunication;
      }
    });
    this.setState({
      purchaseOrderData: poData,
    });
  };
  // clearImageLines
  clearImageLines = (imageEntity) => {
    let poData = this.state.purchaseOrderData;
    poData.orderImages.map((det) => {
      if (det.imageName == imageEntity.imageName) {
        det.tags = "";
        det.notesCommunication = "";
      }
    });
    this.setState({
      purchaseOrderData: poData,
    });
  };
  uploadMutiDouments = (docs) => {
    let purchaseOrderData = this.state.purchaseOrderData;
    let documents = new Array();
    let docmentData = null;
    for (const doc of docs) {
      if (!doc.isFetched) {
        docmentData = new PurchaseOrderDocumentBean();
        docmentData.documentOriginalName = doc.name;
        docmentData.documentName = doc.name;
        docmentData.companyCode = this.companyCode;
        docmentData.purchaseOrderNumber = purchaseOrderData.code;
        docmentData.documentPath = DOCUMENT_CHANGED;
        documents.push(docmentData);
      } else {
        documents.push(doc);
      }
    }
    purchaseOrderData.purchaseOrderDocuments = documents;
    this.setState({
      purchaseOrderData: purchaseOrderData,
      documents: docs,
    });
  };
  uploadMutiDoumentsUrl = (url) => {
    setTimeout(() => {
      this.setState({
        preview_Docs: url,
      });
    }, 400);
  };

  deleteMultiDocument = (rowData) => {
    let docs = this.state.purchaseOrderData.purchaseOrderDocuments;
    if (!isEmptyArray(docs)) {
      for (let j = 0; j < docs.length; j++) {
        if (docs[j].documentName === rowData.documentName) {
          if (docs[j].isFetched == true) {
            docs[j].deleted = true; // Change the value at index 2
            docs[j].isDeleted = true;
          } else {
            docs.splice(j, 1); // Change the value at index 2
            this.state.documents.splice(j, 1);
          }
        }
      }
    }
    this.state.purchaseOrderData.purchaseOrderDocuments = docs;
  };
  setMultiImageUrl = (url) => {
    setTimeout(() => {
      this.setState({
        preview_Url: url,
      });
    }, 300);
  };
  setMultiImgData = (data) => {
    setTimeout(() => {
      this.setState({
        images: data,
      });
    }, 400);
  };
  uploadToServer = () => {
    const purchaseOrderData = { ...this.state.purchaseOrderData };
    const temp_OrderImages = this.state.temp_OrderImages;
    const imgData = this.state.imgData;
    const docData = this.state.docData;
    const images = this.state.images;
    if (!isEmptyArray(purchaseOrderData.orderImages)) {
      purchaseOrderData.orderImages.map((img) => {
        if (img.isDeleted != true && img.isFetched != true) {
          images.map((imgData) => {
            if (img.imageOritinalname == imgData.name) {
              this.toServer(imgData, img.imageName);
            }
          });
        } else if (img.isFetched == true && img.isApplied == true) {
          images.map((imgData) => {
            if (img.imageOritinalname == imgData.name) {
              this.toServer(imgData, img.imageName);
            }
          });
        }
      });
    }
  };
  toServer = (file, fileName) => {
    let image = new File([file], `${fileName}`, { type: file.type });
    let formData = new FormData();
    formData.append("file", image);
    PurchaseOrderService.purchaseOrderImageUpload(
      formData,
      this.uploadImageServerResponse,
      this.uploadImageServerError,
    );
  };

  uploadImageServerResponse = (response) => {
    if (response.data.success) {
    }
  };
  uploadImageServerError = (error) => {
    ShowError("Error :", error);
  };
  uploadMultiDocsToServer = () => {
    const purchaseOrderData = { ...this.state.purchaseOrderData };
    const documents = this.state.documents;
    if (!isEmptyArray(purchaseOrderData.purchaseOrderDocuments)) {
      purchaseOrderData.purchaseOrderDocuments.map((doc) => {
        if (doc.isDeleted != true && doc.isFetched != true) {
          documents.map((docData) => {
            if (doc.documentOriginalName == docData.name) {
              this.docToServer(docData, doc.documentName);
            }
          });
        }
      });
    }
  };

  docToServer = (file, fileName) => {
    let document = new File([file], `${fileName}`, { type: file.type });
    const formData = new FormData();
    formData.append("file", document);
    PurchaseOrderService.purchaseOrderDocUpload(
      formData,
      this.documentUploadResponse,
      this.errorCallBack,
    );
  };
  documentUploadResponse = (response) => {};
  getModuleListView = () => {
    let purchaseOrderData = this.state.purchaseOrderData;
    if (purchaseOrderData.code === NEW_ENTRY) {
      this.closeEntryForm();
      this.loadPurchaseOrderPage();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unlockPurchaseOrder(purchaseOrderData.code);
      } else {
        this.isLocked = false;
      }

      this.closeEntryForm();
      this.loadPurchaseOrderPage();
    }
    this.setState({
      selectedNodeKey: "headerView",
    });
  };
  resetView = () => {
    let purchaseData = this.state.purchaseOrderData;
    this.state.isReseted = true;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode) this.unlockPurchaseOrder(purchaseData.code);
    } else {
      this.isLocked = false;
    }

    let purchaseOrderData = new PurchaseOrderBean();
    purchaseOrderData.customerName = "";
    this.setState({
      purchaseOrderData: purchaseOrderData,
      isResetModule: true,
      moduleKeyCode: NEW_ENTRY,
      selectedNodeKey: "headerView",
      disabled: false,
      isFocus: false,
      isFocusLookup: true,
      fabricPageListForAutoCompleteList: new Array(),
      customerCodePageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      showAutoCompleteFabricList: false,
      fabricPageListForAutoCompleteList: [],
      isDisabledFields: false,
      disablePurchaseOrderFormFields: false,
      isTexcoDiableUpdateFields: false,
      poLinesList: [],
    });
    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.hideAlertCallBack();
    this.addNewEntry();
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  selectButtonClick = (e) => {
    this.editPurchaseOrder(this.state.moduleKeyCode);
    // this.disable();
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  moduleExit = () => {
    let purchaseData = this.state.purchaseOrderData;
    if (purchaseData.code === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode) this.unlockPurchaseOrder(purchaseData.code);
      } else {
        this.isLocked = false;
      }
      // this.unlockPurchaseOrder(purchaseData.code, false);
      this.props.onModuleExit();
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({
      isShowAlert: isDisplayed,
      isShowPopupAlert: isDisplayed,
      isShowLineAlert: isDisplayed,
      isShowCopyPoAlert: isDisplayed,
    });
  };
  clearLineValues = () => {
    let purchaseOrderData = this.state.purchaseOrderData;

    let newLineBean = new PurchaseOrderLineBean();

    this.setState({
      purchaseOrderLineData: newLineBean,
      isShowColorLookup: false,
      colorLookupHandler: null,
      isShowAdjQtyButton: false,
      currentFabricStyle: new FabricStyleBean(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: false,
    });
    this.fabricStyleRef.current.focus();
    this.addNewPOLine();
  };

  onCopyPOChange = (e) => {
    let copyPoCode = this.state.copyPoCode;
    this.state.showAutoCompletePurchaseOrderList = true;
    copyPoCode = e.target.value;
    let showAutoCompleteList = this.state.showAutoCompletePurchaseOrderList;
    if (isEmpty(copyPoCode)) {
      let purchaseOrder = this.state.copyPoCode;
      let suggestion = [];
      this.setState({
        copyPoCode: purchaseOrder,
        purchaseOrderPageListForAutoCompleteList: suggestion,
        showAutoCompletePurchaseOrderList: false,
      });
    } else if (
      e.target.name == "copyPoCode" &&
      showAutoCompleteList === true &&
      copyPoCode !== ""
    ) {
      this.readPurchaseOrderBySearchString(e.target.value);
    }
    this.setState({
      copyPoCode: copyPoCode,
    });
  };
  readPurchaseOrderBySearchString(searchString) {
    let searchCriteria = new PurchaseOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.purchaseOrderNumberStartsWith = searchString;
    searchCriteria.purchaseOrderNumberContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestPurchaseOrderListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    PurchaseOrderService.getPurchaseOrderPageList(
      cust_requestInput,
      this.readPurchaseOrderBySearchStringResponse,
      this.errorCallBack,
    );
  }

  readPurchaseOrderBySearchStringResponse = (response) => {
    let purchaseorderData = response.data.purchaseOrderPageList.purchaseOrders;
    let simpleAutoCompleteList = new Array();
    if (purchaseorderData.length > 0 && purchaseorderData != null) {
      purchaseorderData.map((po) => {
        let simpleItemBean = {
          code: po.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      purchaseOrderPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };

  purchaseOrderEnterKeyEventHandler = (e) => {
    let copyPoCode = this.state.copyPoCode;
    copyPoCode = e.target.value;
    this.setState({
      copyPoCode: copyPoCode,
    });
    this.setState({
      purchaseOrderPageListForAutoCompleteList: new Array(),
    });
  };

  displayAutoCompletePurchaseOrderList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompletePurchaseOrderList: showAutoCompleteList,
    });
  };

  copyPOContinue = (e) => {
    if (e.detail == 1) {
      if (!isEmptyString(this.state.copyPoCode)) {
        this.setState({
          isLoading: true,
          loadingText: "Copying PO",
        });
        let copyPoCode = this.state.copyPoCode;
        let request = new RestReadRequest();
        request.code = copyPoCode;
        request.companyCode = this.companyCode;
        PurchaseOrderService.readPurchaseOrder(
          request,
          this.copyPOContinueResponse,
          this.copyPOContinueError,
        );
      } else {
        //Else Added
        let errMsg = "Invalid PurchaseOrder";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowCopyPoAlert: true,
        });
      }
    }
  };

  // copyPOContinue = () => {
  //   this.setState({
  //     isLoading: true,
  //     loadingText: "Copying PO",
  //   });
  //   let copyPoCode = this.state.copyPoCode;
  //   let request = new RestReadRequest();
  //   request.code = copyPoCode;
  //   request.companyCode = this.companyCode;
  //   if (SecurityAccessManager.PurchaseOrderMaintenanceView_IsAccessible()) {
  //     PurchaseOrderService.readPurchaseOrder(
  //       request,
  //       this.copyPOContinueResponse,
  //       this.copyPOContinueError
  //     );
  //   } else {
  //     let errMsg = "Access Denied";
  //     let errList = [];
  //     errList.push(errMsg);

  //     this.setState({
  //       alertMessage: errList,
  //       alertType: "danger",
  //       isShowAlert: true,
  //     });
  //   }
  // };
  copyPOContinueResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let poDatas = this.state.purchaseOrderData;
    poDatas.lines = [];
    let poData = response.data.purchaseOrder;
    poDatas.companyCode = this.companyCode;
    poDatas.code = NEW_ENTRY;
    poDatas.vendorCode = poData.vendorCode;
    poDatas.vendorName = poData.vendorName;
    poDatas.factoryCode = poData.factoryCode;
    poDatas.currencyCode = poData.currencyCode;
    poDatas.createdDate = new Date();
    poDatas.orderDate = new Date();
    poDatas.orderStatus = poData.orderStatus;
    poDatas.etaDate = poData.etaDate;
    poDatas.businessDivision = poData.businessDivision;
    poDatas.shipToCode = poData.shipToCode;
    poDatas.buyingTermsCode = poData.buyingTermsCode;
    poDatas.shipmentTermsCode = poData.shipmentTermsCode;
    poDatas.daysToFrightForwarding = poData.daysToFrightForwarding;
    poDatas.orderStartDate = poData.orderStartDate;
    poDatas.orderStopDate = poData.orderStopDate;
    poDatas.locationCode = poData.locationCode;
    poDatas.orderSubTotal = poData.orderSubTotal;
    poDatas.taxAmount = poData.taxAmount;
    poDatas.discountAmount = poData.discountAmount;
    poDatas.shipmentChargesAmount = poData.shipmentChargesAmount;
    poDatas.extraCharge = poData.extraCharge;
    poDatas.miscellaneousCharge = poData.miscellaneousCharge;
    poDatas.grandTotalAmount = poData.grandTotalAmount;
    poDatas.adjustedQuantityAmount = 0;
    poDatas.receivedQuantityAmount = 0;
    poDatas.extraChargeReasonCode = poData.extraChargeReasonCode;
    poDatas.miscellaneousChargeReasonCode =
      poData.miscellaneousChargeReasonCode;
    poDatas.incoterm = poData.incoterm;
    poDatas.lCNumber = poData.lCNumber;
    poDatas.receiptTolerancePercentage = poData.receiptTolerancePercentage;
    poDatas.createdBy = poData.createdBy;
    poDatas.updatedBy = poData.updatedBy;
    poDatas.updatedDate = poData.updatedDate;
    poDatas.shipppingInstructions = poData.shipppingInstructions;
    poDatas.generateCpm = poData.generateCpm;
    poDatas.comments = poData.comments;
    poDatas.groupPurchaseOrderNumber = poData.groupPurchaseOrderNumber;
    poDatas.shipToName = poData.shipToName;
    poDatas.orderType = poData.orderType;
    poDatas.purchaseDivisionCode = poData.purchaseDivisionCode;
    poDatas.destination = poData.destination;
    let lineData = poData.lines;
    if (lineData != null) {
      for (let poLnData of lineData) {
        let poLnDatas = new PurchaseOrderLineBean();
        poLnDatas.companyCode = poLnData.companyCode;
        poLnDatas.purchaseOrderNumber = NEW_ENTRY;
        poLnDatas.lineNumber = poLnData.lineNumber;
        poLnDatas.lineStatus = LogicConstants.PURCHASE_ORDER_LINE_OPEN_STATUS;
        poLnDatas.fabricStyleCode = poLnData.fabricStyleCode;
        poLnDatas.fabricStyleName = poLnData.fabricStyleName;
        poLnDatas.colorCode = poLnData.colorCode;
        poLnDatas.widthCode = poLnData.widthCode;
        poLnDatas.skuNumber = poLnData.skuNumber;
        poLnDatas.upcCode = poLnData.upcCode;
        poLnDatas.uomCode = poLnData.uomCode;
        poLnDatas.inventoryUomCode = poLnData.inventoryUomCode;
        poLnDatas.uomConversionRate = poLnData.uomConversionRate;
        poLnDatas.cost = poLnData.cost;
        poLnDatas.price = poLnData.price;
        poLnDatas.openQuantity = poLnData.orderQuantity;
        poLnDatas.orderQuantity = poLnData.orderQuantity;
        poLnDatas.adjustedQuantity = 0;
        poLnDatas.inTransitAdjustedQuantity = 0;
        poLnDatas.inTransitQuantity = 0;
        poLnDatas.receivedQuantity = 0;
        poLnDatas.receivedAdjustedQuantity = 0;
        poLnDatas.lineTotalAmount = poLnData.lineTotalAmount;
        poLnDatas.locationCode = poLnData.locationCode;
        poLnDatas.orderStartDate = poLnData.orderStartDate;
        poLnDatas.inDCDate = poLnData.inDCDate;
        poLnDatas.orderStopDate = poLnData.orderStopDate;
        poLnDatas.productDivisionCode = poLnData.productDivisionCode;
        poLnDatas.productDepartmentCode = poLnData.productDepartmentCode;
        poLnDatas.productClassCode = poLnData.productClassCode;
        poLnDatas.productSubClassCode = poLnData.productSubClassCode;
        poLnDatas.purchaseOrderScheduleNumber =
          poLnData.purchaseOrderScheduleNumber;
        poLnDatas.techDesigner = poLnData.techDesigner;
        poLnDatas.extraCharge = poLnData.extraCharge;
        poLnDatas.cpmTemplateCode = poLnData.cpmTemplateCode;
        poLnDatas.vendorStyleCode = poLnData.vendorStyleCode;
        poLnDatas.vendorStyleColorCode = poLnData.vendorStyleColorCode;
        poLnDatas.isFetched = false;
        poLnDatas.sts = poLnData.sts;
        poLnDatas.sailDate = poLnData.sailDate;
        poLnDatas.estimatedShipDate = poLnData.estimatedShipDate;
        poLnDatas.landedCost = poLnData.landedCost;
        poLnDatas.fobCost = poLnData.fobCost;
        poLnDatas.externalCustomerCode = poLnData.externalCustomerCode;
        poLnDatas.externalCustomerName = poLnData.externalCustomerName;
        poLnDatas.customerCode = poLnData.customerCode;
        poLnDatas.customerName = poLnData.customerName;
        poLnDatas.commentCode = poLnData.commentCode;
        poLnDatas.comments = poLnData.comments;
        poDatas.lines.push(poLnDatas);
      }
    }
    let documentData = poData.purchaseOrderDocuments;
    if (documentData != null) {
      for (let poDocumentData of documentData) {
        let documentObj = new PurchaseOrderDocumentBean();
        documentObj.purchaseOrderNumber = NEW_ENTRY;
        documentObj.documentName = poDocumentData.documentFilePath;
        documentObj.documentName = poDocumentData.documentName;
        documentObj.documentCode = poDocumentData.documentCode;
        documentObj.isFetched = false;
        documentObj.isDeleted = poDocumentData.deleted;
        poDatas.purchaseOrderDocuments.push(documentObj);
      }
    }
    poDatas.isFetched = false;
    this.setState({
      purchaseOrderData: poDatas,
      copyPoCode: "",
    });
    this.setVendorDetails(poData);
    this.closeAlertModalCallBack(false);
  };
  copyPOContinueError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  getPoLineImagePathMain = (fabricStyle) => {
    if (fabricStyle == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages.length <= 0) {
      return null;
    } else {
      let mainImage = new FabricStyleImageBean();
      for (var i = 0; i < fabricStyle.fabricStyleImages.length; i++) {
        if (
          fabricStyle.fabricStyleImages[i].imagePart == "Main" &&
          fabricStyle.fabricStyleImages[i].deleted == false
        ) {
          mainImage = fabricStyle.fabricStyleImages[i];
        }
      }
      let serviceURL = this.getImageURL();
      let imageName = mainImage.imageName;
      let imageURL = serviceURL + imageName;
      if (mainImage.deleted) {
        imageURL = "";
      }
      if (imageName == "") {
        return null;
      }
      if (imageURL == "") {
        return null;
      }
      return imageURL;
    }
  };
  getPoLineImagePathWeb = (fabricStyle) => {
    if (fabricStyle == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages.length <= 0) {
      return null;
    } else {
      let mainImage = new FabricStyleImageBean();
      for (var i = 0; i < fabricStyle.fabricStyleImages.length; i++) {
        if (
          fabricStyle.fabricStyleImages[i].imagePart == "Web" &&
          fabricStyle.fabricStyleImages[i].deleted == false
        ) {
          mainImage = fabricStyle.fabricStyleImages[i];
        }
      }
      let serviceURL = this.getImageURL();
      let imageName = mainImage.imageName;
      let imageURL = serviceURL + imageName;

      if (mainImage.deleted) {
        imageURL = "";
      }
      if (imageName == "") {
        return null;
      }
      if (imageURL == "") {
        return null;
      }
      return imageURL;
    }
  };
  getPoLineImagePathFront = (fabricStyle) => {
    if (fabricStyle == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages.length <= 0) {
      return null;
    } else {
      let mainImage = new FabricStyleImageBean();
      for (var i = 0; i < fabricStyle.fabricStyleImages.length; i++) {
        if (
          fabricStyle.fabricStyleImages[i].imagePart == "Front" &&
          fabricStyle.fabricStyleImages[i].deleted == false
        ) {
          mainImage = fabricStyle.fabricStyleImages[i];
        }
      }
      let serviceURL = this.getImageURL();
      let imageName = mainImage.imageName;
      let imageURL = serviceURL + imageName;

      if (mainImage.deleted) {
        imageURL = "";
      }

      if (imageName == "") {
        return null;
      }
      if (imageURL == "") {
        return null;
      }
      return imageURL;
    }
  };
  getPoLineImagePathBack = (fabricStyle) => {
    if (fabricStyle == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages.length <= 0) {
      return null;
    } else {
      let mainImage = new FabricStyleImageBean();
      for (var i = 0; i < fabricStyle.fabricStyleImages.length; i++) {
        if (
          fabricStyle.fabricStyleImages[i].imagePart == "Back" &&
          fabricStyle.fabricStyleImages[i].deleted == false
        ) {
          mainImage = fabricStyle.fabricStyleImages[i];
        }
      }
      let serviceURL = this.getImageURL();
      let imageName = mainImage.imageName;
      let imageURL = serviceURL + imageName;

      if (mainImage.deleted) {
        imageURL = "";
      }

      if (imageName == "") {
        return null;
      }
      if (imageURL == "") {
        return null;
      }
      return imageURL;
    }
  };
  getImageURL = () => {
    const { appData } = this.context;
    let serviceURL = appData.serviceURL;
    let imageURL = serviceURL + "/purchaseorderimages?file=";
    return imageURL;
  };
  getDocURL = () => {
    const { appData } = this.context;
    return appData.serviceURL + "/" + "purchaseorderdocuments?file=";
    // return appData.serviceURL + "/" + process.env.REACT_APP_ITEM_DOC_PATH;
  };
  validateSOAlocation = (lines) => {
    let isValidSOAlocation = false;
    let err_list = [];
    let errorMessage = "";
    if (lines == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(lines.fabricStyleCode)) {
        let errMsg = "fabricStyleCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(lines.fabricStyleName)) {
        let errMsg = "fabricStyleName is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }

      if (isEmptyString(lines.colorCode)) {
        let errMsg = "colorCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowPopupAlert: true,
      });
      isValidSOAlocation = false;
      this.setState({ errorList: err_list });
    } else {
      isValidSOAlocation = true;
    }
    return isValidSOAlocation;
  };
  validADQty = (lines) => {
    let isValidADQty = false;
    let err_list = [];
    let errorMessage = "";
    if (lines == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(lines.fabricStyleCode)) {
        let errMsg = "fabricStyleCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowPopupAlert: true,
      });
      isValidADQty = false;
      this.setState({ errorList: err_list });
    } else {
      isValidADQty = true;
    }
    return isValidADQty;
  };
  validateAddLineSOAlocation = (lines) => {
    let isLineFound = false;
    let err_list = [];
    let errorMessage = "";
    if (isEmptyString(lines.salesOrderNumber)) {
      let errMsg = "salesOrderNumber is Required";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    }
    if (err_list.length > 0) {
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowLineAlert: true,
      });
      isLineFound = false;
      this.setState({ errorList: err_list });
    } else {
      isLineFound = true;
    }
    return isLineFound;
  };
  validatePurchaseData = (poBean) => {
    let isValidData = false;
    let err_list = [];
    let errorMessage = "";
    if (poBean == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(poBean.vendorCode)) {
        let errMsg = "vendorCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(poBean.vendorName)) {
        let errMsg = "vendorName is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyArray(poBean.lines) || poBean.lines == null) {
        let errMsg = "No purchaseOrder Lines";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmpty(poBean.address)) {
        let errMsg = "Address is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmpty(poBean.orderType) && this.state.isShowOrderType) {
        let errMsg = "PO OrderType is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValidData = true;
      this.setState({ isShowAlert: false });
    }
    return isValidData;
  };
  validateLineData = (lines) => {
    let isLineFound = false;
    let err_list = [];
    let errorMessage = "";
    if (lines === null) {
      let errMsg = "Enter All Fields";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(lines.fabricStyleCode)) {
        let errMsg = "fabricStyleCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(lines.colorCode)) {
        let errMsg = "colorCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (lines.cost <= 0) {
        if (this.state.is3PL) {
          // No Error Message
        } else if (this.state.isTexco) {
          // No Error Message
        } else {
          let errMsg = "Cost is Required";
          errorMessage = errorMessage + errMsg;
          err_list.push(errMsg);
        }
      }
      if (isEmptyString(lines.orderQuantity)) {
        let errMsg = "orderQuantity is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (lines.skuNumber <= 0) {
        let errMsg = "Invalid Sku";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowPopupAlert: true,
      });
      isLineFound = false;
      this.setState({ errorList: err_list });
    } else {
      isLineFound = true;
    }
    return isLineFound;
  };
  clearAdjLines = () => {
    let lines = new PurchaseOrderLineAdjustmentBean();
    this.setState({
      purchaseOrderLineAdjustmentData: lines,
      reasonPageListForAutoCompleteList: new Array(),
    });
  };
  validateAdj = (lines) => {
    let isValidAdj = false;
    let err_list = [];
    let errorMessage = "";

    if (isEmptyString(lines.code)) {
      let errMsg = "Invalid ReasonCode is Required";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    }
    if (lines.adjustedQuantity <= 0) {
      let errMsg = "Adjusted Quantity is Required";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    }
    if (err_list.length > 0) {
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowLineAlert: true,
      });
      isValidAdj = false;
      this.setState({ errorList: err_list });
    } else {
      isValidAdj = true;
    }
    return isValidAdj;
  };
  onmiscellaneousChargeReasonCodeChange = (e) => {
    let miscellaneousChargeReasonCode = e.target.value;
    this.state.showAutoCompletemiscellaneousChargeReasonCodeList = true;
    let tempPurchaseOrderData = this.state.purchaseOrderData;
    let showAutoCompleteList =
      this.state.showAutoCompletemiscellaneousChargeReasonCodeList;
    if (isEmpty(miscellaneousChargeReasonCode)) {
      this.state.showAutoCompletemiscellaneousChargeReasonCodeList = false;
      let showAutoCompleteList =
        this.state.showAutoCompletemiscellaneousChargeReasonCodeList;
      let tempPurchaseOrderData = this.state.purchaseOrderData;
      tempPurchaseOrderData.miscellaneousChargeReasonCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompletemiscellaneousChargeReasonCodeList: showAutoCompleteList,
        purchaseOrderData: tempPurchaseOrderData,
        miscellaneousChargeReasonCodePageListForAutoCompleteList: suggestion,
      });
    } else if (
      showAutoCompleteList === true &&
      miscellaneousChargeReasonCode !== ""
    ) {
      this.readmiscellaneousReasonsBySearchString(
        miscellaneousChargeReasonCode,
      );
    }
    if (e.target.name == "miscellaneousChargeReasonCode") {
      tempPurchaseOrderData[e.target.name] = e.target.value;
      let miscellaneousReasons = this.state.miscellaneousReasons;
      miscellaneousReasons.map((miscellaneousReason) => {
        if (miscellaneousReason.code == e.target.value) {
          tempPurchaseOrderData["miscellaneousChargeReasonCode"] =
            miscellaneousReason.code;
          this.state.showAutoCompletemiscellaneousChargeReasonCodeList = false;
          let showAutoCompletemiscellaneousChargeReasonCodeList =
            this.state.showAutoCompletemiscellaneousChargeReasonCodeList;
          this.setState({
            showAutoCompletemiscellaneousChargeReasonCodeList:
              showAutoCompletemiscellaneousChargeReasonCodeList,
          });
        }
      });
    }
    this.setState({
      purchaseOrderData: tempPurchaseOrderData,
    });
  };
  readmiscellaneousReasonsBySearchString(searchString) {
    let miscellaneousReasons = this.state.miscellaneousReasons;
    let simpleAutoCompleteList = new Array();
    if (miscellaneousReasons.length > 0 && miscellaneousReasons != null) {
      miscellaneousReasons.map((miscellaneousReason) => {
        let simpleItemBean = {
          code: miscellaneousReason.code,
          description: miscellaneousReason.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletemiscellaneousReasonsLists) =>
        simpleAutoCompletemiscellaneousReasonsLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      miscellaneousChargeReasonCodePageListForAutoCompleteList:
        filteredSuggestions,
    });
  }
  miscellaneousChargeReasonCodeEnterKeyEventHandler = (e) => {
    let purchaseOrderData = this.state.purchaseOrderData;
    purchaseOrderData["miscellaneousChargeReasonCode"] = e.target.value;
    let miscList = this.state.miscellaneousReasons;
    let miscBean = null;
    miscList.map((inco) => {
      if (inco.code == e.target.value) {
        miscBean = inco;
      }
    });
    if (!isEmpty(miscBean)) {
      purchaseOrderData.miscellaneousChargeReasonCode = miscBean.code;

      this.setState({
        purchaseOrderData: purchaseOrderData,
        miscellaneousChargeReasonCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompletemiscellaneousChargeReasonCodeList = (
    showAutoCompletemiscellaneousChargeReasonCodeList,
  ) => {
    this.setState({
      showAutoCompletemiscellaneousChargeReasonCodeList:
        showAutoCompletemiscellaneousChargeReasonCodeList,
    });
  };
  displayAutoCompleteextraChargeReasonCodeList = (
    showAutoCompleteextraChargeReasonCodeList,
  ) => {
    this.setState({
      showAutoCompleteextraChargeReasonCodeList:
        showAutoCompleteextraChargeReasonCodeList,
    });
  };
  onextraChargeReasonCodeChange = (e) => {
    let extraChargeReasonCode = e.target.value;
    this.state.showAutoCompleteextraChargeReasonCodeList = true;
    let tempPurchaseOrderData = this.state.purchaseOrderData;
    let showAutoCompleteList =
      this.state.showAutoCompleteextraChargeReasonCodeList;
    if (isEmpty(extraChargeReasonCode)) {
      this.state.showAutoCompleteextraChargeReasonCodeList = false;
      let showAutoCompleteList =
        this.state.showAutoCompleteextraChargeReasonCodeList;
      let tempPurchaseOrderData = this.state.purchaseOrderData;
      tempPurchaseOrderData.extraChargeReasonCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteextraChargeReasonCodeList: showAutoCompleteList,
        purchaseOrderData: tempPurchaseOrderData,
        extraChargeReasonCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && extraChargeReasonCode !== "") {
      this.readextraChargeReasonsBySearchString(extraChargeReasonCode);
    }
    if (e.target.name == "extraChargeReasonCode") {
      tempPurchaseOrderData[e.target.name] = e.target.value;
      let extraChargeReasons = this.state.extraChargeReasons;
      extraChargeReasons.map((extraChargeReason) => {
        if (extraChargeReason.code == e.target.value) {
          tempPurchaseOrderData["extraChargeReasonCode"] =
            extraChargeReason.code;

          this.state.showAutoCompleteextraChargeReasonCodeList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteextraChargeReasonCodeList;
          this.setState({
            showAutoCompleteextraChargeReasonCodeList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({
      purchaseOrderData: tempPurchaseOrderData,
    });
  };
  readextraChargeReasonsBySearchString(searchString) {
    let extraChargeReason = this.state.extraChargeReasons;
    let simpleAutoCompleteList = new Array();
    if (extraChargeReason.length > 0 && extraChargeReason != null) {
      extraChargeReason.map((extraChargeReasons) => {
        let simpleItemBean = {
          code: extraChargeReasons.code,
          description: extraChargeReasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteextraChargeReasonsLists) =>
        simpleAutoCompleteextraChargeReasonsLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      extraChargeReasonCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  extraChargeReasonCodeEnterKeyEventHandler = (e) => {
    let purchaseOrderData = this.state.purchaseOrderData;
    purchaseOrderData["extraChargeReasonCode"] = e.target.value;
    let extraChargeList = this.state.extraChargeReasons;
    let extraChargeBean = null;
    extraChargeList.map((inco) => {
      if (inco.code == e.target.value) {
        extraChargeBean = inco;
      }
    });
    if (!isEmpty(extraChargeBean)) {
      purchaseOrderData.extraChargeReasonCode = extraChargeBean.code;

      this.setState({
        purchaseOrderData: purchaseOrderData,
        extraChargeReasonCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  customerOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.isShowAutoCompleteCustomerList = true;
    let tempData = this.state.purchaseOrderData;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.isShowAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
      let tempData = this.state.purchaseOrderData;
      tempData.customerCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        purchaseOrderData: tempData,
        customerPageListForAutoCompleteList: suggestion,
      });
      this.customerCleared();
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      setTimeout(() => {
        this.readCustomerBySearchString(e.target.value);
      }, 200);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ purchaseOrderData: tempData });
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 10;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readCustomerBySearchCodeResponse,
      this.readCustomerBySearchCodeError,
    );
  }
  readCustomerBySearchCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readCustomerBySearchCodeError = (error) => {
    ShowError("Error : " + error);
  };
  customerEnterKeyEventHandler = (e) => {
    this.readCustomer(e.target.value);
    this.state.isShowAutoCompleteCustomerList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayAutoCustomerCompleteList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  readCustomerResponse = (response) => {
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      let purchaseOrderData = this.state.purchaseOrderData;
      purchaseOrderData.customerCode = customerData.code;
      purchaseOrderData.customerName = customerData.description;
      this.setState({
        purchaseOrderData: purchaseOrderData,
      });
    }
  };
  readCustomerByCustomerCodeError = (error) => {
    ShowError("Error : " + error);
  };
  readCustomer = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    CustomerService.readCustomerWithChildren(
      readrestInput,
      this.readCustomerResponse,
      this.readCustomerByCustomerCodeError,
    );
  };
  customerCleared() {
    let tempData = this.state.purchaseOrderData;
    tempData.customerName = "";
  }
  addressClickHandler = (e) => {
    if (e.detail == 1) {
      let purchaseOrderData = this.state.purchaseOrderData;
      let addressData = new AddressBean();
      addressData = { ...purchaseOrderData.address };
      this.setState({ isShowAddressPopup: true, addressData: addressData });
    }
  };
  shippingAddressClickHandler = (e) => {
    if (e.detail == 1) {
      let purchaseOrderData = this.state.purchaseOrderData;
      let addressData = new AddressBean();
      addressData = { ...purchaseOrderData.shippingAddress };
      this.setState({ isShowShipAddressPopup: true, addressData: addressData });
    }
  };
  closeAlertAddressModalCallBack = () => {
    this.setState({
      isShowAddressPopup: false,
      isShowShipAddressPopup: false,
      addressData: new AddressBean(),
    });
  };
  addressOnChange = (e) => {
    let addressData = this.state.addressData;
    addressData[e.target.name] = e.target.value;
    this.setState({ addressData: addressData });
  };
  addressOnClick = () => {
    let purchaseOrderData = this.state.purchaseOrderData;
    let addressData = { ...this.state.addressData };
    purchaseOrderData.address = addressData;
    this.setState({ purchaseOrderData: purchaseOrderData });
    this.closeAlertAddressModalCallBack();
  };
  shippingAddressOnClick = () => {
    let purchaseOrderData = this.state.purchaseOrderData;
    let addressData = { ...this.state.addressData };
    purchaseOrderData.shippingAddress = addressData;
    this.setState({ purchaseOrderData: purchaseOrderData });
    this.closeAlertAddressModalCallBack();
  };
  onCityChange = (e) => {
    let city = e.target.value;
    this.state.showAutoCompleteCityList = true;
    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;
    if (isEmpty(city)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let addressData = this.state.addressData;
      addressData.city = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCityList: showAutoCompleteList,
        addressData: addressData,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && city !== "") {
      this.readCityBySearchString(city);
    }
    if (e.target.name == "city") {
      temp_addressData["city"] = e.target.value;
      let cityList = this.state.cityList;
      cityList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_addressData["city"] = pdtType.code;
          this.state.showAutoCompleteCityList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCityList;
          this.setState({ showAutoCompleteCityList: showAutoCompleteList });
        }
      });
    }
    this.setState({
      addressData: temp_addressData,
    });
  };
  readCityBySearchString(searchString) {
    let cityData = this.state.cityList;
    let simpleAutoCompleteList = new Array();
    if (cityData.length > 0 && cityData != null) {
      cityData.map((cityDatas) => {
        let simpleItemBean = {
          code: cityDatas.code,
          description: cityDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ cityPageListForAutoCompleteList: filteredSuggestions });
  }
  cityEnterKeyEventHandler = (e) => {
    let city = e.target.value;
    let city_List = this.state.cityList;
    let cityBean = null;
    city_List.map((city) => {
      if (city.code == e.target.value) {
        cityBean = city;
      }
    });
    if (!isEmpty(cityBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.city = cityBean.code;
      this.setState({
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCityList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCityList: showAutoCompleteList });
  };
  onStateChange = (e) => {
    let state = e.target.value;
    this.state.showAutoCompleteStateList = true;

    let temp_addressData = this.state.addressData;

    let showAutoCompleteList = this.state.showAutoCompleteStateList;
    if (isEmpty(state)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let addressData = this.state.addressData;

      addressData.state = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteStateList: showAutoCompleteList,
        addressData: addressData,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && state !== "") {
      this.readStateBySearchString(state);
    }
    if (e.target.name == "state") {
      temp_addressData["state"] = e.target.value;
      let stateList = this.state.stateList;
      stateList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_addressData["state"] = pdtType.code;
          this.state.showAutoCompleteStateList = false;
          let showAutoCompleteList = this.state.showAutoCompleteStateList;
          this.setState({ showAutoCompleteStateList: showAutoCompleteList });
        }
      });
    }

    this.setState({
      addressData: temp_addressData,
    });
  };
  readStateBySearchString(searchString) {
    let stateData = this.state.stateList;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ statePageListForAutoCompleteList: filteredSuggestions });
  }
  stateEnterKeyEventHandler = (e) => {
    let state = e.target.value;
    let state_List = this.state.stateList;
    let stateBean = null;
    state_List.map((state) => {
      if (state.code == e.target.value) {
        stateBean = state;
      }
    });
    if (!isEmpty(stateBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.state = stateBean.code;

      this.setState({
        addressData: temp_addressData,
        statePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteStateList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteStateList: showAutoCompleteList });
  };
  onCountryChange = (e) => {
    let country = e.target.value;
    this.state.showAutoCompleteCountryList = true;

    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryList;
    if (isEmpty(country)) {
      this.state.showAutoCompleteCountryList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryList;
      let addressData = this.state.addressData;
      addressData.country = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCountryList: showAutoCompleteList,
        addressData: addressData,
        countryPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && country !== "") {
      this.readCountryBySearchString(country);
    }
    if (e.target.name == "country") {
      temp_addressData["country"] = e.target.value;
      let countryList = this.state.countryList;
      countryList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_addressData["country"] = pdtType.code;
          this.state.showAutoCompleteCountryList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryList;
          this.setState({ showAutoCompleteCountryList: showAutoCompleteList });
        }
      });
    }
    this.setState({
      addressData: temp_addressData,
    });
  };
  readCountryBySearchString(searchString) {
    let stateData = this.state.countryList;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ countryPageListForAutoCompleteList: filteredSuggestions });
  }
  countryEnterKeyEventHandler = (e) => {
    let country = e.target.value;
    let country_List = this.state.countryList;
    let countryBean = null;
    country_List.map((country) => {
      if (country.code == e.target.value) {
        countryBean = country;
      }
    });
    if (!isEmpty(countryBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.country = countryBean.code;
      this.setState({
        addressData: temp_addressData,
        countryPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCountryList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCountryList: showAutoCompleteList });
  };
  onbusinessDivisionChange = (e) => {
    let businessDivision = e.target.value;
    this.state.showAutoCompleteBusinessDivisionList = true;
    let tempPurchaseOrderData = this.state.purchaseOrderData;
    let showAutoCompleteList = this.state.showAutoCompleteBusinessDivisionList;
    if (isEmpty(businessDivision)) {
      this.state.showAutoCompleteBusinessDivisionList = false;
      let showAutoCompleteList =
        this.state.showAutoCompleteBusinessDivisionList;
      let tempPurchaseOrderData = this.state.purchaseOrderData;
      tempPurchaseOrderData.businessDivision = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        purchaseOrderData: tempPurchaseOrderData,
        businessDivisionPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && businessDivision !== "") {
      this.readbusinessDivisionSearchString(businessDivision);
    }
    if (e.target.name == "businessDivision") {
      tempPurchaseOrderData[e.target.name] = e.target.value;
      let businessDivisionCityList = this.state.businessDivisions;
      businessDivisionCityList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          tempPurchaseOrderData["businessDivision"] = pdtType.code;
          this.state.showAutoCompleteBusinessDivisionList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteBusinessDivisionList;
          this.setState({
            showAutoCompleteBusinessDivisionList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({
      purchaseOrderData: tempPurchaseOrderData,
    });
  };
  readbusinessDivisionSearchString(searchString) {
    let businessData = this.state.businessDivisions;
    let simpleAutoCompleteList = new Array();
    if (businessData.length > 0 && businessData != null) {
      businessData.map((bd) => {
        let simpleItemBean = { code: bd.code, description: bd.description };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletebusinessLists) =>
        simpleAutoCompletebusinessLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      businessDivisionPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  businessDivisionEnterKeyEventHandler = (e) => {
    let purchaseOrderData = this.state.purchaseOrderData;
    purchaseOrderData["businessDivision"] = e.target.value;
    let fobList = this.state.businessDivisions;
    let businessBean = null;
    fobList.map((fb) => {
      if (fb.code == e.target.value) {
        businessBean = fb;
      }
    });
    if (!isEmpty(businessBean)) {
      purchaseOrderData.businessDivision = businessBean.code;

      this.setState({
        purchaseOrderData: purchaseOrderData,
        businessDivisionPageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompleteBusinessDivisionList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteBusinessDivisionList: showAutoCompleteList,
    });
  };

  onorderTypeChange = (e) => {
    let orderType = e.target.value;
    this.state.showAutoCompleteOrderTypeList = true;
    let tempPurchaseOrderData = this.state.purchaseOrderData;
    let showAutoCompleteList = this.state.showAutoCompleteOrderTypeList;
    if (isEmpty(orderType)) {
      this.state.showAutoCompleteOrderTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteOrderTypeList;
      let tempPurchaseOrderData = this.state.purchaseOrderData;
      tempPurchaseOrderData.orderType = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        purchaseOrderData: tempPurchaseOrderData,
        orderTypePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && orderType !== "") {
      this.readorderTypeSearchString(orderType);
    }
    if (e.target.name == "orderType") {
      tempPurchaseOrderData[e.target.name] = e.target.value;
      let orderTypesCityList = this.state.purchaseOrderTypes;
      orderTypesCityList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          tempPurchaseOrderData["orderType"] = pdtType.code;
          this.state.showAutoCompleteOrderTypeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteOrderTypeList;
          this.setState({
            showAutoCompleteOrderTypeList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({
      purchaseOrderData: tempPurchaseOrderData,
    });
  };
  readorderTypeSearchString(searchString) {
    let orderTypeData = this.state.purchaseOrderTypes;
    let simpleAutoCompleteList = new Array();
    if (orderTypeData.length > 0 && orderTypeData != null) {
      orderTypeData.map((bd) => {
        let simpleItemBean = { code: bd.code, description: bd.description };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteOrderLists) =>
        simpleAutoCompleteOrderLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      orderTypePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  orderTypeEnterKeyEventHandler = (e) => {
    let purchaseOrderData = this.state.purchaseOrderData;
    purchaseOrderData["orderType"] = e.target.value;
    let orderTypes = this.state.purchaseOrderTypes;
    let orderTypeBean = null;
    orderTypes.map((fb) => {
      if (fb.code == e.target.value) {
        orderTypeBean = fb;
      }
    });
    if (!isEmpty(orderTypeBean)) {
      purchaseOrderData.orderType = orderTypeBean.code;

      this.setState({
        purchaseOrderData: purchaseOrderData,
        orderTypePageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompleteOrderTypeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteOrderTypeList: showAutoCompleteList });
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let purchaseOrderList = this.state.purchaseOrderListData;
    if (sortField && !isEmptyArray(purchaseOrderList)) {
      const sorted = [...purchaseOrderList].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ purchaseOrderListData: sorted });
    }
  };

  onfabricBlur = (e) => {
    if (this.state.isAllowRead == false && e.target.value != "") {
      this.readSelectedFabricStyle(this.state.fabricStyleCode);
    }

    if (e.target.value == "") {
      this.state.purchaseOrderLineData.fabricStyleName = "";

      this.state.purchaseOrderLineData.colorCode = "";

      this.state.colorList = [];
      this.state.isShowColorLookup = false;
    }
  };

  getPOLinebySKUNumber = (lineNumber) => {
    let poLine = null;
    if (this.state.purchaseOrderData === null) return poLine;
    else if (this.state.purchaseOrderData.lines === null) return poLine;
    else {
      this.state.purchaseOrderData.lines.map((line) => {
        if (line.lineNumber === lineNumber) {
          poLine = line;
          return poLine;
        }
      });
    }
    return poLine;
  };
  getPOMaxLineNumber() {
    let maxLineNumber = 0;
    let poLines = this.state.purchaseOrderData.lines;
    if (poLines.length > 0)
      poLines.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  }
  onKeyPress = (e) => {
    if (e.keyCode == 120) {
      this.addorUpdateMultiplePOLine();
    }
  };

  addorUpdateMultiplePOLine = (e) => {
    let poLine = this.state.purchaseOrderLineData;
    poLine.openQuantity = poLine.orderQuantity;

    let poData = this.state.purchaseOrderData;

    // FIX: block zero-cost lines when isAllowZeroCostFlag is false
    const cost = parseFloat(poLine.cost) || 0;
    if (!poData.isAllowZeroCostFlag && cost === 0) {
      this.setState({
        alertMessage: [
          "Cost cannot be zero when 'Allow Zero Cost' is disabled.",
        ],
        alertType: "error",
        isShowPopupAlert: true,
      });
      return; // stop — do not add/update the line
    }

    let isValid = false;
    isValid = this.validateLineData(poLine);
    if (isValid) {
      let purchaseOrderLinesList = this.state.purchaseOrderData.lines;
      let existingLine = this.getPOLinebySKUNumber(poLine.lineNumber);

      if (existingLine === null) {
        var lineNumber = this.getPOMaxLineNumber();
        poLine.lineNumber = ++lineNumber;
        poData.lines.push(poLine);
      } else {
        const index = poData.lines.findIndex(
          (ln) => ln.lineNumber === existingLine.lineNumber,
        );
        if (index != -1) {
          poLine.isFetched = existingLine.isFetched;
          poLine.salesOrderLineNumber = existingLine.salesOrderLineNumber;
          this.calculatePurchaseOrderAmounts();
          poData.lines.splice(index, 1);
          poData.lines.push(poLine);
        }
      }

      this.setState({
        purchaseOrderData: poData,
        poLinesList: purchaseOrderLinesList,
      });

      this.closeAlertModalCallBack(false);
      this.clearLineValues(e);
    }
  };
  render() {
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let poList = this.state.poList;
    let excelIncompletePOList = this.state.excelIncompletePOList;
    let purchaseOrderData = this.state.purchaseOrderData;
    var styles = {
      header: {
        style: {
          minHeight: "0px",
        },
      },
      table: {
        style: {
          minHeight: "359px",
          maxHeight: "359px",
        },
      },
    };
    let mailInfoData = this.state.mailInfoData;
    const textAreaStyle = {
      maxHeight: "75px",
      minHeight: "9em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    let purchaseOrderLookupHandler = this.state.purchaseOrderLookupHandler;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        {this.state.isSpecialViewMode == false ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <ModuleToolBar
          isShowNewButton={false}
          onNewEntry={() => this.addNewEntry()}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          // isMaintenanceMode={!this.state.isPurchaseOrderListFormOpen}
          isMaintenanceMode={this.state.isMaintenanceMode}
          onModuleKeyContainerButtonClick={this.editPurchaseOrder}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.purchaseOrderLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          selectButtonClick={this.selectButtonClick}
          disabled={this.state.disabled}
          isSpecialViewMode={this.state.isSpecialViewMode}
          isResetView={this.state.isResetView}
          isFocusLookup={this.state.isFocusLookup}
        />

        {!this.state.isPurchaseOrderListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              pageTitle={this.state.pageTitle}
              back={this.back}
              //isShowBackButton={this.state.isShowBackButton}
              save={this.save}
              isShowSaveButton={this.state.isShowSaveButton}
              clearError={this.clearError}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              generatePDF={this.generatePDF}
              isShowPDFButton={this.state.isShowPDFReportButton}
              extend_toolbar={
                <>
                  {this.state.isShowUnApproveButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.unApprovePurchaseOrder(e)}
                    >
                      UnApprove
                    </Button>
                  )}
                  {this.state.isShowApproveButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.approvePurchaseOrder(e)}
                    >
                      Approve
                    </Button>
                  )}
                  {this.state.isShowCancelButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.cancelPurchaseOrder(e)}
                    >
                      Cancel
                    </Button>
                  )}
                  {this.state.isShowExcelButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.generateExcel(e)}
                    >
                      <ExcelIcon />
                      Excel
                    </Button>
                  )}
                  {this.state.isShowMailButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.sendPOMail(e)}
                    >
                      Mail
                    </Button>
                  )}
                  {this.state.isShowAppproveAndPrintButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.approveAndPrintPO(e)}
                    >
                      Approve+Print
                    </Button>
                  )}
                  {this.state.isShowCopyPOButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.copyPO(e)}
                    >
                      Copy PO
                    </Button>
                  )}
                </>
              }
            />
          )}

        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedModuleKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
            moduleStatus={moduleOrderStatus}
          />
        )}

        {!this.state.isShowNodes &&
          !this.state.isPurchaseOrderListFormOpen &&
          !this.state.isPurchaseOrderDetailFormOpened &&
          !this.state.isPurchaseOrderHistoryFormOpened &&
          !this.state.isPurchaseReceiptFormOpened &&
          this.state.isPurchaseOrderEntryFormOpen &&
          !this.state.isPaymentDetailViewOpen &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isPurchaseOrderListFormOpen &&
          !this.state.isPurchaseOrderDetailFormOpened &&
          !this.state.isPurchaseOrderHistoryFormOpened &&
          !this.state.isPurchaseReceiptFormOpened &&
          this.state.isPurchaseOrderEntryFormOpen &&
          !this.state.isPaymentDetailViewOpen &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isPurchaseOrderListFormOpen &&
          !this.state.isPurchaseOrderEntryFormOpen &&
          !this.state.isPurchaseOrderHistoryFormOpened &&
          !this.state.isPurchaseReceiptFormOpened &&
          this.state.isPurchaseOrderDetailFormOpened &&
          !this.state.isPaymentDetailViewOpen &&
          this.getOrderDetailsView()}
        {this.state.isShowNodes &&
          !this.state.isPurchaseOrderListFormOpen &&
          !this.state.isPurchaseOrderEntryFormOpen &&
          !this.state.isPurchaseOrderDetailFormOpened &&
          !this.state.isPurchaseReceiptFormOpened &&
          this.state.isPurchaseOrderHistoryFormOpened &&
          !this.state.isPaymentDetailViewOpen &&
          this.getOrderHistoryView()}
        {this.state.isShowNodes &&
          !this.state.isPurchaseOrderListFormOpen &&
          !this.state.isPurchaseOrderEntryFormOpen &&
          !this.state.isPurchaseOrderDetailFormOpened &&
          !this.state.isPurchaseOrderHistoryFormOpened &&
          this.state.isPurchaseReceiptFormOpened &&
          !this.state.isPaymentDetailViewOpen &&
          this.getOrderReceiptView()}
        {this.state.isShowNodes &&
          !this.state.isPurchaseOrderListFormOpen &&
          !this.state.isPurchaseOrderEntryFormOpen &&
          !this.state.isPurchaseOrderDetailFormOpened &&
          !this.state.isPurchaseOrderHistoryFormOpened &&
          !this.state.isPurchaseReceiptFormOpened &&
          !this.state.isPurchaseOrderDocumentFormOpened &&
          !this.state.isPurchaseOrderModelDocumentFormOpened &&
          this.state.isPurchaseOrderImageFormOpened &&
          !this.state.isPaymentDetailViewOpen &&
          this.getImageFormView()}
        {this.state.isShowNodes &&
          !this.state.isPurchaseOrderListFormOpen &&
          !this.state.isPurchaseOrderEntryFormOpen &&
          !this.state.isPurchaseOrderDetailFormOpened &&
          !this.state.isPurchaseOrderHistoryFormOpened &&
          !this.state.isPurchaseOrderImageFormOpened &&
          !this.state.isPurchaseReceiptFormOpened &&
          !this.state.isPurchaseOrderModelDocumentFormOpened &&
          this.state.isPurchaseOrderDocumentFormOpened &&
          !this.state.isPaymentDetailViewOpen &&
          this.getDocumentMutipleFormView()}
        {this.state.isShowNodes &&
          !this.state.isPurchaseOrderListFormOpen &&
          !this.state.isPurchaseOrderEntryFormOpen &&
          !this.state.isPurchaseOrderDetailFormOpened &&
          !this.state.isPurchaseOrderHistoryFormOpened &&
          !this.state.isPurchaseOrderImageFormOpened &&
          !this.state.isPurchaseReceiptFormOpened &&
          !this.state.isPurchaseOrderModelDocumentFormOpened &&
          !this.state.isPurchaseOrderDocumentFormOpened &&
          this.state.isPaymentDetailViewOpen &&
          this.getPaymentDetailView()}

        {/* {this.state.isShowNodes &&
          !this.state.isPurchaseOrderListFormOpen &&
          !this.state.isPurchaseOrderEntryFormOpen &&
          !this.state.isPurchaseOrderDetailFormOpened &&
          !this.state.isPurchaseOrderHistoryFormOpened &&
          !this.state.isPurchaseOrderImageFormOpened &&
          !this.state.isPurchaseReceiptFormOpened &&
          !this.state.isPurchaseOrderDocumentFormOpened &&
          this.state.isPurchaseOrderModelDocumentFormOpened &&
          this.getModelDocumentView()} */}
        {/*this.state.isShowNodes && 
        	this.state.isPurchaseReceiptFormOpened &&
            this.getPurchaseReceiptFormView()
             	
        */}
        {/* <BaseNotification error_list={this.state.error_list} /> */}
        {this.state.isPurchaseOrderListFormOpen &&
          this.state.isSpecialViewMode == false && (
            <PurchaseOrderListForm
              {...this.state}
              filterPurchaseOrder={this.filterPurchaseOrder}
              loadFirst={this.loadFirst}
              loadNext={this.loadNext}
              loadPrevious={this.loadPrevious}
              loadLast={this.loadLast}
              editPurchaseOrder={this.editPurchaseOrder}
              onChange={this.onCriteriaChange}
              resetFilteredPurchaseOrder={this.resetFilteredPurchaseOrder}
              handleSortingChange={this.handleSortingChange}
            />
          )}
        <AddressComponent
          {...this.state}
          isShowPopup={this.state.isShowAddressPopup}
          // addressData={this.state.addressData}
          title={"Address"}
          closeAlertAddressModalCallBack={this.closeAlertAddressModalCallBack}
          onChange={this.addressOnChange}
          onClick={this.addressOnClick}
          disabled={this.state.disablePurchaseOrderFormFields}
          // cityList={this.state.cityList}
          onCityChange={this.onCityChange}
          cityEnterKeyEventHandler={this.cityEnterKeyEventHandler}
          displayAutoCompleteCityList={this.displayAutoCompleteCityList}
          onStateChange={this.onStateChange}
          stateEnterKeyEventHandler={this.stateEnterKeyEventHandler}
          displayAutoCompleteStateList={this.displayAutoCompleteStateList}
          onCountryChange={this.onCountryChange}
          countryEnterKeyEventHandler={this.countryEnterKeyEventHandler}
          displayAutoCompleteCountryList={this.displayAutoCompleteCountryList}
        />
        <AddressComponent
          {...this.state}
          isShowPopup={this.state.isShowShipAddressPopup}
          // addressData={this.state.addressData}
          title={"Shipping Address"}
          closeAlertAddressModalCallBack={this.closeAlertAddressModalCallBack}
          onChange={this.addressOnChange}
          onClick={this.shippingAddressOnClick}
          disabled={this.state.isDisableShippingAdd}
          // cityList={this.state.cityList}
          onCityChange={this.onCityChange}
          cityEnterKeyEventHandler={this.cityEnterKeyEventHandler}
          displayAutoCompleteCityList={this.displayAutoCompleteCityList}
          onStateChange={this.onStateChange}
          stateEnterKeyEventHandler={this.stateEnterKeyEventHandler}
          displayAutoCompleteStateList={this.displayAutoCompleteStateList}
          onCountryChange={this.onCountryChange}
          countryEnterKeyEventHandler={this.countryEnterKeyEventHandler}
          displayAutoCompleteCountryList={this.displayAutoCompleteCountryList}
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={true}
          id="moduleSalesPopup"
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.state.isShowMailInvoicePopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Mailing Purchase Order"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          // headerButtonContainer={

          // }
          content={
            <div className="PurchaseOrderPopup">
              <div>
                <Row>
                  <Col sm="1">
                    <FormLabel>From</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={mailInfoData.from}
                      onChange={this.onChange}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>TOs</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={mailInfoData.tos}
                      onChange={this.onChange}
                      disabled={false}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>CCs</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={mailInfoData.ccs}
                      onChange={this.onChange}
                      disabled={false}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>BCCs</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={mailInfoData.bccs}
                      onChange={this.onChange}
                      disabled={false}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>Title</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={mailInfoData.title}
                      onChange={this.onChange}
                      disabled={false}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>Attachments</FormLabel>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <textarea
                      style={textAreaStyle}
                      className="form-control"
                      name="message"
                      type="text"
                      onChange={this.onChange}
                      value={mailInfoData.message}
                    />
                  </Col>
                </Row>
                <Row>
                  <Button
                    className="header_buttons"
                    size="sm"
                    onClick={(e) => this.mailInvoiceContinue(e)}
                  >
                    Continue
                  </Button>
                </Row>
              </div>
            </div>
          }
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel6"}
          isModulePopup={false}
          isShowPopup={this.state.isShowCopyPOPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Copy PO"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                onClick={(e) => this.copyPOContinue(e)}
              >
                Continue
              </Button>
            </div>
          }
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowCopyPoAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div className="PurchaseOrderPopup">
              <div>
                <Row>
                  <Col sm="">
                    <FormLabel>PO</FormLabel>
                  </Col>
                  <Col sm="">
                    <InputTextbox
                      onChange={this.onCopyPOChange}
                      ref={this.purchaseOrderRef}
                      name="copyPoCode"
                      placeholder="copyPoCode"
                      value={this.state.copyPoCode}
                      lookupRequired={true}
                      lookupHandler={purchaseOrderLookupHandler}
                      enterKeyEventHandler={
                        this.purchaseOrderEnterKeyEventHandler
                      }
                      autoCompleteListData={
                        this.state.purchaseOrderPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayAutoCompletePurchaseOrderList
                      }
                      showAutoCompleteList={
                        this.state.showAutoCompletePurchaseOrderList
                      }
                      isMandatory={true}
                    />
                  </Col>
                </Row>
                {/* <Row>
                  <Button onClick={this.copyPOContinue}>Continue</Button>
                </Row> */}
              </div>
            </div>
          }
        />
        {/*{this.state.isPurchaseOrderEntryFormOpen &&
          this.state.selectedNodeKey == "headerView" && (
            <PurchaseOrderForm
              {...this.state}
              back={this.back}
              save={this.save}
              clearError={this.clearError}
              savePurchaseOrder={this.savePurchaseOrder}
              onChange={this.onChange}
              onDateChange={this.onDateChange}
              onVendorCodeChange={this.onVendorCodeChange}
              purchaseOrderData={this.state.purchaseOrderData}
              addressOnChange={this.addressOnChange}
              
            />
          )}
        {this.state.isPurchaseOrderEntryFormOpen &&
          this.state.selectedNodeKey == "orderDetailView" && (
            <PurchaseOrderDetailsForm
              {...this.state}
              back={this.back}
              save={this.save}
              clearError={this.clearError}
              savePurchaseOrder={this.savePurchaseOrder}
              onChange={this.onChange}
              onDateChange={this.onDateChange}
              onVendorCodeChange={this.onVendorCodeChange}
              onLineChange={this.onLineChange}
              addOrUpdateLineChange={this.addOrUpdateLineChange}
              handleItemAutocompleteSearch={this.handleItemAutocompleteSearch}
              addNewPOLine={this.addNewPOLine}
              //purchaseOrderData={this.state.purchaseOrderData}
            />
          )}
        {this.state.isPurchaseOrderEntryFormOpen &&
          this.state.selectedNodeKey == "orderHistoryView" && (
            <PurchaseOrderHistoryDetailsForm
              purchaseOrderData={this.state.purchaseOrderData}
            />
          )}
        {this.state.isPurchaseOrderEntryFormOpen &&
        	this.state.isPurchaseReceiptFormOpened &&
            this.state.selectedNodeKey == "orderReceiptView" && (
              <PurchaseReceiptForm
                purchaseOrderData={this.state.purchaseOrderData}
                dependenciesBean = {this.state.dependenciesBean}
              />
            )}*/}
        <ReasonCaptureComponent
          ref={this.unapproveReasonDialogRef}
          reasons={this.state.unapprovalReasons}
          reasonData={this.state.reasonData}
          title="PurchaseOrder UnApprove"
          onChange={this.onUnApproveReasonChange}
          onClick={this.onUnApproveReasonContinue}
          isShowPopup={this.state.isShowUnApproveReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.unApproveReasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.unApproveReasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={
            this.displayAutoCompleteUnApproveReasonList
          }
          showAutoCompleteReasonList={
            this.state.showAutoCompleteUnApproveReasonList
          }
          onReasonDescChange={this.onReasonDescChange}
        />
        <ReasonCaptureComponent
          ref={this.cancelReasonDialogRef}
          reasons={this.state.cancelReasons}
          reasonData={this.state.reasonData}
          title="PurchaseOrder Cancel"
          onChange={this.onReasonChange}
          onClick={this.onCancelReasonContinue}
          isShowPopup={this.state.isShowCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />
        <ReasonCaptureComponent
          ref={this.lineCancelReasonDialogRef}
          reasons={this.state.cancelReasons}
          reasonData={this.state.reasonData}
          title="PurchaseOrder Line Cancel"
          onChange={this.onReasonChange}
          onClick={this.onLineCancelReasonContinue}
          isShowPopup={this.state.isShowLineCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowCostDetail}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={false}
        ></MultiViewPopup>
      </div>
    );
  }
}
class PurchaseOrderListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      criteria: new PurchaseOrderSearchCriteria(),
      filter: "",
      pageList: this.props.pageList,
    };
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  filterPurchaseOrder = (e) => {
    if (e.detail == 1) this.props.filterPurchaseOrder();
  };
  resetfilteredPurchaseOrder = (e) => {
    let criteria = this.props.criteria;
    if (e.detail == 1) this.props.resetFilteredPurchaseOrder(criteria);
  };
  loadFirst = (e) => {
    if (e.detail == 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail == 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail == 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail == 1) this.props.loadLast();
  };
  handlePurchaseOrderCodeChange = (event) => {
    this.setState({ filter: event.target.value });
  };
  editPurchaseOrder = (e, val) => {
    if (e.detail == 1) this.props.editPurchaseOrder(val);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterPurchaseOrder();
    }
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
   purchasePagePageColumns = () => {
      const columns = new Array();
      columns.push(
        new ColumnDefinition()
          .setDetails("PurchaseOrder#", "code", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3")
          .setClickDetails(true, false, this.editPurchaseOrder, null),
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("VendorCode", "vendorCode", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3"),
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("VendorName", "vendorName", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3"),
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("FabricStyle", "fabricStyleCode", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3"),
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("PurchaseDate", "orderDate", true, false, true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3"),
      );
            columns.push(
        new ColumnDefinition()
          .setDetails("OrderType", "orderType", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3")
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("Status", "orderStatus", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3")
          .setStatusDetails(true, this.getCaption),
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("BuyingTerms", "buyingTermsCode", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3"),
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("GrandTotalAmt", "grandTotalAmount", true, true)
          .setStyleDetails("right", "", "", "wt-3", "wt-3"),
      );
      return columns;
    };
    getCaption = (status) => {
      return ModuleUtils.getPurchaseOrderStatusCaption(status);
    };
  render() {
    let purchaseOrderList = new Array();
    if (!isEmptyArray(this.props.purchaseOrderListData))
      purchaseOrderList = this.props.purchaseOrderListData;
    let criteria = this.props.criteria;
    let pageList = this.props.pageList;

    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    return (
      <div>
        <div className="secondary_module_header">
          {/* <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                name="searchName"
                type="text"
                placeholder="Enter Value to Filter.."
                value={criteria.searchName}
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
              <span className="px-2"></span>
              <Button onClick={(e) => this.filterPurchaseOrder(e)}>
                Filter
              </Button>
              <span className="px-2"></span>
              <Button onClick={(e) => this.resetfilteredPurchaseOrder(e)}>
                Reset
              </Button>
            </span>
          </div> */}
          <div className="mdle-criteria-wrap">
            <div className="">
              <FormLabel className="criteria-labl">Status</FormLabel>
            </div>
            <div className="criteria-val">
              <FormControl
                as="select"
                custom
                onChange={this.onChange}
                name="orderStatus"
                value={criteria.orderStatus}
              >
                <option value={""}>All</option>
                <option value={"A"}>Approved</option>
                <option value={"U"}>UnApproved</option>
                <option value={"R"}>Received</option>
                <option value={"I"}>Partially Received</option>
                <option value={"H"}>Force Close</option>
                <option value={"X"}>Cancelled</option>
              </FormControl>
            </div>
            <div className="">
              <FormLabel className="criteria-labl">Search</FormLabel>
            </div>
            <div className="criteria-val">
              <InputTextbox
                name="searchName"
                type="text"
                placeholder="Enter Value to Filter.."
                value={criteria.searchName}
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
            </div>
            <div className="criteria-btn-wrap ">
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.filterPurchaseOrder(e)}
              >
                Filter
              </Button>
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.resetfilteredPurchaseOrder(e)}
              >
                Reset
              </Button>
            </div>
          </div>

          <div className="module_header_secondary_buttons">
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
          <div className="mt-3">
                  <CustomTable
                    data={purchaseOrderList}
                    columns={this.purchasePagePageColumns()}
                    enableHighlight={true} // Boolean flag controlling highlight execution
                    //  searchText={pickTicketCriteria.searchName} // Search input text
                  />
                </div>
                
        {/* <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  PurchaseOrder#
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "vendorCode")}>
                  VendorCode
                  {this.props.order === "desc" &&
                  this.props.sortField === "vendorCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "vendorName")}>
                  VendorName
                  {this.props.order === "desc" &&
                  this.props.sortField === "vendorName" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "fabricStyleCode")
                  }
                >
                  FabricStyle
                  {this.props.order === "desc" &&
                  this.props.sortField === "fabricStyleCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "orderDate")}>
                  PurchaseDate
                  {this.props.order === "desc" &&
                  this.props.sortField === "orderDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "orderType")}>
                  OrderType
                  {this.props.order === "desc" &&
                  this.props.sortField === "orderType" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "orderStatus")}>
                  Status
                  {this.props.order === "desc" &&
                  this.props.sortField === "orderStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "buyingTermsCode")
                  }
                >
                  BuyingTerms
                  {this.props.order === "desc" &&
                  this.props.sortField === "buyingTermsCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "grandTotalAmount")
                  }
                >
                  GrandTotalAmt
                  {this.props.order === "desc" &&
                  this.props.sortField === "grandTotalAmount" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            <tbody>
              {purchaseOrderList.map((po, index) => (
                <tr key={index}>
                  <td>
                    <Button
                      size="sm"
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) => this.editPurchaseOrder(e, po.code)}
                    >
                      {po.code}
                    </Button>
                  </td>
                  <td>{po.vendorCode}</td>
                  <td>{po.vendorName}</td>
                  <td>{po.fabricStyleCode}</td>
                  <td>{ModuleUtils.getDateFormat_v1(po.orderDate)}</td>
                  <td>{po.orderType}</td>
                  <td>
                    {ModuleUtils.getPurchaseOrderStatusCaption(po.orderStatus)}
                  </td>
                  <td>{po.buyingTermsCode}</td>
                  <td className="text-end">
                    {toCommaSeperatedAmount(po.grandTotalAmount)}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div> */}
      </div>
    );
  }
}
class PurchaseOrderForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.vendorCodeRef = React.createRef();

    this.state = {
      //
      isShowVendorModule: false,
      isShowVendorOnOrderInq: false,
      isShowVendorPurchaseHistoryInq: false,
      // isShowVendorHistoryModule: false,
      // isShowVendorPurchaseHistoryPopup: false,
      // isShowOpenVendorPopup: false,
      moduleForPopup: [],
      customerLookupHandler: null,
    };
    this.extraChargeReasonCodeRef = React.createRef();
    this.miscellaneousChargeReasonCodeRef = React.createRef();
    this.customerRef = React.createRef();
    this.fobCityRef = React.createRef();
    this.warehouseRef = React.createRef();
    this.paymentTermRef = React.createRef();
    this.vendorTermRef = React.createRef();
    this.transportTypeRef = React.createRef();
    this.incoTermRef = React.createRef();
    this.fabricStyleCodeRef = React.createRef();
    this.shipmentTermRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.purchaseOrder_data_url =
      appData.serviceURL + "/PurchaseOrderRestService";
    this.fabricStyle_data_url = appData.serviceURL + "/FabricStyleRestService";
    this.customer_data_url = appData.serviceURL + "/CustomerRestService";
    this.salesOrder_data_url = appData.serviceURL + "/SalesOrderRestService";
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    this.setInputFocus();
  }
  componentDidUpdate() {}
  setInputFocus() {
    if (this.customerRef.current != null) {
      this.customerRef.current.focus();
    }
    if (this.vendorCodeRef.current != null) {
      this.vendorCodeRef.current.focus();
    }
  }
  initLookupHandlers = () => {
    let paymentTermLookupHandler = new GenericAttributeLookupHandler(
      this.props.paymentTerms,
      "Payment Term",
    );
    this.setState({ paymentTermLookupHandler: paymentTermLookupHandler });
    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.props.wareHouses,
      "Warehouse",
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });
    let transportTypeLookupHandler = new GenericAttributeLookupHandler(
      this.props.transportTypes,
      "TransportType",
    );
    this.setState({ transportTypeLookupHandler: transportTypeLookupHandler });
    let shipmentTermLookupHandler = new GenericAttributeLookupHandler(
      this.props.shipmentTerms,
      "ShipmentTerms",
    );
    this.setState({ shipmentTermLookupHandler: shipmentTermLookupHandler });
    let vendorTermLookupHandler = new GenericAttributeLookupHandler(
      this.props.vendorTerms,
      "vendorTerm",
    );
    this.setState({ vendorTermLookupHandler: vendorTermLookupHandler });
    let shipViaLookupHandler = new GenericAttributeLookupHandler(
      this.props.shipVias,
      "ShipVia",
    );
    this.setState({ shipViaLookupHandler: shipViaLookupHandler });
    let incoTermsLookupHandler = new GenericAttributeLookupHandler(
      this.props.incoTerms,
      "incoTerms",
    );
    this.setState({ incoTermsLookupHandler: incoTermsLookupHandler });
    let fobCityLookupHandler = new GenericAttributeLookupHandler(
      this.props.fOBCities,
      "FobCity",
    );
    this.setState({ fobCityLookupHandler: fobCityLookupHandler });
    let vendorLookupHandler = new VendorLookupHandler(
      this.companyCode,
      "Vendor",
    );
    this.setState({ vendorLookupHandler: vendorLookupHandler });
    let miscellaneousReasonLookupHandler = new GenericAttributeLookupHandler(
      this.props.miscellaneousReasons,
      "miscellaneousChargeReason",
    );
    this.setState({
      miscellaneousReasonLookupHandler: miscellaneousReasonLookupHandler,
    });
    let extraChargeReasonLookupHandler = new GenericAttributeLookupHandler(
      this.props.extraChargeReasons,
      "extraChargeReason",
    );
    this.setState({
      extraChargeReasonLookupHandler: extraChargeReasonLookupHandler,
    });
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer",
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
    let businessDivisionLookupHandler = new GenericAttributeLookupHandler(
      this.props.businessDivisions,
      "businessDivisions",
    );
    this.setState({
      businessDivisionLookupHandler: businessDivisionLookupHandler,
    });
    let orederTypeLookupHandler = new GenericAttributeLookupHandler(
      this.props.purchaseOrderTypes,
      "purchaseOrderTypes",
    );
    this.setState({
      orederTypeLookupHandler: orederTypeLookupHandler,
    });
  };
  showHideSecondHeader = () => {
    this.props.showHideSecondHeader();
  };
  closeEntryForm() {
    this.props.closeEntryForm();
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  onDateChange = (e) => {
    this.props.onDateChange(e);
  };
  onVendorCodeChange = (e) => {
    this.props.onVendorCodeChange(e);
  };
  onShipViaCodeChange = (e) => {
    this.props.onShipViaCodeChange(e);
  };
  shipViaEnterKeyEventHandler = (e) => {
    this.props.shipViaEnterKeyEventHandler(e);
  };
  onVendorTermChange = (e) => {
    this.props.onVendorTermChange(e);
  };
  vendorTermEnterKeyEventHandler = (e) => {
    this.props.vendorTermEnterKeyEventHandler(e);
  };
  onShipmentTermChange = (e) => {
    this.props.onShipmentTermChange(e);
  };
  shipmentTermEnterKeyEventHandler = (e) => {
    this.props.shipmentTermEnterKeyEventHandler(e);
  };
  onLocationChange = (e) => {
    this.props.onLocationChange(e);
  };
  locationEnterKeyEventHandler = (e) => {
    this.props.locationEnterKeyEventHandler(e);
  };
  onFOBChange = (e) => {
    this.props.onFOBChange(e);
  };
  fobEnterKeyEventHandler = (e) => {
    this.props.fobEnterKeyEventHandler(e);
  };
  addressOnChange = (e) => {
    this.props.addressOnChange(e);
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  vendorCodeEnterKeyEventHandler = (e) => {
    this.props.vendorCodeEnterKeyEventHandler(e);
  };
  onincotermCodeChange = (e) => {
    this.props.incotermOnChange(e);
  };
  incoTermsEnterKeyEventHandler = (e) => {
    this.props.incoTermsEnterKeyEventHandler(e);
  };
  displayAutoCompleteincoTermsList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteincoTermsList(showAutoCompleteList);
  };
  displayAutoCompleteLocationList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteLocationList(showAutoCompleteList);
  };
  displayAutoCompleteShipViaList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteShipViaList(showAutoCompleteList);
  };
  displayAutoCompleteVendorTermList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteVendorTermList(showAutoCompleteList);
  };
  displayAutoCompleteShipmentTermList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteShipmentTermList(showAutoCompleteList);
  };
  displayAutoCompleteFobList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteFobList(showAutoCompleteList);
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteList(showAutoCompleteList);
  };
  onextraChargeReasonCodeChange = (e) => {
    this.props.onextraChargeReasonCodeChange(e);
  };
  extraChargeReasonCodeEnterKeyEventHandler = (e) => {
    this.props.extraChargeReasonCodeEnterKeyEventHandler(e);
  };
  displayAutoCompleteextraChargeReasonCodeList = (
    showAutoCompleteextraChargeReasonCodeList,
  ) => {
    this.props.displayAutoCompleteextraChargeReasonCodeList(
      showAutoCompleteextraChargeReasonCodeList,
    );
  };
  onmiscellaneousChargeReasonCodeChange = (e) => {
    this.props.onmiscellaneousChargeReasonCodeChange(e);
  };
  miscellaneousChargeReasonCodeEnterKeyEventHandler = (e) => {
    this.props.miscellaneousChargeReasonCodeEnterKeyEventHandler(e);
  };
  displayAutoCompletemiscellaneousChargeReasonCodeList = (
    showAutoCompletemiscellaneousChargeReasonCodeList,
  ) => {
    this.props.displayAutoCompletemiscellaneousChargeReasonCodeList(
      showAutoCompletemiscellaneousChargeReasonCodeList,
    );
  };
  onbusinessDivisionChange = (e) => {
    this.props.onbusinessDivisionChange(e);
  };
  businessDivisionEnterKeyEventHandler = (e) => {
    this.props.businessDivisionEnterKeyEventHandler(e);
  };
  displayAutoCompleteBusinessDivisionList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteBusinessDivisionList(showAutoCompleteList);
  };
  onorderTypeChange = (e) => {
    this.props.onorderTypeChange(e);
  };
  orderTypeEnterKeyEventHandler = (e) => {
    this.props.orderTypeEnterKeyEventHandler(e);
  };
  displayAutoCompleteOrderTypeList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteOrderTypeList(showAutoCompleteList);
  };
  lnkVendorModule = (e) => {
    if (e.detail == 1) {
      let purchaseOrderData = this.props.purchaseOrderData;
      let code = purchaseOrderData.vendorCode;
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowVendorModule: true,
          moduleForPopup: (
            <PopupVendorModule
              vendorCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowVendorModule: false,
      isShowVendorOnOrderInq: false,
      isShowVendorPurchaseHistoryInq: false,
      moduleForPopup: [],
    });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  openVendorOnOrderInq = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowVendorOnOrderInq: true,
          moduleForPopup: (
            <PopupVendorOnOrderInq
              vendorCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  openVendorPurchaseHistoryInq = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowVendorPurchaseHistoryInq: true,
          moduleForPopup: (
            <PopupVendorPurchaseHistoryInq
              vendorCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  // lnkVendorPurchaseHistoryModule = () => {
  //   this.setState({
  //     isShowVendorPurchaseHistoryPopup: true,
  //   });
  // };
  // openVendors = () => {
  //   this.setState({
  //     isShowOpenVendorPopup: true,
  //   });
  // };
  // closeModalCallBack = (isOpen) => {
  //   this.setState({ , moduleForPopup: [] });
  // };
  closeVendorHistoryAlertModalCallBack = (isShowPopup) => {
    this.setState({
      // isShowVendorPurchaseHistoryPopup: isShowPopup,
      isShowAlert: isShowPopup,
      isOpenImagePopup: isShowPopup,
      isOpenColorPopup: isShowPopup,
      isOpenOnHandDetailPopup: isShowPopup,
    });
  };
  closeVendorOpenOrderAlertModalCallBack = (isShowPopup) => {
    this.setState({
      // isShowOpenVendorPopup: isShowPopup,
      isShowAlert: isShowPopup,
      isOpenImagePopup: isShowPopup,
      isOpenColorPopup: isShowPopup,
      isOpenOnHandDetailPopup: isShowPopup,
    });
  };
  onLogisticOnChange = (e) => {
    this.props.onLogisticOnChange(e);
  };
  isModifyPosible = () => {
    return this.props.isModifyPosible();
  };
  customerOnChange = (e) => {
    this.props.customerOnChange(e);
  };
  customerEnterKeyEventHandler = (e) => {
    this.props.customerEnterKeyEventHandler(e);
  };
  displayAutoCustomerCompleteList = (list) => {
    this.props.displayAutoCustomerCompleteList(list);
  };
  render() {
    let purchaseOrderData = this.props.purchaseOrderData;
  
    
    if (!purchaseOrderData) purchaseOrderData = new PurchaseOrderBean();
    let logisticsPlanUpdates = null;
    if (purchaseOrderData.logisticsPlanUpdates) {
      logisticsPlanUpdates = purchaseOrderData.logisticsPlanUpdates;
    }
    if (!logisticsPlanUpdates) {
      logisticsPlanUpdates = new PurchaseOrderLogisticsPlanUpdateBean();
    }
    let logisticData = this.props.logisticData;
    let purchaseOrderLineData = this.props.purchaseOrderLineData;
    let vendor_List = this.props.vendor_List;
    let fOBCities = this.props.fOBCities;
    let shipmentTerms = this.props.shipmentTerms;
    let incoTerms = this.props.incoTerms;
    let paymentTerms = this.props.paymentTerms;
    let vendorTerms = this.props.vendorTerms;
    let transportTypes = this.props.transportTypes;
    let disablePurchaseOrderFormFields =
      this.props.disablePurchaseOrderFormFields;
    let fabricStyle_List = this.props.fabricStyle_List;
    let lines = purchaseOrderData.lines;
    let warehouses = this.props.wareHouses;
    if (!lines) {
      lines = new Array();
    }
    let isDisabledFields = this.props.isDisabledFields;
    
    
    let isMiscDisable = this.props.isMiscDisable;
    let isModify = false;
    isModify = this.props.isModifyPosible();

    const textAreaStyle = {
      height: "3em",
      width: "25em",
      resize: "none",
      padding: "2px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    let is3PL = this.props.is3PL;
    let isTexco = this.props.isTexco;
    let isVendorInvoiceShow = this.props.isVendorInvoiceShow;
   
    
    return (
      <div>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowVendorModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowVendorOnOrderInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowVendorPurchaseHistoryInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <div>
          <div className="header_div">
            <Row>
              {is3PL && (
                <Col className="align-fabricStyles-left" sm="1">
                  <FormLabel>Customer</FormLabel>{" "}
                </Col>
              )}
              {is3PL && (
                <Col sm="2">
                  <InputTextbox
                    ref={this.customerRef}
                    onChange={this.customerOnChange}
                    name="customerCode"
                    placeholder="Customer"
                    value={purchaseOrderData.customerCode}
                    lookupRequired={true}
                    lookupHandler={this.state.customerLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.customerEnterKeyEventHandler}
                    autoCompleteListData={
                      this.props.customerPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCustomerCompleteList
                    }
                    showAutoCompleteList={
                      this.props.isShowAutoCompleteCustomerList
                    }
                    disabled={disablePurchaseOrderFormFields}
                    isMandatory={true}
                  />
                </Col>
              )}
              {is3PL && (
                <Col sm="3">
                  <InputTextbox
                    name="customerName"
                    value={purchaseOrderData.customerName}
                    disabled={true}
                  />
                </Col>
              )}
              <Col className="so-align-items-left" sm="1">
                <FormLabel
                  className="hyperlinklabel"
                  onClick={(e) => this.lnkVendorModule(e)}
                >
                  Vendor
                </FormLabel>
                <Col>
                  <ShortCutMenuPopup
                    value={purchaseOrderData.vendorCode}
                    menuItems={
                      <ul>
                        <li
                          className="shortcut-menu-item"
                          onClick={(e) => this.lnkVendorModule(e)}
                        >
                          {" "}
                          Vendor Info{" "}
                        </li>
                        <li
                          className="shortcut-menu-item"
                          // onClick={this.openVendorOnOrderInq}
                          onClick={(e) =>
                            this.openVendorOnOrderInq(
                              e,
                              purchaseOrderData.vendorCode,
                            )
                          }
                        >
                          {" "}
                          Open Vendors{" "}
                        </li>
                        <li
                          className="shortcut-menu-item"
                          // onClick={this.openVendorPurchaseHistoryInq}
                          onClick={(e) =>
                            this.openVendorPurchaseHistoryInq(
                              e,
                              purchaseOrderData.vendorCode,
                            )
                          }
                        >
                          {" "}
                          Vendor Purchase History{" "}
                        </li>
                      </ul>
                    }
                  />
                </Col>
              </Col>
              {!is3PL && (
                <Col sm="2">
                  <InputTextbox
                    onChange={this.onVendorCodeChange}
                    ref={this.vendorCodeRef}
                    name="vendorCode"
                    placeholder="vendorCode"
                    value={purchaseOrderData.vendorCode}
                    lookupRequired={true}
                    lookupHandler={this.state.vendorLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
                    autoCompleteListData={
                      this.props.vendorPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={this.displayAutoCompleteList}
                    showAutoCompleteList={this.props.showAutoCompleteList}
                    disabled={disablePurchaseOrderFormFields}
                    isMandatory={true}
                  ></InputTextbox>
                </Col>
              )}
              {is3PL && (
                <Col sm="2">
                  <InputTextbox
                    name="vendorCode"
                    value={purchaseOrderData.vendorCode}
                    disabled={true}
                  ></InputTextbox>
                </Col>
              )}
              <Col sm="3">
                <InputTextbox
                  name="vendorName"
                  value={purchaseOrderData.vendorName}
                  disabled={true}
                />
              </Col>

              {this.props.isShowOrderType && (
                // <Row>
                <Col className="align-fabricStyles-left" sm="1">
                  <FormLabel>Order Type</FormLabel>{" "}
                </Col>
              )}

              {this.props.isShowOrderType && (
                <Col sm="2">
                  <InputTextbox
                    onChange={this.onorderTypeChange}
                    name="orderType"
                    placeholder="orderType"
                    value={purchaseOrderData.orderType}
                    lookupRequired={true}
                    lookupHandler={this.state.orederTypeLookupHandler}
                    enterKeyEventHandler={this.orderTypeEnterKeyEventHandler}
                    autoCompleteListData={
                      this.props.orderTypePageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompleteOrderTypeList
                    }
                    showAutoCompleteList={
                      this.props.showAutoCompleteOrderTypeList
                    }
                    disabled={disablePurchaseOrderFormFields}
                    isMandatory={true}
                  />
                </Col>
                // </Row>
              )}
              <Col sm="1">
                <FormLabel>Payment Status</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="paymentStatus"
                  onChange={this.onChange}
                  className="qty_input summary_input"
                  //      value={ModuleUtils.getPurchaseOrderPaymentStatusCaption(cpmLineData.paymentStatus)}
                  value={ModuleUtils.getPurchaseOrderPaymentStatusCaption(
                    purchaseOrderData.paymentStatus,
                  )}
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col className="align-fabricStyles-left" sm="1">
                <FormLabel>OrderDate</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <DatePickerComponent_adv
                  name="orderDate"
                  value={purchaseOrderData.orderDate}
                  onChange={this.onDateChange}
                  //disabled={disablePurchaseOrderFormFields}
                  disabled={disablePurchaseOrderFormFields}
                  isMandatory={true}
                />
              </Col>
              <Col className="align-fabricStyles-left" sm="1">
                <FormLabel>StartDate</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <DatePickerComponent_adv
                  name="orderStartDate"
                  value={purchaseOrderData.orderStartDate}
                  onChange={this.onDateChange}
                  // isModifyView={isModify}
                  disabled={isDisabledFields}
                  isMandatory={true}
                />
              </Col>

              <Col className="align-fabricStyles-left" sm="1">
                {isTexco ? (
                  <FormLabel>Cancel Date</FormLabel>
                ) : (
                  <FormLabel>StopDate</FormLabel>
                )}
              </Col>

              <Col sm="2">
                <DatePickerComponent_adv
                  name="orderStopDate"
                  value={purchaseOrderData.orderStopDate}
                  onChange={this.onDateChange}
                  disabled={isDisabledFields}
                  isMandatory={true}
                  // isModifyView={isModify}
                />
              </Col>

              <Col className="align-fabricStyles-left" sm="1">
                <FormLabel>LC</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="lCNumber"
                  type="text"
                  placeholder="Enter lCNumber"
                  value={purchaseOrderData.lCNumber}
                  onChange={this.onChange}
                  disabled={disablePurchaseOrderFormFields}
                />
              </Col>
            </Row>
            <Row>
              <Col className="align-fabricStyles-left" sm="1">
                <FormLabel>IncoTerm</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onincotermCodeChange}
                  // disabled={disablePurchaseOrderFormFields}
                  name="incoterm"
                  placeholder="incoterm"
                  value={purchaseOrderData.incoterm}
                  lookupRequired={true}
                  lookupHandler={this.state.incoTermsLookupHandler}
                  enterKeyEventHandler={this.incoTermsEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.incoTermsPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompleteincoTermsList
                  }
                  showAutoCompleteList={
                    this.props.showAutoCompleteincoTermsList
                  }
                  disabled={
                    isTexco ? isDisabledFields : disablePurchaseOrderFormFields
                  }
                ></InputTextbox>
              </Col>
              <Col className="align-fabricStyles-left" sm="1">
                <FormLabel>ShipVia</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onShipViaCodeChange}
                  ref={this.shipViaCodeRef}
                  disabled={
                    isTexco ? isDisabledFields : disablePurchaseOrderFormFields
                  }
                  name="shipViaCode"
                  placeholder="ShipVia"
                  value={purchaseOrderData.shipViaCode}
                  lookupRequired={true}
                  lookupHandler={this.state.shipViaLookupHandler}
                  enterKeyEventHandler={this.shipViaEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.shipViaPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteShipViaList}
                  showAutoCompleteList={this.props.showAutoCompleteShipViaList}
                ></InputTextbox>
              </Col>
              <Col className="align-fabricStyles-left" sm="1">
                <FormLabel>ShipToName</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="shipToName"
                  placeholder="Enter shipToName"
                  value={purchaseOrderData.shipToName}
                  onChange={this.onChange}
                  disabled={
                    isTexco ? isDisabledFields : disablePurchaseOrderFormFields
                  }
                />
              </Col>
              {is3PL && (
                <Col className="align-fabricStyles-left" sm="1">
                  <FormLabel>Container#</FormLabel>{" "}
                </Col>
              )}
              {is3PL && (
                <Col sm="2">
                  <InputTextbox
                    name="containerNumber"
                    value={purchaseOrderData.containerNumber}
                    onChange={this.onChange}
                    disabled={disablePurchaseOrderFormFields}
                  />
                </Col>
              )}
              {is3PL && (
                <Col className="align-fabricStyles-left" sm="1">
                  <FormLabel>CustomerRef#</FormLabel>{" "}
                </Col>
              )}
              {is3PL && (
                <Col sm="2">
                  <InputTextbox
                    name="customerReferenceNumber"
                    value={purchaseOrderData.customerReferenceNumber}
                    onChange={this.onChange}
                    disabled={disablePurchaseOrderFormFields}
                  />
                </Col>
              )}
              {isTexco && (
                <Col className="align-fabricStyles-left" sm="1">
                  <FormLabel>VendorInvoice#</FormLabel>{" "}
                </Col>
              )}
              {isTexco && (
                <Col sm="2">
                  <InputTextbox
                    name="vendorInvoiceNumber"
                    value={purchaseOrderData.vendorInvoiceNumber}
                    onChange={this.onChange}
                    disabled={isVendorInvoiceShow}
                  />
                </Col>
              )}
              {/* {isTexco && (
                <Col className="align-fabricStyles-left" sm="1">
                  <FormLabel>ETA Date#</FormLabel>{" "}
                </Col>
              )} */}
              {/* {isTexco && (
                <Col sm="2">
                  <DatePickerComponent_adv
                    name="etaDate"
                    value={purchaseOrderData.etaDate}
                    onChange={this.onChange}
                    disabled={isDisabledFields}
                  />
                </Col>
              )} */}
            </Row>
            <Row>
              <Col sm="1">
                {/* <AddressComponent
                  label={"Address"}
                  addressData={purchaseOrderData.address}
                  onChange={this.onChange}
                  disabled={disablePurchaseOrderFormFields}
                /> */}
                <FormLabel
                  className="hyperlinklabel"
                  onClick={(e) => this.props.addressClickHandler(e)}
                >
                  Address
                </FormLabel>
              </Col>
              <Col sm="1">
                {/* <AddressComponent
                  label={"Shipping Address"}
                  addressData={purchaseOrderData.shippingAddress}
                  onChange={this.onChange}
                /> */}
                <FormLabel
                  className="hyperlinklabel"
                  onClick={(e) => this.props.shippingAddressClickHandler(e)}
                >
                  ShippingAddress
                </FormLabel>
              </Col>
           { isTexco ? ( 
            <>
              <Col sm="1">
                <FormLabel>Comments</FormLabel>
              </Col>
              <Col sm="3">
                <textarea
                  style={textAreaStyle}
                  className="form-control"
                  type="text"
                  name="comments"
                  value={purchaseOrderData.comments}
                  onChange={this.onChange}
                  disabled={
                      isTexco ? isDisabledFields : disablePurchaseOrderFormFields
                  }
                />
              </Col>
              <Col sm="1">
                <FormLabel>Shipping Instruction</FormLabel>
              </Col>
              <Col sm="3">
                <textarea
                  style={textAreaStyle}
                  className="form-control"
                  type="text"
                  name="shippingInstructions"
                  value={purchaseOrderData.shippingInstructions}
                  onChange={this.onChange}
                  disabled={
                      isTexco ? isDisabledFields : disablePurchaseOrderFormFields
                  }
                />
              </Col>
              </>
  ):null}
            </Row>
          </div>
          <div className="header_div">
            <Row>
              <Col sm="2" className="title_text_div">
                <FormLabel className="label_head">Misc Details</FormLabel>
              </Col>
            </Row>
            <Row>
              <Col className="align-fabricStyles-left" sm="1">
                <FormLabel>VendorTerm</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onVendorTermChange}
                  ref={this.vendorTermRef}
                  name="buyingTermsCode"
                  placeholder="buyingTermsCode"
                  value={purchaseOrderData.buyingTermsCode}
                  lookupRequired={true}
                  lookupHandler={this.state.vendorTermLookupHandler}
                  disabled={disablePurchaseOrderFormFields}
                  enterKeyEventHandler={this.vendorTermEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.vendorTermPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompleteVendorTermList
                  }
                  showAutoCompleteList={
                    this.props.showAutoCompleteVendorTermList
                  }
                  isMandatory={true}
                ></InputTextbox>
              </Col>
              <Col className="align-fabricStyles-left" sm="1">
                <FormLabel>Tolerance%</FormLabel>{" "}
              </Col>
              <Col sm="2">
                {" "}
                <InputTextbox
                  name="receiptTolerancePercentage"
                  type="text"
                  placeholder="Enter Tolerence%"
                  value={purchaseOrderData.receiptTolerancePercentage}
                  onChange={this.onChange}
                  disabled={disablePurchaseOrderFormFields}
                  isMandatory={true}
                />
              </Col>
              <Col className="align-fabricStyles-left" sm="1">
                <FormLabel>ShipmentTerm</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onShipmentTermChange}
                  ref={this.shipmentTermRef}
                  name="shipmentTermsCode"
                  placeholder="shipmentTermsCode"
                  value={purchaseOrderData.shipmentTermsCode}
                  lookupRequired={true}
                  lookupHandler={this.state.shipmentTermLookupHandler}
                  enterKeyEventHandler={this.shipmentTermEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.shipmentTermPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompleteShipmentTermList
                  }
                  showAutoCompleteList={
                    this.props.showAutoCompleteShipmentTermList
                  }
                  disabled={disablePurchaseOrderFormFields}
                  isMandatory={true}
                ></InputTextbox>
              </Col>
              <Col className="align-fabricStyles-left" sm="1">
                <FormLabel>Location</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onLocationChange}
                  ref={this.warehouseRef}
                  name="locationCode"
                  placeholder="locationCode"
                  value={purchaseOrderData.locationCode}
                  lookupRequired={true}
                  lookupHandler={this.state.warehouseLookupHandler}
                  enterKeyEventHandler={this.locationEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.locationPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteLocationList}
                  showAutoCompleteList={this.props.showAutoCompleteLocationList}
                  disabled={disablePurchaseOrderFormFields}
                  isMandatory={true}
                ></InputTextbox>
              </Col>
            </Row>
            <Row>
              <Col className="align-fabricStyles-left" sm="1">
                <FormLabel>FOBCity</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onFOBChange}
                  ref={this.fobCityRef}
                  name="fOBCity"
                  placeholder="fOBCity"
                  value={purchaseOrderData.fOBCity}
                  lookupRequired={true}
                  lookupHandler={this.state.fobCityLookupHandler}
                  enterKeyEventHandler={this.fobEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.fobPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteFobList}
                  showAutoCompleteList={this.props.showAutoCompleteFOBList}
                  disabled={disablePurchaseOrderFormFields}
                  isMandatory={true}
                />
              </Col>
              {!isTexco ? (
                <Col className="align-fabricStyles-left" sm="1">
                  <FormLabel>Days To Fright Forwarding</FormLabel>{" "}
                </Col>
              ) : null}
              {!isTexco ? (
                <Col sm="2">
                  <InputTextbox
                    name="daysToFrightForwarding"
                    type="text"
                    placeholder="Enter daysToFrightForwarding"
                    value={purchaseOrderData.daysToFrightForwarding}
                    onChange={this.onChange}
                    disabled={disablePurchaseOrderFormFields}
                    isMandatory={true}
                  />
                </Col>
              ) : null}
              <Col className="align-fabricStyles-left" sm="1">
                <FormLabel>BusinessDivision</FormLabel>{" "}
              </Col>

              <Col sm="2">
                <InputTextbox
                  onChange={this.onbusinessDivisionChange}
                  name="businessDivision"
                  placeholder="businessDivision"
                  value={purchaseOrderData.businessDivision}
                  lookupRequired={true}
                  lookupHandler={this.state.businessDivisionLookupHandler}
                  enterKeyEventHandler={
                    this.businessDivisionEnterKeyEventHandler
                  }
                  autoCompleteListData={
                    this.props.businessDivisionPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompleteBusinessDivisionList
                  }
                  showAutoCompleteList={
                    this.props.showAutoCompleteBusinessDivisionList
                  }
                  disabled={disablePurchaseOrderFormFields}
                />
              </Col>

              <Col className="align-fabricStyles-left" sm="1">
                <FormLabel>Purchase Division</FormLabel>{" "}
              </Col>

              <Col sm="2">
                <InputTextbox
                  name="purchaseDivisionCode"
                  type="text"
                  placeholder="purchaseDivisionCode"
                  value={purchaseOrderData.purchaseDivisionCode}
                  onChange={this.onChange}
                  disabled={disablePurchaseOrderFormFields}
                />
              </Col>
            </Row>
            {/* {this.props.isShowOrderType ? (
              <Row>
                <Col className="align-fabricStyles-left" sm="1">
                  <FormLabel>Order Type</FormLabel>{" "}
                </Col>

                <Col sm="2">
                  <InputTextbox
                    onChange={this.onorderTypeChange}
                    name="orderType"
                    placeholder="orderType"
                    value={purchaseOrderData.orderType}
                    lookupRequired={true}
                    lookupHandler={this.state.orederTypeLookupHandler}
                    enterKeyEventHandler={this.orderTypeEnterKeyEventHandler}
                    autoCompleteListData={
                      this.props.orderTypePageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompleteOrderTypeList
                    }
                    showAutoCompleteList={
                      this.props.showAutoCompleteOrderTypeList
                    }
                    disabled={disablePurchaseOrderFormFields}
                    isMandatory={true}
                  />
                </Col>
              </Row>
            ) : null} */}
          </div>
          <div className="div_inline">
            <div className="div_3_Equal">
              <Row>
                <FormLabel className="label_head">Amount Details</FormLabel>
              </Row>
              <Row>
                <Col>
                  <FormLabel>SubTotal</FormLabel>{" "}
                </Col>
                <Col sm="8">
                  <NumberFormatInputbox
                    name="orderSubTotal"
                    type="text"
                    className="qty_input text-end summary_input"
                    value={purchaseOrderData.orderSubTotal}
                    onChange={this.onChange}
                    decimalScale={2}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormLabel>MiscCharge</FormLabel>{" "}
                </Col>
                <Col>
                  <NumberFormatInputbox
                    name="miscellaneousCharge"
                    className="text-end"
                    value={purchaseOrderData.miscellaneousCharge}
                    onChange={this.onChange}
                    decimalScale={2}
                    disabled={isMiscDisable}
                    isMandatory={true}
                  />
                </Col>
                <Col>
                  <InputTextbox
                    ref={this.miscellaneousChargeReasonCodeRef}
                    name="miscellaneousChargeReasonCode"
                    onChange={this.onmiscellaneousChargeReasonCodeChange}
                    disabled={disablePurchaseOrderFormFields}
                    value={purchaseOrderData.miscellaneousChargeReasonCode}
                    lookupRequired={true}
                    lookupHandler={this.state.miscellaneousReasonLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={
                      this.miscellaneousChargeReasonCodeEnterKeyEventHandler
                    }
                    autoCompleteListData={
                      this.props
                        .miscellaneousChargeReasonCodePageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompletemiscellaneousChargeReasonCodeList
                    }
                    showAutoCompleteList={
                      this.props
                        .showAutoCompletemiscellaneousChargeReasonCodeList
                    }
                    isMandatory={true}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormLabel>ExtraCharge</FormLabel>{" "}
                </Col>
                <Col>
                  <NumberFormatInputbox
                    name="extraCharge"
                    className="text-end"
                    value={purchaseOrderData.extraCharge}
                    onChange={this.onChange}
                    decimalScale={2}
                    disabled={isMiscDisable}
                    isMandatory={true}
                  />
                </Col>
                <Col>
                  <InputTextbox
                    ref={this.extraChargeReasonCodeRef}
                    name="extraChargeReasonCode"
                    onChange={this.onextraChargeReasonCodeChange}
                    disabled={disablePurchaseOrderFormFields}
                    value={purchaseOrderData.extraChargeReasonCode}
                    lookupRequired={true}
                    lookupHandler={this.state.extraChargeReasonLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={
                      this.extraChargeReasonCodeEnterKeyEventHandler
                    }
                    autoCompleteListData={
                      this.props
                        .extraChargeReasonCodePageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompleteextraChargeReasonCodeList
                    }
                    showAutoCompleteList={
                      this.props.showAutoCompleteextraChargeReasonCodeList
                    }
                    isMandatory={true}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormLabel>GrandTotalAmt</FormLabel>{" "}
                </Col>
                <Col sm="8">
                  <NumberFormatInputbox
                    name="grandTotalAmount"
                    decimalScale={2}
                    className="qty_input text-end summary_input"
                    value={purchaseOrderData.grandTotalAmount}
                    onChange={this.onChange}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormLabel>Received Amt</FormLabel>{" "}
                </Col>
                <Col sm="8">
                  <NumberFormatInputbox
                    name="receivedQuantityAmount"
                    decimalScale={2}
                    className="qty_input text-end summary_input"
                    value={purchaseOrderData.receivedQuantityAmount}
                    onChange={this.onChange}
                    disabled={true}
                  />
                </Col>
              </Row>
            </div>
            <div className="div_3_Equal">
              <Row>
                <Col className="title_text_div">
                  <FormLabel className="label_head">LogisticsPlan</FormLabel>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormLabel>XFactory Date</FormLabel>{" "}
                </Col>
                <Col>
                  <DatePickerComponent_adv
                    name="xFactoryDate"
                    value={logisticData.xFactoryDate}
                    onChange={this.onLogisticOnChange}
                    disabled={disablePurchaseOrderFormFields}
                  />
                </Col>
              </Row>
              {!isTexco ? (
                <Row>
                  <Col>
                    <FormLabel>InConsolidatorDCDate</FormLabel>{" "}
                  </Col>
                  <Col>
                    <DatePickerComponent_adv
                      name="inConsolidatorDCDate"
                      value={logisticData.inConsolidatorDCDate}
                      onChange={this.onLogisticOnChange}
                      disabled={disablePurchaseOrderFormFields}
                    />
                  </Col>
                </Row>
              ) : null}
              {!isTexco ? (
                <Row>
                  <Col>
                    <FormLabel>InDcDate</FormLabel>{" "}
                  </Col>
                  <Col>
                    <DatePickerComponent_adv
                      name="inDCDate"
                      value={logisticData.inDCDate}
                      onChange={this.onLogisticOnChange}
                      disabled={true}
                    />
                  </Col>
                </Row>
              ) : null}
              <Row>
                <Col>
                  <FormLabel>EtaDate</FormLabel>{" "}
                </Col>
                <Col>
                  <DatePickerComponent_adv
                    name="etaDate"
                    value={purchaseOrderData.etaDate}
                    onChange={this.onDateChange}
                    disabled={true}
                  />
                </Col>
              </Row>
              {isTexco && (
                <Row>
                  <Col>
                    <FormLabel>ETD Date#</FormLabel>{" "}
                  </Col>

                  <Col>
                    <DatePickerComponent_adv
                      name="etdDate"
                      value={purchaseOrderData.etdDate}
                      onChange={this.onChange}
                      disabled={disablePurchaseOrderFormFields}
                    />
                  </Col>
                </Row>
              )}
              <Row>
                <Col>
                  <FormLabel>Logistics Remarks</FormLabel>{" "}
                </Col>
                <Col>
                  <InputTextbox
                    name="comments"
                    type="text"
                    placeholder="Enter comments"
                    value={logisticData.comments}
                    onChange={this.onLogisticOnChange}
                    disabled={disablePurchaseOrderFormFields}
                  />
                </Col>
              </Row>
            </div>
            <div className="div_3_Equal">
              <div className="div_Custom">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th>X-FactoryDate</th>
                      <th>InConsoliDate</th>
                      <th>InDCDate</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  {purchaseOrderData.logisticsPlanUpdates != null && (
                    <tbody>
                      {purchaseOrderData.logisticsPlanUpdates.map((ln, i) => (
                        <tr key={i} data-item={ln}>
                          <td>
                            {ModuleUtils.getDateFormat_v1(ln.xFactoryDate)}
                          </td>
                          <td>
                            {ModuleUtils.getDateFormat_v1(
                              ln.inConsolidatorDCDate,
                            )}
                          </td>
                          <td>{ModuleUtils.getDateFormat_v1(ln.inDCDate)}</td>
                          <td>{ln.comments}</td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </div>
        </div>
        {/* <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={false}
          isShowPopup={this.state.isShowVendorPurchaseHistoryPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeVendorHistoryAlertModalCallBack}
          title={"Vendor Purchase History Details"}
          closeOnDocumentClick={false}
          content={
            <VendorPurchaseDetail
              purchaseOrderData={this.props.purchaseOrderData}
            />
          }
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.state.isShowOpenVendorPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeVendorOpenOrderAlertModalCallBack}
          title={"Vendor Open Order"}
          closeOnDocumentClick={false}
          content={
            <VendorOpenOrderDetail
              purchaseOrderData={this.props.purchaseOrderData}
            />
          }
        /> */}
      </div>
    );
  }
}
class VendorOpenOrderDetail extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      purchaseOrderData: new PurchaseOrderBean(),
      purchaseOrderLineData: new PurchaseOrderLineBean(),
      isShowElements: false,
      isShowPopup: false,
      inquiryDataList: [],
      criteria: new VendorPurchaseOnOrderSearchCriteria(),
      isShowPurchaseOrderModule: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      error_list: [],
    };
    this.skyLightDialogRef = React.createRef();
    this.fabricStyleCodeRef = React.createRef();
  }
  componentDidMount() {
    let purchaseOrderData = this.props.purchaseOrderData;
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    let criteria = this.state.criteria;
    criteria.vendorCode = purchaseOrderData.vendorCode;
    this.setState({
      criteria: criteria,
    });
    this.loadPage();
  }
  loadPage = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let vend_criteria = new VendorPurchaseOnOrderSearchCriteria();
    vend_criteria.companyCode = this.companyCode;
    vend_criteria.vendorCode = criteria.vendorCode;

    let listRequest = new RestVendorPurchaseOnOrderListRequest();
    listRequest.searchCriteria = criteria;

    this.loadVendorOnOrderInquiryList(listRequest);
  };
  loadVendorOnOrderInquiryList = (listRequest) => {
    if (SecurityAccessManager.PurchaseOrderMaintenance_IsAccessible()) {
      VendorService.getVendorPurchaseOnOrderDetailsForFabricStyleStatistics(
        listRequest,
        this.loadVendorOnOrderQtyPageResponse,
        this.loadVendorOnOrderQtyPageError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadVendorOnOrderQtyPageResponse = (response) => {
    let inquiryDataList = response.data.orderDetailsResult;
    if (inquiryDataList != null) {
      let vendorQtyDataList = [];
      if (!isEmptyArray(response.data.orderDetailsResult.onOrderInfoDetails))
        vendorQtyDataList = response.data.orderDetailsResult.onOrderInfoDetails;
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        inquiryDataList: vendorQtyDataList,
        isShowPDFButton: true,
        isShowExcelButton: true,
      });
    } else {
      let errMsg = "No data Found";
      let errList = this.state.error_list;
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      this.setState({
        isInquiryDatasFound: false,
      });
    }
  };
  loadVendorOnOrderQtyPageError = (error) => {
    ShowError("Error : " + error);
  };
  viewPurchaseOrderModule = (val, rowData) => {
    let code = rowData.purchaseOrderNumber;
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowPurchaseOrderModule: true,
        moduleForPopup: (
          <PurchaseModule code={code} onModuleExit={this.onPopupModalExit} />
        ),
      });
    }
  };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "PO#",
        "purchaseOrderNumber",
        0,
        true,
        this.viewPurchaseOrderModule,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("OrderDate", "orderDate"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "StopDate",
        "purchaseOrderStopDate",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("UOM", "orderUom"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("TotalQty", "onOrderQuantity"),
    );
    return columnList;
  };
  closePurchaseModalCallBack = (isOpen) => {
    this.setState({ isShowPurchaseOrderModule: isOpen, moduleForPopup: [] });
  };
  generateExcel = () => {
    this.downloadReport(2, this.state.criteria);
  };
  generatePDF = () => {
    this.downloadReport(1, this.state.criteria);
  };
  downloadReportResponse = (response) => {
    if (!isEmpty(response.data.reportResult.reportFileID)) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
    }
  };
  downloadReportError = (error) => {
    ShowError("Error : " + error);
  };
  downloadReport = (reportType, criteria) => {
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let requestInput = new PopupVendorOpenOrderSalesDetailPrintRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.criteria = criteria;
    requestInput.reportBean = reportBean;
    if (SecurityAccessManager.PurchaseOrderMaintenance_IsAccessible()) {
      ReportService.generateVendorOnOrderPrintReport(
        requestInput,
        this.downloadReportResponse,
        this.downloadReportError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    return (
      <div className="PurchaseOrderPopup">
        <BaseInquiryToolBar
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowPurchaseOrderModule}
          closeModalCallBack={this.closePurchaseModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <DataGrid
          columnsList={this.columnDefinitions()}
          dataList={inquiryDataList}
        />
      </div>
    );
  }
}
// class VendorPurchaseDetail extends React.Component {
//   static contextType = AppContext;
//   constructor(props) {
//     super(props);
//     this.state = {
//       purchaseOrderData: new PurchaseOrderBean(),
//       purchaseOrderLineData: new PurchaseOrderLineBean(),
//       isShowElements: false,
//       isShowPopup: false,
//       inquiryDataList: [],
//       criteria: new FabricStylePurchaseHistoryCriteriaBean(),
//       isShowPDFButton: false,
//       isShowExcelButton: false,
//       error_list: [],
//     };
//     this.skyLightDialogRef = React.createRef();
//     this.fabricStyleCodeRef = React.createRef();
//   }
//   componentDidMount() {
//     let purchaseOrderData = this.props.purchaseOrderData;
//     const { appData } = this.context;
//     this.companyCode = appData.companyCode;
//     this.report_url = appData.reportURL;
//     let criteria = this.state.criteria;
//     criteria.vendorCode = purchaseOrderData.vendorCode;
//     this.setState({
//       criteria: criteria,
//     });
//     this.loadPage();
//   }
//   loadPage = () => {
//     let criteria = this.state.criteria;
//     criteria.companyCode = this.companyCode;
//     this.loadFabricStylePurchaseHistoryList(criteria);
//   };
//   loadFabricStylePurchaseHistoryList = (criteria) => {
//     if (SecurityAccessManager.PurchaseOrderMaintenance_IsAccessible()) {
//       ReportService.inquireFabricStylePurchaseOrderHistoryInfos(
//         criteria,
//         this.loadFabricStylePurchaseHistoryPageResponse,
//         this.loadFabricStylePurchaseHistoryPageError
//       );
//     } else {
//       let errMsg = "Access Denied";
//       let errList = [];
//       errList.push(errMsg);
//       this.setState({
//         alertMessage: errList,
//         alertType: "danger",
//         isShowAlert: true,
//       });
//     }
//   };
//   loadFabricStylePurchaseHistoryPageResponse = (response) => {
//     let inquiryDataList = response.data.result;
//     if (inquiryDataList != null) {
//       let historyList = [];
//       if (response.data.result.historyBeans != null)
//         historyList = response.data.result.historyBeans;
//       this.setState({
//         isInquiryDatasFound: true,
//         isShowResetButton: true,
//         inquiryDataList: historyList,
//         isShowPDFButton: true,
//         isShowExcelButton: true,
//       });
//     } else {
//       let errMsg = "No data Found";
//       let errList = this.state.error_list;
//       errList.push(errMsg);
//       this.setState({
//         alertMessage: errList,
//         alertType: "danger",
//         isShowAlert: true,
//       });
//       this.setState({
//         isInquiryDatasFound: false,
//       });
//     }
//   };
//   loadFabricStylePurchaseHistoryPageError = (error) => {
//     ShowError("Error : " + error);
//   };
//   generateExcel = () => {
//     this.downloadReport(2, this.state.criteria);
//   };
//   generatePDF = () => {
//     this.downloadReport(1, this.state.criteria);
//   };
//   downloadReportResponse = (response) => {
//     let reportFilePath = response.data.reportResult.reportFileID;
//     window.open(this.report_url + reportFilePath);
//   };
//   downloadReportError = (error) => {
//     ShowError("Error : " + error);
//   };
//   downloadReport = (reportType, criteria) => {
//     let reportBean = new RestReportBean();
//     reportBean.reportType = reportType;
//     let requestInput = new FabricStylePurchaseOrderHistoryPrintRequest();
//     requestInput.companyCode = this.companyCode;
//     requestInput.criteria = criteria;
//     requestInput.reportBean = reportBean;
//     if (SecurityAccessManager.PurchaseOrderMaintenance_IsAccessible()) {
//       ReportService.generateFabricStylePurchaseOrderHistoryPrintReport(
//         requestInput,
//         this.downloadReportResponse,
//         this.downloadReportError
//       );
//     } else {
//       let errMsg = "Access Denied";
//       let errList = [];
//       errList.push(errMsg);
//       this.setState({
//         alertMessage: errList,
//         alertType: "danger",
//         isShowAlert: true,
//       });
//     }
//   };
//   render() {
//     let inquiryDataList = this.state.inquiryDataList;
//     return (
//       <div className="PurchaseOrderPopup">
//         <BaseInquiryToolBar
//           isShowPDFButton={this.state.isShowPDFButton}
//           isShowExcelButton={this.state.isShowExcelButton}
//           generatePDF={this.generatePDF}
//           generateExcel={this.generateExcel}
//         />
//         <Table>
//           <thead>
//             <tr>
//               <th>PO.Date</th>
//               <th>PO#</th>
//               <th>FabricStyle</th>
//               <th>FabricStyleName</th>
//               <th>Color</th>
//               <th>Uom</th>
//               <th>PurchaseOrderQty</th>
//               <th>P.O.RcvdQty</th>
//             </tr>
//           </thead>
//           {inquiryDataList.map((inquiryInfo, index) => (
//             <tbody>
//               <tr key={index}>
//                 <td>{inquiryInfo.purchaseOrderDate}</td>
//                 <td>{inquiryInfo.purchaseOrderNumber}</td>
//                 <td>{inquiryInfo.fabricStyleCode}</td>
//                 <td>{inquiryInfo.fabricStyleName}</td>
//                 <td>{inquiryInfo.fabricStyleColor}</td>
//                 <td>{inquiryInfo.uomCode}</td>
//                 <td>{inquiryInfo.purchaseOrderQuantity}</td>
//                 <td>{inquiryInfo.purchaseOrderReceivedQuantity}</td>
//               </tr>
//             </tbody>
//           ))}
//         </Table>
//       </div>
//     );
//   }
// }
class PurchaseOrderDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.skyLightDialogRef = React.createRef();
    this.fabricStyleRef = React.createRef();
    // this.colorCodeRef = React.createRef();
    this.costRef = React.createRef();
    this.state = {
      isShowElements: false,
      isShowPopup: false,
      colorLookupHandler: this.props.colorLookupHandler,
      isShowColorLookup: this.props.isShowColorLookup,
      isShowFabricModule: false,
      // isShowItemCurrentInventoryPopup: false,
      // isShowVendorItemPurchaseHistoryPopup: false,
      // isShowItemInventoryPositionPopup: false,
      moduleForPopup: [],
      purchaseOrderLineAdjustmentData: new PurchaseOrderLineAdjustmentBean(),
      purchaseOrderLineAdjustmentDataList: new Array(),
      lineDatas: [],
      selectedLineList: [],
      purchaseSourceSalesOrderLineData:
        new PurchaseSourceSalesOrderDetailLineBean(),
      salesPageListForAutoCompleteList: new Array(),
      showAutoCompleteSOList: true,
      isShowAdjDeleteButton: this.props.isShowAdjDeleteButton,
      alertMessage: this.props.alertMessage,
      alertType: this.props.alertType,
      isShowPopupAlert: this.props.isShowPopupAlert,
      isShowLineAlert: this.props.isShowLineAlert,
      isShowProgressBarPopup: false,
      isShowItemInventoryPositionInq: false,
      isShowItemCurrentInventoryInq: false,
      isShowFabricPurchaseHistoryInq: false,
      showPassword: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.purchaseOrder_data_url =
      appData.serviceURL + "/PurchaseOrderRestService";
    this.fabricStyle_data_url = appData.serviceURL + "/FabricStyleRestService";
    this.customer_data_url = appData.serviceURL + "/CustomerRestService";
    this.companyCode = appData.companyCode;
  }
  onDateChange = (e) => {
    this.props.onDateChange(e);
  };
  onVendorCodeChange = (e) => {
    this.props.onVendorCodeChange(e);
  };

  onLineClick = (e, val, row) => {
    if (e.detail == 1) {
     this.props.readSelectedFabricStyle(row.fabricstyleCode);
      this.props.onLineClick(row);
      this.setState({ isEditPurchaseOrderLine: true });
      this.showLookup();
    }
  };
  cancelPurchaseOrderLine = (e, val, row) => {
    if (e.detail == 1) this.props.cancelPurchaseOrderLine(row);
  };
  onLineSearchLinkClick = (searchString, colDef, row) => {
    this.handleItemAutocompleteSearch(searchString);
  };
  showLookup = () => {
    this.props.showLookup();
  };
  closeLookup = () => {
    this.props.closeLookup();
  };
  addNewPOLine = (e) => {
    if (e.detail == 1) {
      this.props.addNewPOLine(e);
      this.showLookup();
    }
  };
  handleAfterClose = () => {
    this.setState({ isShowElements: false });
  };
  handleFocus = (event) => {
    event.target.select();
  };
  handleKeyDown = (event) => {
    if (event.keyCode == 13) {
    }
  };
  onLineChange = (e) => {
    this.props.onLineChange(e);
  };
  authClick = (e) => {
    this.props.authClick(e);
  };
  priceOncontinue = (e) => {
    this.props.priceOncontinue(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  onClick = (e) => {
    if (e.detail == 1) this.props.addOrUpdateLineChange(e);
  };
  closeAlertLinePopupModalCallBack = (isShowPopup) => {
    this.props.closeAlertLinePopupModalCallBack(isShowPopup);
  };
  onFabricCodeChange = (e) => {
    this.props.onFabricCodeChange(e);
  };
  fabricCodeEnterKeyEventHandler = (e) => {
    this.props.fabricCodeEnterKeyEventHandler(e);
  };
  onFabricColourCodeChange = (e) => {
    this.props.onFabricColourCodeChange(e);
  };
  fabricColourEnterKeyEventHandler = (e) => {
    this.props.fabricColourEnterKeyEventHandler(e);
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteList(showAutoCompleteList);
  };
  displayAutoCompleteColourList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteColourList(showAutoCompleteList);
  };
  enterKeyEventHandler = (event) => {
    this.props.readSelectedFabricStyle(event.target.value);
  };
  clearLineValues = (e) => {
    if (e.detail == 1) {
      this.props.clearLineValues();
      //   if (this.fabricStyleRef.current != null) {
      //     this.fabricStyleRef.current.clear();
      //     this.fabricStyleRef.current.focus();
      //   }
      //   if (this.colorCodeRef.current != null) {
      //     this.colorCodeRef.current.clear();
      //   }
      // }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricModule: isOpen,
      isShowItemInventoryPositionInq: isOpen,
      isShowItemCurrentInventoryInq: isOpen,
      isShowFabricPurchaseHistoryInq: isOpen,

      moduleForPopup: [],
    });
  };
  handleSortingPoLinesChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingPoLinesChange(accessor);
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  lnkFabricModule = (e, code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowFabricModule: true,
        moduleForPopup: (
          <PopupFabricModule
            fabricStyleCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openItemPurchaseHistoryInq = (e, code) => {
    if (e.detail == 1) {
      let vendorCode = "";
      let purchaseOrderData = this.props.purchaseOrderData;
      if (!isEmptyString(purchaseOrderData.vendorCode)) {
        vendorCode = purchaseOrderData.vendorCode;
        if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
          this.setState({
            isShowFabricPurchaseHistoryInq: true,
            moduleForPopup: (
              <PopupFabricPurchaseHistoryInq
                fabricCode={code}
                vendorCode={vendorCode}
                onModuleExit={this.onPopupModalExit}
              />
            ),
          });
        }
      }
    }
  };

  openItemInvPositionInq = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowItemInventoryPositionInq: true,
          moduleForPopup: (
            <PopupFabricInventoryPositionInq
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  openItemCurrentInvInq = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowItemCurrentInventoryInq: true,
          moduleForPopup: (
            <PopupItemCurrentInventoryInq
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  // vendorPuchaseHistory = () => {
  //   this.setState({
  //     isShowVendorItemPurchaseHistoryPopup: true,
  //   });
  // };

  closeVendorItemPurchaseHistoryAlertModalCallBack = (isShowPopup) => {
    this.setState({
      // isShowVendorItemPurchaseHistoryPopup: isShowPopup,
      isShowAlert: isShowPopup,
      isOpenImagePopup: isShowPopup,
      isOpenColorPopup: isShowPopup,
      isOpenOnHandDetailPopup: isShowPopup,
    });
  };
  // itemInventoryPosition = () => {
  //   this.setState({
  //     isShowItemInventoryPositionPopup: true,
  //   });
  // };
  closeItemInventoryPositionAlertModalCallBack = (isShowPopup) => {
    this.setState({
      // isShowItemInventoryPositionPopup: isShowPopup,
      isShowAlert: isShowPopup,
      isOpenImagePopup: isShowPopup,
      isOpenColorPopup: isShowPopup,
      isOpenOnHandDetailPopup: isShowPopup,
    });
  };
  // itemCurrentInventoryLevel = () => {
  //   this.setState({
  //     isShowItemCurrentInventoryPopup: true,
  //   });
  // };
  closeItemCurrentInventoryAlertModalCallBack = (isShowPopup) => {
    this.setState({
      // isShowItemCurrentInventoryPopup: isShowPopup,
      isShowAlert: isShowPopup,
      isOpenImagePopup: isShowPopup,
      isOpenColorPopup: isShowPopup,
      isOpenOnHandDetailPopup: isShowPopup,
    });
  };
  copyPreviousLine = () => {
    this.props.copyPreviousLine();
  };

  closeFabricModalCallBack = (isOpen) => {
    this.setState({ isShowFabricModule: isOpen, moduleForPopup: [] });
  };
  adjustedQuantity = () => {
    this.props.adjustedQuantityClick();
  };
  closeAdjutedQuantityAlertModalCallBack = (isShowPopup) => {
    this.props.closeAdjutedQuantityAlertModalCallBack(isShowPopup);
  };
  adjContinue = (e) => {
    if (e.detail == 1) {
      this.props.poLineAdjustmentPopupContinueClick();
      this.closeAdjutedQuantityAlertModalCallBack(false);
    }
  };
  onAdjLineChange = (e) => {
    this.props.onAdjLineChange(e);
  };
  onAdjLineReasonChange = (e) => {
    this.props.onAdjLineReasonChange(e);
  };
  adjReasonEnterKeyEventHandler = (e) => {
    this.props.adjReasonEnterKeyEventHandler(e);
  };
  displayAutoCompleteAdjReasonList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteAdjReasonList(showAutoCompleteList);
  };
  onAdjLineClick = (rowData) => {
    this.props.onAdjLineClick(rowData);
  };
  deleteAdjustment = (rowData) => {
    this.props.deleteAdjustment(rowData);
  };
  addOrUpdateAdj = () => {
    this.props.addOrUpdateAdjustedLine();
  };

  salesOrderAllocationContinue = (e) => {
    if (e.detail == 1)
      this.props.closeSalesOrderAllocationAlertModalCallBack(false);
  };

  onExcelClick = (e) => {
    if (e.detail == 1) {
      const input = document.getElementById("file-input");

      if (input) {
        input.click();
      }
    }
  };
  uploadExcelFile = (e) => {
    this.props.uploadExcelFile(e);
  };
  isModifyPosible = () => {
    return this.props.isModifyPosible();
  };
  clearAdjLines = () => {
    this.props.clearAdjLines();
  };
  togglePassword = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  };
  onfabricBlur = (e) => {
    this.props.onfabricBlur(e);
  };
  onfabricKeyDown = (e) => {
    this.props.onfabricKeyDown(e);
  };

  addorUpdateMultiplePOLine = (e) => {
    this.props.addorUpdateMultiplePOLine(e);
  };
  onKeyPress = (e) => {
    //  if (e.keyCode == 120) {
    //     this.props.addorUpdateMultiplePOLine();
    //   }
    this.props.onKeyPress(e);
  };

  getShortcutComponent = (row) => {
    return (
      <ShortCutMenuPopup
        value={row.fabricStyleCode}
        // popupData = {this.state.tempPopUpData }
        menuItems={
          <ul>
            <li
              className="shortcut-menu-item"
              onClick={(e) => this.lnkFabricModule(e, row.fabricStyleCode)}
            >
              {" "}
              Item Info{" "}
            </li>
            <li
              className="shortcut-menu-item"
              // onClick={this.vendorPuchaseHistory}
              onClick={(e) =>
                this.openItemPurchaseHistoryInq(e, row.fabricStyleCode)
              }
            >
              {" "}
              Vendor-Item Purchase History{""}
            </li>
            <li
              className="shortcut-menu-item"
              // onClick={this.itemCurrentInventoryLevel}
              onClick={(e) =>
                this.openItemCurrentInvInq(e, row.fabricStyleCode)
              }
            >
              {" "}
              Item Current Inventory Level{""}
            </li>
            <li
              className="shortcut-menu-item"
              // onClick={this.itemInventoryPosition}
              onClick={(e) =>
                this.openItemInvPositionInq(e, row.fabricStyleCode)
              }
            >
              {" "}
              Item Inventory Position{""}
            </li>
            <li
              className="shortcut-menu-item"
              onClick={(e) => this.copyPreviousLine(e)}
            >
              {" "}
              Copy Previous Line{" "}
            </li>
          </ul>
        }
      />
    );
  };
  getCaption = (status) => {
    return ModuleUtils.getPurchaseOrderLineStatusCaption(status);
  };
  poLineColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setHeaderDetails(true, <AddIcon />, this.addNewPOLine, false)
        .setStyleDetails("", "", "", "wt-4", "wt-4")

        .setShortCutPopDetails(this.getShortcutComponent, true),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Ln#", "lineNumber", true)

        .setStyleDetails("right", "", "", "wt-2", " wt-2")

        .setClickDetails(true, false, this.onLineClick, null),
    );
    {
      this.state.is3PL
        ? columns.push(
            new ColumnDefinition()
              .setDetails("Item", "fabricStyleCode", true)
              .setStyleDetails("left", "", "", "min-wt-5", "min-wt-5"),
          )
        : columns.push(
            new ColumnDefinition()
              .setDetails("Fabric", "fabricStyleCode", true)
              .setStyleDetails("left", "", "", "min-wt-5", "min-wt-5"),
          );
    }
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)
        .setStyleDetails("left", "", "", "min-wt-5 ", "min-wt-5 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "min-wt-5 ", "min-wt-5"),
    );
    {
      this.state.is3PL
        ? columns.push(
            new ColumnDefinition()
              .setDetails(" Qty#", "orderQuantity", true)

              .setStyleDetails("right", "", "", "wt-5 ", "wt-5"),
          )
        : columns.push(
            new ColumnDefinition()
              .setDetails(" Qty#", "orderQuantity", true, true)

              .setStyleDetails("right", "", "", "wt-5 ", "wt-5"),
          );
    }
    {
      this.state.is3PL
        ? columns.push(
            new ColumnDefinition()
              .setDetails(" IntransitQty#", "inTransitQuantity", true)
              .setStyleDetails("right", "", "", "wt-4", "wt-4"),
          )
        : columns.push(
            new ColumnDefinition()
              .setDetails(" IntransitQty#", "inTransitQuantity", true, true)
              .setStyleDetails("right", "", "", "wt-4", "wt-4"),
          );
    }

    {
      this.state.is3PL
        ? columns.push(
            new ColumnDefinition()
              .setDetails("Rcd Qty#", "receivedQuantity", true)

              .setStyleDetails("right", "", "", "wt-5 ", "wt-5"),
          )
        : columns.push(
            new ColumnDefinition()
              .setDetails("Rcd Qty#", "receivedQuantity", true, true)

              .setStyleDetails("right", "", "", "wt-5 ", "wt-5"),
          );
    }

    {
      this.state.is3PL
        ? columns.push(
            new ColumnDefinition()
              .setDetails("Open Qty#", "openQuantity", true)
              .setStyleDetails("right", "", "", "wt-5", "wt-5"),
          )
        : columns.push(
            new ColumnDefinition()
              .setDetails("Open Qty#", "openQuantity", true, true)
              .setStyleDetails("right", "", "", "wt-5", "wt-5"),
          );
    }
    columns.push(
      new ColumnDefinition()
        .setDetails("Cost", "cost", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM#", "uomCode", true)
        .setStyleDetails("right", "", "", "wt-5", ""),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Extension", "lineTotalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-5", ""),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "lineStatus", true)
        .setStatusDetails(true, this.getCaption)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Comments", "comments", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("", <DeleteIcon />, false)

        .setClickDetails(
          false,
          true,
          this.cancelPurchaseOrderLine,
          <DeleteIcon />,
        ),
    );
    return columns;
  };
  render() {
    let purchaseOrderData = this.props.purchaseOrderData;
    let purchaseOrderLineData = this.props.purchaseOrderLineData;
    let vendor_List = this.props.vendor_List;
    let fabricStyle_List = this.props.fabricStyle_List;
    let poLineAdjData = [];
    if (!isEmptyArray(this.props.purchaseOrderLineAdjustmentDataList)) {
      poLineAdjData = this.props.purchaseOrderLineAdjustmentDataList;
    } else {
      poLineAdjData = this.props.purchaseOrderLineData.adjustmentLines;
    }
    // let lines = purchaseOrderData.lines;
    // if (!lines) {
    //   lines = new Array();
    // }
    let lines = [];
    if (!isEmptyArray(purchaseOrderData.lines)) {
      lines = purchaseOrderData.lines;
    }
    let fabricStyleSkuList = this.props.currentFabricStyleSkuList;
    if (!fabricStyleSkuList) {
      fabricStyleSkuList = new Array();
    }
    let disablePurchaseOrderFormFields =
      this.props.disablePurchaseOrderFormFields;
    let isDisabledFields = this.props.isDisabledFields;
    let disableCancelButton = this.props.disableCancelButton;
    const is3PL = this.props.is3PL;
    let isModify = false;
    isModify = this.props.isModifyPosible();
    let disableUpdatableFields = false;
    if (disablePurchaseOrderFormFields) {
      if (isModify) {
        disableUpdatableFields = false;
      } else {
        if (
          purchaseOrderData.orderStatus ===
          LogicConstants.PURCHASE_ORDER_UNAPPROVE_STATUS
        ) {
          disableUpdatableFields = false;
        } else {
          disableUpdatableFields = true;
        }
      }
    }
    if (this.props.isViewMode) {
      disableUpdatableFields = true;
    }
    let lineUpdateDisableForTexco = false;

    if (
      purchaseOrderData.orderStatus ===
        LogicConstants.PURCHASE_ORDER_CANCEL_STATUS ||
       purchaseOrderData.orderStatus === LogicConstants.PURCHASE_ORDER_FORCE_CLOSED_STATUS
    ) {
      lineUpdateDisableForTexco = true;
    }
    let poLinesList = new Array();
    if (!isEmptyArray(this.props.poLinesList))
      poLinesList = this.props.poLinesList;
    let showPassword = this.state.showPassword;
    return (
      <div>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowFabricModule}
          closeModalCallBack={this.closeFabricModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <div className="header_div">
          <div className="">
            <Row>
              <Col className="align-fabricStyles-left" sm="1">
                {" "}
                <FormLabel>Date#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                {" "}
                <DatePickerComponent_adv
                  name="code"
                  type="text"
                  placeholder="Enter code"
                  value={purchaseOrderData.orderStartDate}
                  onChange={this.onDateChange}
                  disabled={disablePurchaseOrderFormFields}
                  isMandatory={true}
                />
              </Col>
              <Col className="align-fabricStyles-left" sm="1">
                <FormLabel>Vendor</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="vendorCode"
                  placeholder="Enter Vendor"
                  readOnly={false}
                  value={purchaseOrderData.vendorCode}
                  disabled={true}
                />
              </Col>

              <Col sm="3">
                <InputTextbox
                  name="vendorName"
                  type="text"
                  value={purchaseOrderData.vendorName}
                  onChange={this.onChange}
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col className="align-fabricStyles-left" sm="1">
                {" "}
                <FormLabel>OrderStopDate#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                {" "}
                <DatePickerComponent_adv
                  name="orderStopDate"
                  type="text"
                  placeholder="Enter orderStopDate"
                  value={purchaseOrderData.orderStopDate}
                  onChange={this.onDateChange}
                  disabled={disablePurchaseOrderFormFields}
                  isMandatory={true}
                />
              </Col>

              <Col className="align-fabricStyles-left" sm="1">
                <FormLabel>IsAllowZeroCost</FormLabel>{" "}
              </Col>

              <Col sm="2">
                <InputCheckbox
                  name="isAllowZeroCostFlag"
                  onChange={this.onChange}
                  checked={purchaseOrderData.isAllowZeroCostFlag}
                  disabled={disablePurchaseOrderFormFields}
                />
              </Col>
            </Row>

            <div>
              <div>
                {" "}
                <Row>
                  {/* <Col sm="2">
                    <FormLabel>PurchaseOrder Lines</FormLabel>
                  </Col> */}
                  {/* <Col sm="1">
                    <Button
                      id="fabric_Add_Button"
                      size="sm"
                      onClick={(e) => this.addNewPOLine(e)}
                      disabled={disableUpdatableFields}
                    >
                      AddLine{" "}
                    </Button>
                  </Col> */}
                  <Col sm="2">
                    <Button
                      id="fabric_Add_Button"
                      className="header_buttons"
                      size="sm"
                      onClick={(e) => this.onExcelClick(e)}
                      disabled={disableUpdatableFields}
                    >
                      Load From Excel
                    </Button>
                  </Col>
                  <input
                    type="file"
                    id="file-input"
                    style={{ display: "none" }}
                    onChange={this.uploadExcelFile}
                    accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
                  />
                </Row>
              </div>
              <div>
                <MultiViewPopup
                  popupLvlClass={"popupSizeLevel0"}
                  isModulePopup={false}
                  isShowPopup={this.props.isShowLinePopup}
                  closeOnEsc={false}
                  closeAlertModalCallBack={
                    this.closeAlertLinePopupModalCallBack
                  }
                  title={"LINE DETAIL"}
                  closeOnDocumentClick={false}
                  lineFunctionalityForm={this.lineFunctionalityForm}
                  alertContainerBox={
                    <AlertToolBox
                      alertMsgList={this.props.alertMessage}
                      alertErrorType={this.props.alertType}
                      isShowAlert={this.props.isShowPopupAlert}
                      hideAlertCallBack={this.props.hideAlertCallBack}
                    />
                  }
                  headerButtonContainer={
                    <div className="floatLeft">
                      <Button
                        size="sm"
                        className="header_buttons enterFocus"
                        onClick={(e) => this.onClick(e)}
                        //  disabled={disableUpdatableFields}
                        disabled={
                          this.props.isTexco
                            ? lineUpdateDisableForTexco
                            : disableUpdatableFields
                        }
                      >
                        Add/Update
                      </Button>
                      <Button
                        className="header_buttons enterFocus"
                        size="sm"
                        onClick={(e) => this.addorUpdateMultiplePOLine(e)}
                        // disabled={disableUpdatableFields}
                        disabled={
                          this.props.isTexco
                            ? lineUpdateDisableForTexco
                            : disableUpdatableFields
                        }
                      >
                        Add+ [f9]
                      </Button>

                      <Button
                        className="header_buttons"
                        size="sm"
                        onClick={(e) => this.clearLineValues(e)}
                        //  disabled={disableUpdatableFields}
                        disabled={
                          this.props.isTexco
                            ? lineUpdateDisableForTexco
                            : disableUpdatableFields
                        }
                      >
                        Clear
                      </Button>
                    </div>
                  }
                  content={
                    <div tabIndex="0" onKeyDown={this.onKeyPress}>
                      <LineDetailsEntryPopup
                        {...this.state}
                        isViewMode={this.props.isViewMode}
                        is3PL={this.props.is3PL}
                        fabricStyleData={this.props.currentFabricStyle}
                        isShowReserveAllocation={
                          this.props.isShowReserveAllocation
                        }
                        isShowAdjQtyButton={this.props.isShowAdjQtyButton}
                        purchaseOrderData={this.props.purchaseOrderData}
                        purchaseOrderLineData={this.props.purchaseOrderLineData}
                        disablePurchaseOrderFormFields={
                          this.props.disablePurchaseOrderFormFields
                        }
                        fabricPageListForAutoCompleteList={
                          this.props.fabricPageListForAutoCompleteList
                        }
                        showAutoCompleteFabricList={
                          this.props.showAutoCompleteFabricList
                        }
                        colorLookupHandler={this.props.colorLookupHandler}
                        fabricColourPageListForAutoCompleteList={
                          this.props.fabricColourPageListForAutoCompleteList
                        }
                        showAutoCompleteColourList={
                          this.props.showAutoCompleteColourList
                        }
                        // isModify={this.isModify}
                        isShowColorLookup={this.props.isShowColorLookup}
                        lnkFabricModule={this.lnkFabricModule}
                        // vendorPuchaseHistory={this.vendorPuchaseHistory}
                        // itemCurrentInventoryLevel={this.itemCurrentInventoryLevel}
                        // itemInventoryPosition={this.itemInventoryPosition}
                        copyPreviousLine={this.copyPreviousLine}
                        adjustedQuantity={this.adjustedQuantity}
                        onFabricCodeChange={this.onFabricCodeChange}
                        fabricCodeEnterKeyEventHandler={
                          this.fabricCodeEnterKeyEventHandler
                        }
                        onLineChange={this.onLineChange}
                        onFabricColourCodeChange={this.onFabricColourCodeChange}
                        fabricColourEnterKeyEventHandler={
                          this.fabricColourEnterKeyEventHandler
                        }
                        displayAutoCompleteColourList={
                          this.displayAutoCompleteColourList
                        }
                        displayAutoCompleteList={this.displayAutoCompleteList}
                        salesOrderAlocation={this.props.salesOrderAlocation}
                        isModifyPosible={this.isModifyPosible}
                        getPoLineImagePathMain={
                          this.props.getPoLineImagePathMain
                        }
                        getPoLineImagePathWeb={this.props.getPoLineImagePathWeb}
                        getPoLineImagePathFront={
                          this.props.getPoLineImagePathFront
                        }
                        getPoLineImagePathBack={
                          this.props.getPoLineImagePathBack
                        }
                        openCustomerReserveAllocationPopup={
                          this.props.openCustomerReserveAllocationPopup
                        }
                        isDisabledFields={this.props.isDisabledFields}
                        openItemPurchaseHistoryInq={
                          this.openItemPurchaseHistoryInq
                        }
                        openItemInvPositionInq={this.openItemInvPositionInq}
                        openItemCurrentInvInq={this.openItemCurrentInvInq}
                        authClick={this.authClick}
                        isTexco={this.props.isTexco}
                        isTexcoDiableUpdateFields={
                          this.props.isTexcoDiableUpdateFields
                        }
                        colorCodeRef={this.props.colorCodeRef}
                        vendorStyleRef={this.props.vendorStyleRef}
                        fabricStyleRef={this.props.fabricStyleRef}
                        onfabricBlur={this.onfabricBlur}
                        onfabricKeyDown={this.onfabricKeyDown}
                        openVendorCostDetailsInq={
                          this.props.openVendorCostDetailsInq
                        }
                        openAllVendorCostDetailsInq={
                          this.props.openAllVendorCostDetailsInq
                        }
                      />
                    </div>
                  }
                />

                {/* <MultiViewPopup
                  popupLvlClass={"popupSizeLevel1"}
                  isModulePopup={false}
                  isShowPopup={this.state.isShowItemCurrentInventoryPopup}
                  closeOnEsc={false}
                  closeAlertModalCallBack={
                    this.closeItemCurrentInventoryAlertModalCallBack
                  }
                  title={"FabricStyle Current Inventory Level"}
                  closeOnDocumentClick={false}
                  content={
                    <ItemInventoryDetails
                      purchaseOrderLineData={this.props.purchaseOrderLineData}
                    />
                  }
                /> */}
                {/* <MultiViewPopup
                  popupLvlClass={"popupSizeLevel2"}
                  isModulePopup={false}
                  isShowPopup={this.state.isShowVendorItemPurchaseHistoryPopup}
                  closeOnEsc={false}
                  closeAlertModalCallBack={
                    this.closeVendorItemPurchaseHistoryAlertModalCallBack
                  }
                  title={"Vendor Purchase Details"}
                  closeOnDocumentClick={false}
                  content={
                    <VendorItemPurchaseHistoryDetails
                      purchaseOrderLineData={this.props.purchaseOrderLineData}
                      purchaseOrderData={this.props.purchaseOrderData}
                    />
                  }
                /> */}
                {/* <MultiViewPopup
                  popupLvlClass={"popupSizeLevel1"}
                  isModulePopup={false}
                  isShowPopup={this.state.isShowItemInventoryPositionPopup}
                  closeOnEsc={false}
                  closeAlertModalCallBack={
                    this.closeItemInventoryPositionAlertModalCallBack
                  }
                  title={"FabricStyle Inventory Position"}
                  closeOnDocumentClick={false}
                  content={
                    <ItemInventoryPositionDetails
                      purchaseOrderLineData={this.props.purchaseOrderLineData}
                      purchaseOrderData={this.props.purchaseOrderData}
                    />
                  }
                /> */}
                <MultiViewPopup
                  popupLvlClass={"popupSizeLevel1"}
                  isModulePopup={true}
                  id="modulePopup"
                  isShowPopup={this.state.isShowFabricPurchaseHistoryInq}
                  closeModalCallBack={this.closeModalCallBack}
                  module={this.state.moduleForPopup}
                ></MultiViewPopup>
                <MultiViewPopup
                  popupLvlClass={"popupSizeLevel1"}
                  isModulePopup={true}
                  id="modulePopup"
                  isShowPopup={this.state.isShowItemInventoryPositionInq}
                  closeModalCallBack={this.closeModalCallBack}
                  module={this.state.moduleForPopup}
                ></MultiViewPopup>
                <MultiViewPopup
                  popupLvlClass={"popupSizeLevel1"}
                  isModulePopup={true}
                  id="modulePopup"
                  isShowPopup={this.state.isShowItemCurrentInventoryInq}
                  closeModalCallBack={this.closeModalCallBack}
                  module={this.state.moduleForPopup}
                ></MultiViewPopup>
                <MultiViewPopup
                  popupLvlClass={"popupSizeLevel1"}
                  isModulePopup={false}
                  isShowPopup={this.props.isShowAdjustedQuantityPopup}
                  closeOnEsc={false}
                  closeAlertModalCallBack={
                    this.closeAdjutedQuantityAlertModalCallBack
                  }
                  title={"PurchaseOrderLine Adjustment Details"}
                  closeOnDocumentClick={false}
                  alertContainerBox={
                    <AlertToolBox
                      alertMsgList={this.props.alertMessage}
                      alertErrorType={this.props.alertType}
                      isShowAlert={this.props.isShowLineAlert}
                      hideAlertCallBack={this.props.hideAlertCallBack}
                    />
                  }
                  headerButtonContainer={
                    <div className="floatLeft">
                      <Button
                        className="header_buttons enterFocus"
                        onClick={(e) => this.adjContinue(e)}
                      >
                        Continue
                      </Button>
                    </div>
                  }
                  content={
                    <AdjustedQuantityDetail
                      {...this.state}
                      is3PL={this.props.is3PL}
                      purchaseOrderData={this.props.purchaseOrderData}
                      continue={this.continue}
                      purchaseOrderLineAdjustmentDataList={poLineAdjData}
                      purchaseOrderLineAdjustmentData={
                        this.props.purchaseOrderLineAdjustmentData
                      }
                      onAdjLineChange={this.onAdjLineChange}
                      addOrUpdateAdj={this.addOrUpdateAdj}
                      purchaseOrderLineData={this.props.purchaseOrderLineData}
                      purchaseOrderLineDatas={this.props.purchaseOrderLineData}
                      onAdjLineClick={this.onAdjLineClick}
                      adjReason={this.props.adjReason}
                      isDisabledFields={this.props.isDisabledFields}
                      onAdjLineReasonChange={this.onAdjLineReasonChange}
                      reasonEnterKeyEventHandler={
                        this.adjReasonEnterKeyEventHandler
                      }
                      displayAutoCompleteReasonList={
                        this.displayAutoCompleteAdjReasonList
                      }
                      showAutoCompleteReasonList={
                        this.props.showAutoCompleteAdjReasonList
                      }
                      reasonPageListForAutoCompleteList={
                        this.props.adjReasonPageListForAutoCompleteList
                      }
                      isModifyPosible={this.isModifyPosible}
                      deleteAdjustment={this.deleteAdjustment}
                      isShowAdjDeleteButton={this.props.isShowAdjDeleteButton}
                      clearAdjLines={this.clearAdjLines}
                    />
                  }
                />
                <ProgressBar
                  progressLoadingText={this.state.progressLoadingText}
                  isShowPopup={this.state.isShowProgressBarPopup}
                />
                <MultiViewPopup
                  popupLvlClass={"popupSizeLevel1"}
                  isModulePopup={false}
                  isShowPopup={this.props.isSalesOrderAllocationPopup}
                  closeOnEsc={false}
                  closeAlertModalCallBack={
                    this.props.closeSalesOrderAllocationAlertModalCallBack
                  }
                  title={"PurchaseOrderLine SalesLine Details"}
                  closeOnDocumentClick={false}
                  alertContainerBox={
                    <AlertToolBox
                      alertMsgList={this.props.alertMessage}
                      alertErrorType={this.props.alertType}
                      isShowAlert={this.props.isShowLineAlert}
                      hideAlertCallBack={this.props.hideAlertCallBack}
                    />
                  }
                  headerButtonContainer={
                    <div className="floatLeft">
                      <Button
                        className="header_buttons enterFocus"
                        onClick={(e) => this.salesOrderAllocationContinue(e)}
                      >
                        Continue
                      </Button>
                    </div>
                  }
                  content={
                    <SalesOrderAllocation
                      {...this.state}
                      is3PL={this.props.is3PL}
                      purchaseOrderLineData={this.props.purchaseOrderLineData}
                      lineDatas={this.props.lineDatas}
                      purchaseOrderData={this.props.purchaseOrderData}
                      addOrUpdateSoLines={this.props.addOrUpdateSoLines}
                      purchaseSourceSalesOrderLineData={
                        this.props.purchaseSourceSalesOrderLineData
                      }
                      onSalesAllocationChange={
                        this.props.onSalesAllocationChange
                      }
                      salesLinesContinue={this.props.salesLinesContinue}
                      onSelectedChange={this.props.onSelectedChange}
                      deleteLine={this.props.deleteLine}
                      isDisabledFields={this.props.isDisabledFields}
                      onSalesOrderChange={this.props.onSalesOrderChange}
                      salesCodeEnterKeyEventHandler={
                        this.props.salesCodeEnterKeyEventHandler
                      }
                      displayAutoCompleteSalesList={
                        this.props.displayAutoCompleteSalesList
                      }
                      salesPageListForAutoCompleteList={
                        this.props.salesPageListForAutoCompleteList
                      }
                      showAutoCompleteSOList={this.props.showAutoCompleteSOList}
                      multipleLines={this.props.multipleLines}
                      unSelectAll={this.props.unSelectAll}
                      selectAll={this.props.selectAll}
                      loadLines={this.props.loadLines}
                      salesAlocationLines={this.props.salesAlocationLines}
                      filterSoLines={this.props.filterSoLines}
                      onSoCustomerChange={this.props.onSoCustomerChange}
                      customerLookupHandler={this.state.customerLookupHandler}
                      customerCodeEnterKeyEventHandler={
                        this.props.customerCodeEnterKeyEventHandler
                      }
                      customerCodePageListForAutoCompleteList={
                        this.props.customerCodePageListForAutoCompleteList
                      }
                      displayAutoCompleteCustomerList={
                        this.props.displayAutoCompleteCustomerList
                      }
                      showAutoCompleteCustomerList={
                        this.props.showAutoCompleteCustomerList
                      }
                      onCustomerCodeChange={this.props.onCustomerCodeChange}
                      isModifyPosible={this.isModifyPosible}
                      hideAlertCallBack={this.props.hideAlertCallBack}
                      isTexco={this.props.isTexco}
                    />
                  }
                />
                <MultiViewPopup
                  popupLvlClass={"popupSizeLevel3"}
                  isModulePopup={false}
                  isShowPopup={this.props.isCustomerReserveAllocationPopup}
                  closeOnEsc={false}
                  closeAlertModalCallBack={
                    this.props.closeAlertModalCallBackLvl2
                  }
                  title={"Customer Reservation Details"}
                  closeOnDocumentClick={false}
                  alertContainerBox={
                    <AlertToolBox
                      alertMsgList={this.props.alertMessage}
                      alertErrorType={this.props.alertType}
                      isShowAlert={this.props.isShowAlertLvl1}
                      hideAlertCallBack={this.props.hideAlertCallBackLvl1}
                    />
                  }
                  headerButtonContainer={
                    <div className="floatLeft">
                      {/* <Button
                        className="header_buttons enterFocus"
                        onClick={this.continue}
                      >
                        Continue
                      </Button> */}
                    </div>
                  }
                  content={
                    <ReserveAllocation
                      {...this.state}
                      purchaseOrderLineData={this.props.purchaseOrderLineData}
                      is3PL={this.props.is3PL}
                    />
                  }
                />

                <MultiViewPopup
                  popupLvlClass={"popupSizeLevel6"}
                  isModulePopup={false}
                  isShowPopup={this.props.isAuthenticationPopup}
                  closeOnEsc={false}
                  closeAlertModalCallBack={
                    this.props.closeAlertModalCallBackLvl2
                  }
                  title={"Price Authentication"}
                  closeOnDocumentClick={false}
                  alertContainerBox={
                    <AlertToolBox
                      alertMsgList={this.props.alertMessage}
                      alertErrorType={this.props.alertType}
                      isShowAlert={this.props.isShowAlertLvl1}
                      hideAlertCallBack={this.props.hideAlertCallBackLvl1}
                    />
                  }
                  headerButtonContainer={
                    <div className="floatLeft">
                      {this.props.isShowPriceChangable && (
                        <Button
                          className="header_buttons enterFocus"
                          onClick={this.priceOncontinue}
                        >
                          Continue
                        </Button>
                      )}
                    </div>
                  }
                  content={
                    <div>
                      <Row></Row>
                      <Row>
                        {!this.props.isShowPriceChangable && (
                          <Col sm="3">
                            <FormLabel>Password#</FormLabel>
                          </Col>
                        )}
                        {!this.props.isShowPriceChangable && (
                          <Col sm="6">
                            <div className="auth-box-containers">
                              <InputTextbox
                                type={showPassword ? "text" : "password"}
                                // placeholder="PASSWORD"
                                required
                                name="authenticationPassword"
                                id="authenticationPassword"
                                value={this.props.authenticationPassword}
                                onChange={this.props.authOnChange}
                              />

                              <button
                                type="button"
                                onClick={this.togglePassword}
                                style={{
                                  position: "absolute",
                                  right: "20px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  background: "transparent",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                              >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                              </button>
                            </div>
                          </Col>
                        )}
                        {this.props.isShowPriceChangable && (
                          <Col sm="2">
                            <FormLabel>Cost</FormLabel>
                          </Col>
                        )}
                        {this.props.isShowPriceChangable && (
                          <Col sm="6">
                            <NumberFormatInputbox
                              name={"cost"}
                              onChange={this.props.costOnChange}
                              placeholder="Enter cost"
                              value={this.props.modifyCost}
                              className="text-end"
                              decimalScale={2}
                              isMandatory={true}
                            />
                          </Col>
                        )}
                      </Row>
                      {!this.props.isShowPriceChangable && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Row>
                            <Col>
                              <Button
                                className="header_buttons enterFocus"
                                onClick={(e) =>
                                  this.props.checkAuthentication(e)
                                }
                              >
                                Continue
                              </Button>
                            </Col>
                            <Col>
                              <Button
                                className="header_buttons enterFocus"
                                onClick={(e) =>
                                  this.props.clearAuthetication(e)
                                }
                              >
                                Clear
                              </Button>
                            </Col>
                          </Row>
                        </div>
                      )}
                    </div>
                  }
                />
              </div>
            </div>
            {/* <div className="div_Custom_1">
              <Table id="fabrics_tables_default">
                <thead>
                  <tr>
                    <th></th>
                    <th>ln#</th>
                    {is3PL ? <th>Item</th> : <th>Fabric</th>}
                    <th>Name</th>
                    <th>Color</th>
                    <th>Status</th>
                    <th>UOM#</th>
                    <th>Qty#</th>
                    <th>Cost</th>
                    <th>LnTotal</th>
                  </tr>
                </thead>
                <tbody>
                  {lines.map((ln, index) => (
                    <tr key={index}>
                      <td>
                        {!disableCancelButton ? (
                          <Button
                            size="sm"
                            variant="secondry"
                            id="fabric_Add_Button"
                            className="enterFocus"
                            onClick={() => this.cancelPurchaseOrderLine(ln)}
                          >
                            <DeleteIcon />
                          </Button>
                        ) : (
                          <div></div>
                        )}
                      </td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={() => this.onLineClick(ln)}
                        >
                          {ln.lineNumber}
                        </Button>
                      </td>
                      <td>{ln.fabricStyleCode}</td>
                      <td>{ln.fabricStyleName}</td>
                      <td>{ln.colorCode}</td>
                      <td>
                        {ModuleUtils.getPurchaseOrderLineStatusCaption(
                          ln.lineStatus
                        )}
                      </td>
                      <td>{ln.uomCode}</td>
                      <td>{ln.orderQuantity}</td>
                      <td>{ln.cost}</td>
                      <td>{ln.lineTotalAmount}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div> */}
            <div className="div_Custom_1">
              {/* <Table id="fabrics_tables_default">
                <thead>
                  <tr>
                    <th>
                      {" "}
                      <Button
                        size="sm"
                        onClick={(e) => this.addNewPOLine(e)}
                        disabled={disableUpdatableFields}
                        id="fabric_Add_Button"
                      >
                        <AddIcon />
                      </Button>
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingPoLinesChange(e, "lineNumber")
                      }
                    >
                      ln#
                      {this.props.order === "desc" &&
                        this.props.sortField === "lineNumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    {is3PL ? (
                      <th
                        onClick={(e) =>
                          this.handleSortingPoLinesChange(e, "fabricStyleCode")
                        }
                      >
                        Item
                        {this.props.order === "desc" &&
                          this.props.sortField === "fabricStyleCode" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                    ) : (
                      <th
                        onClick={(e) =>
                          this.handleSortingPoLinesChange(e, "fabricStyleCode")
                        }
                      >
                        Fabric
                        {this.props.order === "desc" &&
                          this.props.sortField === "fabricStyleCode" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                    )}
                    <th
                      onClick={(e) =>
                        this.handleSortingPoLinesChange(e, "fabricStyleName")
                      }
                    >
                      Name
                      {this.props.order === "desc" &&
                        this.props.sortField === "fabricStyleName" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingPoLinesChange(e, "colorCode")
                      }
                    >
                      Color
                      {this.props.order === "desc" &&
                        this.props.sortField === "colorCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingPoLinesChange(e, "orderQuantity")
                      }
                    >
                      Qty#
                      {this.props.order === "desc" &&
                        this.props.sortField === "orderQuantity" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingPoLinesChange(e, "inTransitQuantity")
                      }
                    >
                      IntransitQty#
                      {this.props.order === "desc" &&
                        this.props.sortField === "inTransitQuantity" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingPoLinesChange(e, "receivedQuantity")
                      }
                    >
                      Rcd Qty#
                      {this.props.order === "desc" &&
                        this.props.sortField === "receivedQuantity" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingPoLinesChange(e, "openQuantity")
                      }
                    >
                      Open Qty#
                      {this.props.order === "desc" &&
                        this.props.sortField === "openQuantity" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingPoLinesChange(e, "cost")
                      }
                    >
                      Cost
                      {this.props.order === "desc" &&
                        this.props.sortField === "cost" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingPoLinesChange(e, "uomCode")
                      }
                    >
                      UOM#
                      {this.props.order === "desc" &&
                        this.props.sortField === "uomCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingPoLinesChange(e, "lineTotalAmount")
                      }
                    >
                      Extension
                      {this.props.order === "desc" &&
                        this.props.sortField === "lineTotalAmount" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingPoLinesChange(e, "lineStatus")
                      }
                    >
                      Status
                      {this.props.order === "desc" &&
                        this.props.sortField === "lineStatus" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingPoLinesChange(e, "comments")
                      }
                    >
                      Comments
                      {this.props.order === "desc" &&
                        this.props.sortField === "comments" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {poLinesList.map((ln, index) => (
                    <tr key={index}>
                      <td>
                        <ShortCutMenuPopup
                          value={ln.fabricStyleCode}
                          menuItems={
                            <ul>
                              <li
                                className="shortcut-menu-item"
                                onClick={(e) =>
                                  this.lnkFabricModule(e, ln.fabricStyleCode)
                                }
                              >
                                {" "}
                                Item Info{" "}
                              </li>
                              <li
                                className="shortcut-menu-item"
                                // onClick={this.vendorPuchaseHistory}
                                onClick={(e) =>
                                  this.openItemPurchaseHistoryInq(
                                    e,
                                    ln.fabricStyleCode
                                  )
                                }
                              >
                                {" "}
                                Vendor-Item Purchase History{""}
                              </li>
                              <li
                                className="shortcut-menu-item"
                                // onClick={this.itemCurrentInventoryLevel}
                                onClick={(e) =>
                                  this.openItemCurrentInvInq(
                                    e,
                                    ln.fabricStyleCode
                                  )
                                }
                              >
                                {" "}
                                Item Current Inventory Level{""}
                              </li>
                              <li
                                className="shortcut-menu-item"
                                // onClick={this.itemInventoryPosition}
                                onClick={(e) =>
                                  this.openItemInvPositionInq(
                                    e,
                                    ln.fabricStyleCode
                                  )
                                }
                              >
                                {" "}
                                Item Inventory Position{""}
                              </li>
                              {/* <li
                      className="shortcut-menu-item"
                      onClick={(e) => this.copyPreviousLine(e)}
                    >
                      {" "}
                      Copy Previous Line{" "}
                    </li> 
                            </ul>
                          }
                        />
                      </td>

                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) => this.onLineClick(e, ln)}
                        >
                          {ln.lineNumber}
                        </Button>
                      </td>
                      <td>{ln.fabricStyleCode}</td>
                      <td>{ln.fabricStyleName}</td>
                      <td>{ln.colorCode}</td>
                      <td>{ln.orderQuantity}</td>
                      <td>{ln.inTransitQuantity}</td>
                      <td>{ln.receivedQuantity}</td>
                      <td>{ln.openQuantity}</td>
                      <td>{toCommaSeperatedAmount(ln.cost)}</td>
                      <td>{ln.uomCode}</td>
                      <td>{ln.lineTotalAmount}</td>
                      <td>
                        {ModuleUtils.getPurchaseOrderLineStatusCaption(
                          ln.lineStatus
                        )}
                      </td>
                      <td>{ln.comments}</td>
                      <td>
                        {!disableCancelButton ? (
                          <Button
                            size="sm"
                            variant="secondry"
                            id="fabric_Add_Button"
                            className="enterFocus"
                            onClick={(e) => this.cancelPurchaseOrderLine(e, ln)}
                          >
                            <DeleteIcon />
                          </Button>
                        ) : (
                          <div></div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table> */}
              <CustomTable
                columns={this.poLineColumns()}
                data={lines}
                label={"PurchaseOrder Lines"}
                isResizable={true}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
class LineDetailsEntryPopup extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    // this.fabricStyleRef = React.createRef();
    // this.colorCodeRef = React.createRef();
    this.state = {};
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.setFocus();
    this.initLookupHandlers();
  }

  initLookupHandlers = () => {
    let purchaseOrderData = this.props.purchaseOrderData;
    if (this.props.is3PL) {
      let fabricLookupHandler = new FabricStyleLookupHandler(
        this.companyCode,
        "Item",
        purchaseOrderData.customerCode,
      );
      this.setState({ fabricLookupHandler: fabricLookupHandler });
    } else {
      let fabricLookupHandler = new FabricStyleLookupHandler(
        this.companyCode,
        "FabricStyle",
      );
      this.setState({ fabricLookupHandler: fabricLookupHandler });
    }
  };

  setFocus = () => {
    if (
      this.props.fabricStyleRef.current != null &&
      this.props.fabricStyleRef.current != undefined
    ) {
      setTimeout(() => {
        this.props.fabricStyleRef.current.focus();
      }, 100);
    }
  };

  onLineChange = (e) => {
    this.props.onLineChange(e);
  };
  authClick = (e) => {
    this.props.authClick(e);
  };
  onFabricCodeChange = (e) => {
    this.props.onFabricCodeChange(e);
  };
  fabricCodeEnterKeyEventHandler = (e) => {
    this.props.fabricCodeEnterKeyEventHandler(e);
    // if (this.colorCodeRef.current != null) {
    this.props.colorCodeRef.current.focus();
    // }
  };
  onFabricColourCodeChange = (e) => {
    this.props.onFabricColourCodeChange(e);
  };
  fabricColourEnterKeyEventHandler = (e) => {
    this.props.fabricColourEnterKeyEventHandler(e);
  };

  displayAutoCompleteColourList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteColourList(showAutoCompleteList);
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteList(showAutoCompleteList);
  };
  salesOrderAlocation = (e) => {
    if (e.detail == 1) this.props.salesOrderAlocation();
  };
  isModifyPosible = () => {
    return this.props.isModifyPosible();
  };
  adjustedQuantity = (e) => {
    if (e.detail == 1) this.props.adjustedQuantity();
  };
  copyPreviousLine = (e) => {
    if (e.detail == 1) this.props.copyPreviousLine();
  };
  // itemInventoryPosition = () => {
  //   this.props.itemInventoryPosition();
  // };
  // itemCurrentInventoryLevel = () => {
  //   this.props.itemCurrentInventoryLevel();
  // };
  // vendorPuchaseHistory = () => {
  //   this.props.vendorPuchaseHistory();
  // };
  lnkFabricModule = (e) => {
    if (e.detail == 1) this.props.lnkFabricModule();
  };

  onfabricKeyDown = (e) => {
    if (e.keyCode == 113 || e.keyCode == 27) {
      this.setState({
        isAllowRead: true,
      });
    }
    this.props.onfabricKeyDown(e);
  };
  onfabricBlur = (e) => {
    this.props.onfabricBlur(e);
  };

  render() {
    let purchaseOrderData = this.props.purchaseOrderData;
    let purchaseOrderLineData = this.props.purchaseOrderLineData;

    let fabricStyleData = this.props.fabricStyleData;
    let disablePurchaseOrderFormFields =
      this.props.disablePurchaseOrderFormFields;
    let isModify = false;
    isModify = this.isModifyPosible();
    if (!purchaseOrderLineData.isFetched) {
      disablePurchaseOrderFormFields = false;
    }
    let isDisabledFields = this.props.isDisabledFields;
    let disableUpdatableFields = false;
    if (disablePurchaseOrderFormFields) {
      if (isModify) {
        disableUpdatableFields = false;
      } else {
        if (
          purchaseOrderData.orderStatus ===
          LogicConstants.PURCHASE_ORDER_UNAPPROVE_STATUS
        ) {
          disableUpdatableFields = false;
        } else {
          disableUpdatableFields = true;
        }
      }
    }
    if (this.props.isViewMode) {
      disableUpdatableFields = true;
    }
    let is3PL = this.props.is3PL;

    let isShowPriceModifyButton = false;
    if (
      purchaseOrderData.orderStatus ===
      LogicConstants.PURCHASE_ORDER_APPROVE_STATUS
    ) {
      isShowPriceModifyButton = true;
    }
    return (
      <div className="center_div col-md-12 col-lg-12 text-center">
        <Row>
          <Col sm="1">
            <FormLabel>Line#</FormLabel>
          </Col>

          <Col sm="2">
            <InputTextbox
              name="lineNumber"
              type="text"
              placeholder="Enter LineNumber"
              value={purchaseOrderLineData.lineNumber}
              disabled={true}
              isMandatory={true}
            />
          </Col>

          <Col className="so-align-items-left" sm="1">
            <FormLabel
              className="hyperlinklabel"
              onClick={(e) => this.lnkFabricModule(e)}
            >
              {is3PL ? "Item#" : "Fabric Style#"}
            </FormLabel>
            <Col>
              <ShortCutMenuPopup
                value={purchaseOrderLineData.fabricStyleCode}
                menuItems={
                  <ul>
                    <li
                      className="shortcut-menu-item"
                      onClick={(e) => this.lnkFabricModule(e)}
                    >
                      {" "}
                      Item Info{" "}
                    </li>
                    <li
                      className="shortcut-menu-item"
                      // onClick={this.vendorPuchaseHistory}
                      onClick={(e) =>
                        this.props.openItemPurchaseHistoryInq(
                          e,
                          purchaseOrderLineData.fabricStyleCode,
                        )
                      }
                    >
                      {" "}
                      Vendor-Item Purchase History{""}
                    </li>
                    <li
                      className="shortcut-menu-item"
                      // onClick={this.itemCurrentInventoryLevel}
                      onClick={(e) =>
                        this.props.openItemCurrentInvInq(
                          e,
                          purchaseOrderLineData.fabricStyleCode,
                        )
                      }
                    >
                      {" "}
                      Item Current Inventory Level{""}
                    </li>
                    <li
                      className="shortcut-menu-item"
                      // onClick={this.itemInventoryPosition}
                      onClick={(e) =>
                        this.props.openItemInvPositionInq(
                          e,
                          purchaseOrderLineData.fabricStyleCode,
                        )
                      }
                    >
                      {" "}
                      Item Inventory Position{""}
                    </li>
                    <li
                      className="shortcut-menu-item"
                      onClick={(e) => this.copyPreviousLine(e)}
                    >
                      {" "}
                      Copy Previous Line{" "}
                    </li>
                  </ul>
                }
              />
            </Col>
          </Col>

          <Col sm="2">
            <InputTextbox
              // onKeyDown={this.onfabricKeyDown}
              onValueChangeOnBlur={this.onfabricBlur}
              valueChangeOnBlur={true}
              ref={this.props.fabricStyleRef}
              name="fabricStyleCode"
              onChange={this.onFabricCodeChange}
              disabled={disablePurchaseOrderFormFields}
              value={purchaseOrderLineData.fabricStyleCode}
              lookupRequired={true}
              lookupHandler={this.state.fabricLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.fabricCodeEnterKeyEventHandler}
              autoCompleteListData={
                this.props.fabricPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteList}
              showAutoCompleteList={this.props.showAutoCompleteFabricList}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="3">
            <InputTextbox
              name="fabricStyleName"
              type="text"
              placeholder="Enter FabricStyleName"
              value={purchaseOrderLineData.fabricStyleName}
              onChange={this.onLineChange}
              readOnly={true}
              disabled={true}
            />
          </Col>

          <Col sm="1">
            <FormLabel>Color</FormLabel>
          </Col>

          <Col sm="2">
            <InputTextbox
              ref={this.props.colorCodeRef}
              name="colorCode"
              type="text"
              placeholder="Enter Color"
              value={purchaseOrderLineData.colorCode}
              onChange={this.onFabricColourCodeChange}
              lookupRequired={this.props.isShowColorLookup}
              lookupHandler={this.props.colorLookupHandler}
              enterKeyEventHandler={this.fabricColourEnterKeyEventHandler}
              autoCompleteListData={
                this.props.fabricColourPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteColourList}
              showAutoCompleteList={this.props.showAutoCompleteColourList}
              disabled={disablePurchaseOrderFormFields}
              isMandatory={true}
              readOnly={!this.props.isShowColorLookup}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>VendorStyle#</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="vendorStyleCode"
              type="text"
              placeholder="Enter vendorStyleCode"
              ref={this.props.vendorStyleRef}
              value={purchaseOrderLineData.vendorStyleCode}
              onChange={this.onLineChange}
              disabled={disablePurchaseOrderFormFields}
            />
          </Col>

          <Col sm="1">
            <FormLabel>VendorColor#</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="vendorStyleColorCode"
              type="text"
              placeholder="Enter vendorStyleColorCode"
              value={purchaseOrderLineData.vendorStyleColorCode}
              onChange={this.onLineChange}
              disabled={disablePurchaseOrderFormFields}
            />
          </Col>
          {!is3PL ? (
            <>
              <Col sm="1">
                <FormLabel>Width</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="widthCode"
                  type="text"
                  placeholder="Enter widthCode"
                  value={purchaseOrderLineData.widthCode}
                  onChange={this.onLineChange}
                  disabled={true}
                />
              </Col>
            </>
          ) : null}
          <Col sm="1">
            <FormLabel>UOM</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="uomCode"
              type="text"
              placeholder="Enter uomCode"
              value={purchaseOrderLineData.uomCode}
              onChange={this.onLineChange}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          {this.props.isTexco ? (
            <>
              <Col className="so-align-items-left" sm="1">
                <FormLabel className="hyperLinkText">cost</FormLabel>
                <Col className="so-align-items-left">
                  <ShortCutMenuPopup
                    value={purchaseOrderLineData.fabricStyleCode}
                    menuItems={
                      <ul>
                        <li
                          className="shortcut-menu-item"
                          onClick={(e) =>
                            this.props.openAllVendorCostDetailsInq(
                              e,
                              purchaseOrderLineData.cost,
                              purchaseOrderLineData,

                              //row.customerCode
                            )
                          }
                        >
                          All Vendor Cost Purchase Details{" "}
                        </li>

                        <li
                          className="shortcut-menu-item"
                          onClick={(e) =>
                            this.props.openVendorCostDetailsInq(
                              e,
                              purchaseOrderLineData.cost,
                              purchaseOrderLineData,
                              //row.customerCode
                            )
                          }
                        >
                          Vendor Cost Purchase Details
                        </li>
                      </ul>
                    }
                  />
                </Col>
              </Col>

              <Col sm="2">
                <div className="auth-box-containers">
                  <NumberFormatInputbox
                    ref={this.CostRef}
                    name={"cost"}
                    onChange={this.onLineChange}
                    placeholder="Enter cost"
                    value={purchaseOrderLineData.cost}
                    className="text-end"
                    decimalScale={2}
                    // isModifyEditable={this.props.isTexco ? null : disableUpdatableFields}
                    // isModifyView={this.props.isTexco ? null : disableUpdatableFields}
                    // isModifyEditable={disableUpdatableFields}
                    // isModifyView={isModify}
                    //disabled={disableUpdatableFields}
                    //disabled worked for the disableUpdatableFields
                    // disabled={
                    //   this.props.isTexco
                    //     ? this.props.isTexcoDiableUpdateFields
                    //     : disableUpdatableFields
                    // }
                    disabled={disableUpdatableFields}
                    isMandatory={true}

                    // authentication = {true}
                  />
                  {isShowPriceModifyButton ? (
                    <Button
                      tabIndex={-1}
                      onClick={this.authClick}
                      // disabled={this.state.isDisabled}
                    >
                      <Authentication />
                    </Button>
                  ) : null}
                </div>
              </Col>
            </>
          ) : (
            <>
              <Col sm="1">
                <FormLabel>cost</FormLabel>
              </Col>

              <Col sm="2">
                <div className="auth-box-containers">
                  <NumberFormatInputbox
                    ref={this.CostRef}
                    name={"cost"}
                    onChange={this.onLineChange}
                    placeholder="Enter cost"
                    value={purchaseOrderLineData.cost}
                    className="text-end"
                    decimalScale={2}
                    isModifyEditable={disableUpdatableFields}
                    isModifyView={disableUpdatableFields}
                    disabled={disableUpdatableFields}
                    isMandatory={true}

                    // authentication = {true}
                  />
                </div>
              </Col>
            </>
          )}

          <Col sm="1">
            <FormLabel>Qty</FormLabel>
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name={"orderQuantity"}
              onChange={this.onLineChange}
              placeholder="Enter orderQuantity"
              value={purchaseOrderLineData.orderQuantity}
              className="text-end"
              decimalScale={2}
              isModifyEditable={disableUpdatableFields}
              isModifyView={isModify}
              disabled={disableUpdatableFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>OrderStartDate</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="orderStartDate"
              type="date"
              value={purchaseOrderLineData.orderStartDate}
              onChange={this.onLineChange}
              isModifyView={isModify}
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>

          <Col sm="1">
            <FormLabel>OrderStopDate</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="orderStopDate"
              type="date"
              value={purchaseOrderLineData.orderStopDate}
              onChange={this.onLineChange}
              isModifyView={isModify}
              disabled={disablePurchaseOrderFormFields}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col className="so-align-items-left" sm="1">
            <FormLabel>Adj Qty</FormLabel>
            {this.props.isShowAdjQtyButton && (
              <Col>
                <ShortCutMenuPopup
                  value={purchaseOrderData.code}
                  menuItems={
                    <ul>
                      <li
                        className="shortcut-menu-item"
                        onClick={(e) => this.adjustedQuantity(e)}
                      >
                        {" "}
                        Adjusted Quantity{" "}
                      </li>
                    </ul>
                  }
                />
              </Col>
            )}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name={"adjustedQuantity"}
              onChange={this.onLineChange}
              placeholder="Enter adjustedQuantity"
              value={purchaseOrderLineData.adjustedQuantity}
              className="text-end"
              decimalScale={2}
              disabled={true}
            />
          </Col>

          <Col sm="1">
            <FormLabel>LineTotalAmount</FormLabel>
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name={"lineTotalAmount"}
              onChange={this.onLineChange}
              placeholder="Enter lineTotalAmount"
              value={purchaseOrderLineData.lineTotalAmount}
              className="text-end"
              decimalScale={2}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Rcd Qty</FormLabel>
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name={"receivedQuantity"}
              onChange={this.onLineChange}
              placeholder="Enter receivedQuantity"
              value={purchaseOrderLineData.receivedQuantity}
              className="text-end"
              decimalScale={2}
              disabled={true}
            />
          </Col>

          <Col sm="1">
            <FormLabel>Rcd Adj Qty</FormLabel>
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name={"receivedAdjustedQuantity"}
              onChange={this.onLineChange}
              placeholder="Enter receivedAdjustedQuantity"
              value={purchaseOrderLineData.receivedAdjustedQuantity}
              className="text-end"
              decimalScale={2}
              disabled={true}
            />
          </Col>
        </Row>
        <div>
          <Button
            id="fabric_Add_Button"
            onClick={(e) => this.salesOrderAlocation(e)}
            disabled={disablePurchaseOrderFormFields}
          >
            Sales Order Allocation
          </Button>

          {this.props.isShowReserveAllocation && (
            <Button
              id="fabric_Add_Button"
              onClick={(e) => this.props.openCustomerReserveAllocationPopup(e)}
            >
              Customer Reserve Allocation
            </Button>
          )}
        </div>
        <Row>
          <Col sm="2">
            <img
              src={`${this.props.getPoLineImagePathMain(
                fabricStyleData,
              )}&a=${new Date().getTime()}`}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = noImage;
              }}
              alt="Click to Add"
              width={75}
              height={75}
              mode="fit"
            />{" "}
          </Col>
          <Col sm="2">
            <img
              src={`${this.props.getPoLineImagePathWeb(
                fabricStyleData,
              )}&a=${new Date().getTime()}`}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = noImage;
              }}
              alt="Click to Add"
              width={75}
              height={75}
              mode="fit"
            />{" "}
          </Col>
          <Col sm="2">
            <img
              src={`${this.props.getPoLineImagePathFront(
                fabricStyleData,
              )}&a=${new Date().getTime()}`}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = noImage;
              }}
              alt="Click to Add"
              width={75}
              height={75}
              mode="fit"
            />{" "}
          </Col>
          <Col sm="2">
            <img
              src={`${this.props.getPoLineImagePathBack(
                fabricStyleData,
              )}&a=${new Date().getTime()}`}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = noImage;
              }}
              alt="Click to Add"
              width={75}
              height={75}
              mode="fit"
            />{" "}
          </Col>
        </Row>
      </div>
    );
  }
}
class SalesOrderAllocation extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      purchaseOrderData: this.props.purchaseOrderData,
      purchaseOrderLineData: new PurchaseOrderLineBean(),
      isShowElements: false,
      isShowPopup: false,
      inquiryDataList: [],
      criteria: new PurchaseSourceSalesOrderLineDetailSearchCriteria(),
      error_list: [],
      pageList: new PageListBean(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      purchaseAdjustmentReasons: [],
      purchaseOrderLineAdjustmentData:
        this.props.purchaseOrderLineAdjustmentData,
      adjReasonLookupHandler: null,
      isMultipleLinesPopup: false,
      purchaseSourceSalesOrderLineData:
        this.props.purchaseSourceSalesOrderLineData,
      lineDatas: this.props.lineDatas,
      soArray: [],
      salesOrderLookupHandler: null,
      salesOrderNumber: [],
      isShowSalesOrderModule: false,
      moduleForPopup: [],
      // listrequest: null,
      customerLookupHandler: null,
    };

    this.skyLightDialogRef = React.createRef();
    this.fabricStyleCodeRef = React.createRef();
    this.customerCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.skuNumber = this.props.purchaseOrderLineData.skuNumber;
    this.setState({
      criteria: criteria,
    });
    this.props.loadLines();
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let salesOrderLookupHandler = new SalesOrderLookupHandler(
      this.companyCode,
      "SalesOrder",
      this.props.purchaseOrderLineData.fabricStyleCode,
      this.props.purchaseOrderLineData.colorCode,
      "A",
    );
    this.setState({ salesOrderLookupHandler: salesOrderLookupHandler });

    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer",
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
  };

  multipleLines = (e) => {
    if (e.detail == 1) {
      this.setState({
        isMultipleLinesPopup: true,
      });
      this.props.multipleLines();
    }
  };
  salesLinesContinue = (e) => {
    if (e.detail == 1) {
      this.props.salesLinesContinue();
      this.closeMultipleLinesAlertModalCallBack(false);
    }
  };
  closeMultipleLinesAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isMultipleLinesPopup: isShowPopup,
      isShowAlert: isShowPopup,
      isOpenImagePopup: isShowPopup,
      isOpenColorPopup: isShowPopup,
      isOpenOnHandDetailPopup: isShowPopup,
      temp_selectedLineList: [],
    });
  };
  onSelectedChange = (evt, line) => {
    this.props.onSelectedChange(evt, line);
  };

  deleteLine = (e, rowData) => {
    if (e.detail == 1) this.props.deleteLine(rowData);
  };
  viewSalesModule = (e, val, rowData) => {
    if (e.detail == 1) {
      let code = rowData.salesOrderNumber;
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesOrderModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeSalesModalCallBack = (isOpen) => {
    this.setState({ isShowSalesOrderModule: isOpen, moduleForPopup: [] });
  };
  soLineColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", "isActive", false)
        .setInputDetails(false, false, true, null, this.onSelectedChange, null)
        .setStyleDetails("", "", "", "wt-1-5 ", "wt-1-5 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesOrder#", "salesOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setClickDetails(true, false, this.viewSalesModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer PO#", "customerPurchaseOrderNumber", true, true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Order Start Date", "orderStartDate", true, true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Order Stop Date", "orderStopDate", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Order Qty", "orderQuantity", true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );

    return columns;
  };
  linesColumnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails("LineSelect", "isActive", 0, false, "5", null, false, null)
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.onSelectedChange,
        ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "SalesOrder#",
        "salesOrderNumber",
        0,
        true,

        this.viewSalesModule,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Customer", "customerCode"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("CustomerName", "customerName"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Customer PO#",
        "customerPurchaseOrderNumber",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Order Start Date",
        "orderStartDate",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Order Stop Date",
        "orderStopDate",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Order Qty", "orderQuantity"),
    );

    return columnList;
  };

  onSalesAllocationChange = (e) => {
    this.props.onSalesAllocationChange(e);
  };
  onSalesOrderChange = (e) => {
    this.props.onSalesOrderChange(e);
  };
  salesCodeEnterKeyEventHandler = (e) => {
    this.props.salesCodeEnterKeyEventHandler(e);
  };
  displayAutoCompleteSalesList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteSalesList(showAutoCompleteList);
  };

  render() {
    let purchaseOrderLineData = this.state.purchaseOrderLineData;
    let purchaseOrderLineDatas = this.props.purchaseOrderLineData;
    let purchaseSourceSalesOrderLineData =
      this.props.purchaseSourceSalesOrderLineData;

    purchaseSourceSalesOrderLineData.purchaseOrderLineNumber =
      purchaseOrderLineData.lineNumber;
    purchaseSourceSalesOrderLineData.purchaseOrderNumber =
      purchaseOrderLineData.purchaseOrderNumber;
    var styles = {
      header: {
        style: {
          minHeight: "0px",
        },
      },
      table: {
        style: {
          minHeight: "300px",
          maxHeight: "600px",
          overflow: "auto",
        },
      },
    };
    var linesStyles = {
      header: {
        style: {
          minHeight: "0px",
        },
      },
      table: {
        style: {
          minHeight: "20em",
          maxHeight: "20em",
          overflow: "auto",
        },
      },
    };
    let lines = this.props.salesAlocationLines;
    let lineDatas = [];
    if (this.props.purchaseOrderLineData.sourceSalesOrderLines)
      lineDatas = this.props.purchaseOrderLineData.sourceSalesOrderLines;
    let isDisabledFields = this.props.isDisabledFields;
    let is3PL = this.props.is3PL;
    return (
      <div className="PurchaseOrderPopup">
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowSalesOrderModule}
          closeModalCallBack={this.closeSalesModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <Row>
          <Col sm="1">
            <FormLabel>CompanyCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name={"companyCode"}
              value={purchaseOrderLineDatas.companyCode}
              className="text-end"
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>PO#</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name={"purchaseOrderNumber"}
              placeholder="Enter purchaseOrderNumber"
              value={purchaseOrderLineDatas.purchaseOrderNumber}
              className="text-end"
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Ln#</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name={"lineNumber"}
              value={purchaseOrderLineDatas.lineNumber}
              className="text-end"
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>

          <Col sm="1">
            <FormLabel>Width</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name={"widthCode"}
              value={purchaseOrderLineDatas.widthCode}
              className="text-end"
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          {is3PL ? (
            <Col sm="1">
              <FormLabel>Item</FormLabel>
            </Col>
          ) : (
            <Col sm="1">
              <FormLabel>Fabric#</FormLabel>
            </Col>
          )}
          <Col sm="2">
            <InputTextbox
              name={"fabricStyleCode"}
              value={purchaseOrderLineDatas.fabricStyleCode}
              className="text-end"
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>

          <Col sm="3">
            <InputTextbox
              name={"fabricStyleName"}
              value={purchaseOrderLineDatas.fabricStyleName}
              className="text-end"
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Color</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name={"colorCode"}
              value={purchaseOrderLineDatas.colorCode}
              className="text-end"
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>

          <Col sm="1">
            <FormLabel>SKU</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name={"skuNumber"}
              value={purchaseOrderLineDatas.skuNumber}
              className="text-end"
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>UOM</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name={"uomCode"}
              value={purchaseOrderLineDatas.uomCode}
              className="text-end"
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>
          {!this.props.isTexco && (
            <Col sm="2">
              <Button
                id="fabric_Add_Button"
                onClick={(e) => this.multipleLines(e)}
              >
                MultipleLines
              </Button>
            </Col>
          )}
        </Row>
        <Row>
          <div>
            <Table className="salesAlocationTable">
              <thead>
                <tr>
                  <th>SalesOrder#</th>
                  <th>Customer</th>
                  <th>CustomerName</th>
                  <th>CustomerPO#</th>
                  <th>OrderStartDate</th>
                  <th>OrderStopDate</th>
                  <th>OrderQty</th>
                  <th></th>
                </tr>
              </thead>
              {lineDatas.map((info, index) => (
                <tbody>
                  <tr key={index}>
                    <td>
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.viewSalesModule(e, info.salesOrderNumber, info)
                        }
                      >
                        {info.salesOrderNumber}
                      </Button>
                    </td>

                    <td>{info.customerCode}</td>

                    <td>{info.customerName}</td>
                    <td>{info.customerPurchaseOrderNumber}</td>
                    <td>{info.orderStartDate}</td>
                    <td>{info.orderStopDate}</td>
                    <td>{info.orderQuantity}</td>
                    {info.isFetched == false ? (
                      <td className="hyperLinkText">
                        <Button
                          variant="secondry"
                          onClick={(e) => this.deleteLine(e, info)}
                        >
                          <DeleteIcon />
                        </Button>
                      </td>
                    ) : (
                      <td></td>
                    )}
                  </tr>
                </tbody>
              ))}
            </Table>
          </div>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>SalesOrder#</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.onSalesOrderChange}
              name="salesOrderNumber"
              placeholder="salesOrderNumber"
              value={purchaseSourceSalesOrderLineData.salesOrderNumber}
              lookupRequired={true}
              lookupHandler={this.state.salesOrderLookupHandler}
              disabled={isDisabledFields}
              enterKeyEventHandler={this.salesCodeEnterKeyEventHandler}
              autoCompleteListData={this.props.salesPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteSalesList}
              showAutoCompleteList={this.props.showAutoCompleteSOList}
              isMandatory={true}
            ></InputTextbox>
          </Col>
          <Col sm="1">
            <FormLabel>Customer#</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.onSalesAllocationChange}
              name={"customerCode"}
              value={purchaseSourceSalesOrderLineData.customerCode}
              className="text-end"
              disabled={true}
            />
          </Col>

          <Col sm="3">
            <InputTextbox
              onChange={this.onSalesAllocationChange}
              name={"customerName"}
              value={purchaseSourceSalesOrderLineData.customerName}
              className="text-end"
              disabled={true}
            />
          </Col>

          <Col sm="1">
            <FormLabel>CustomerPO#$</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.onSalesAllocationChange}
              name={"customerPurchaseOrderNumber"}
              value={
                purchaseSourceSalesOrderLineData.customerPurchaseOrderNumber
              }
              className="text-end"
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Order StartDate</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.onSalesAllocationChange}
              name={"orderStartDate"}
              value={purchaseSourceSalesOrderLineData.orderStartDate}
              className="text-end"
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Order StopDate</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.onSalesAllocationChange}
              name={"orderStopDate"}
              value={purchaseSourceSalesOrderLineData.orderStopDate}
              className="text-end"
              disabled={true}
            />
          </Col>

          <Col sm="1">
            <FormLabel>Order Qty</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.onSalesAllocationChange}
              name={"orderQuantity"}
              value={purchaseSourceSalesOrderLineData.orderQuantity}
              className="text-end"
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>
          {!this.props.isTexco && (
            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                onClick={(e) => this.props.addOrUpdateSoLines(e)}
                disabled={isDisabledFields}
              >
                Add/Update
              </Button>
            </Col>
          )}
        </Row>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.state.isMultipleLinesPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeMultipleLinesAlertModalCallBack}
          title={"Multiple SalesOrder Line Selection"}
          closeOnDocumentClick={false}
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                onClick={(e) => this.salesLinesContinue(e)}
                disabled={isDisabledFields}
              >
                Continue
              </Button>
            </div>
          }
          content={
            <div>
              <Row>
                <Col sm="1">
                  <FormLabel>CompanyCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name={"companyCode"}
                    value={purchaseOrderLineDatas.companyCode}
                    className="text-end"
                    disabled={isDisabledFields}
                    isMandatory={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>PO#</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name={"purchaseOrderNumber"}
                    placeholder="Enter purchaseOrderNumber"
                    value={purchaseOrderLineDatas.purchaseOrderNumber}
                    className="text-end"
                    disabled={isDisabledFields}
                    isMandatory={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>Ln#</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name={"lineNumber"}
                    value={purchaseOrderLineDatas.lineNumber}
                    className="text-end"
                    disabled={isDisabledFields}
                    isMandatory={true}
                  />
                </Col>

                <Col sm="1">
                  <FormLabel>Width</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name={"widthCode"}
                    value={purchaseOrderLineDatas.widthCode}
                    className="text-end"
                    disabled={isDisabledFields}
                    isMandatory={true}
                  />
                </Col>
              </Row>
              <Row>
                {is3PL ? (
                  <Col sm="1">
                    <FormLabel>Item#</FormLabel>
                  </Col>
                ) : (
                  <Col sm="1">
                    <FormLabel>Fabric#</FormLabel>
                  </Col>
                )}
                <Col sm="2">
                  <InputTextbox
                    name={"fabricStyleCode"}
                    value={purchaseOrderLineDatas.fabricStyleCode}
                    className="text-end"
                    disabled={isDisabledFields}
                    isMandatory={true}
                  />
                </Col>

                <Col sm="3">
                  <InputTextbox
                    name={"fabricStyleName"}
                    value={purchaseOrderLineDatas.fabricStyleName}
                    className="text-end"
                    disabled={isDisabledFields}
                    isMandatory={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>Color</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name={"colorCode"}
                    value={purchaseOrderLineDatas.colorCode}
                    className="text-end"
                    disabled={isDisabledFields}
                    isMandatory={true}
                  />
                </Col>

                <Col sm="1">
                  <FormLabel>SKU</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name={"skuNumber"}
                    value={purchaseOrderLineDatas.skuNumber}
                    className="text-end"
                    disabled={isDisabledFields}
                    isMandatory={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>UOM</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name={"uomCode"}
                    value={purchaseOrderLineDatas.uomCode}
                    className="text-end"
                    disabled={isDisabledFields}
                    isMandatory={true}
                  />
                </Col>
                <Col sm="2">
                  <Button
                    id="fabric_Add_Button"
                    onClick={(e) => this.props.selectAll(e)}
                  >
                    SelectAll
                  </Button>
                </Col>
                <Col sm="2">
                  <Button
                    id="fabric_Add_Button"
                    onClick={(e) => this.props.unSelectAll(e)}
                  >
                    UnSelectAll
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>Customer</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    onChange={this.props.onCustomerCodeChange}
                    ref={this.customerCodeRef}
                    name="customerCode"
                    placeholder="Customer"
                    value={purchaseOrderLineDatas.customerCode}
                    lookupRequired={true}
                    lookupHandler={this.state.customerLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={
                      this.props.customerCodeEnterKeyEventHandler
                    }
                    autoCompleteListData={
                      this.props.customerCodePageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.props.displayAutoCompleteCustomerList
                    }
                    showAutoCompleteList={
                      this.props.showAutoCompleteCustomerList
                    }
                  />
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="customerName"
                    type="text"
                    onChange={this.onChange}
                    readOnly={true}
                    value={purchaseOrderLineDatas.customerName}
                  />{" "}
                </Col>
                <Col sm="2">
                  <Button
                    id="fabric_Add_Button"
                    onClick={(e) => this.props.filterSoLines(e)}
                  >
                    Filter
                  </Button>
                </Col>
              </Row>
              {/* <EditableDataGrid
                customStyles={styles}
                columnsList={this.linesColumnDefinitions()}
                dataList={lines}
                isLoading={false}
              /> */}
              <CustomTable
                columns={this.soLineColumns()}
                data={lines}
                label={"SoLines"}
              />
            </div>
          }
        />
      </div>
    );
  }
}
class ReserveAllocation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    let purchaseOrderLineData = this.props.purchaseOrderLineData;
    let is3PL = this.props.is3PL;
    return (
      <div className="">
        <Row>
          <Col sm="1">
            <FormLabel>CompanyCode</FormLabel>{" "}
          </Col>

          <Col sm="2">
            <InputTextbox
              name="companyCode"
              // onChange={this.onChange}
              value={purchaseOrderLineData.companyCode}
              disabled={true}
            />{" "}
          </Col>

          <Col sm="1">
            <FormLabel>PO#</FormLabel>{" "}
          </Col>

          <Col sm="2">
            <InputTextbox
              name="purchaseOrderNumber"
              // onChange={this.onChange}
              value={purchaseOrderLineData.purchaseOrderNumber}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>Line#</FormLabel>{" "}
          </Col>

          <Col sm="2">
            <InputTextbox
              name="lineNumber"
              // onChange={this.onChange}
              value={purchaseOrderLineData.lineNumber}
              disabled={true}
            />{" "}
          </Col>
        </Row>
        <Row>
          {is3PL ? (
            <Col sm="1">
              <FormLabel>Item</FormLabel>{" "}
            </Col>
          ) : (
            <Col sm="1">
              <FormLabel>FabricStyle</FormLabel>{" "}
            </Col>
          )}

          <Col sm="2">
            <InputTextbox
              name="fabricStyleCode"
              // onChange={this.onSkuCostChange}
              value={purchaseOrderLineData.fabricStyleCode}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="3">
            <InputTextbox
              name="fabricStyleName"
              // onChange={this.onSkuCostChange}
              value={purchaseOrderLineData.fabricStyleName}
              disabled={true}
            />{" "}
          </Col>

          <Col sm="1">
            <FormLabel>Color</FormLabel>{" "}
          </Col>

          <Col sm="2">
            <InputTextbox
              name="fabricStyleColorCode"
              // onChange={this.onSkuCostChange}
              value={purchaseOrderLineData.fabricStyleColorCode}
              disabled={true}
            />{" "}
          </Col>

          <Col sm="1">
            <FormLabel>SkuNumber</FormLabel>{" "}
          </Col>

          <Col sm="2">
            <InputTextbox
              name="skuNumber"
              // onChange={this.onSkuCostChange}
              value={purchaseOrderLineData.skuNumber}
              disabled={true}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Width</FormLabel>{" "}
          </Col>

          <Col sm="2">
            <InputTextbox
              name="widthCode"
              // onChange={this.onSkuCostChange}
              value={purchaseOrderLineData.widthCode}
              disabled={true}
            />{" "}
          </Col>

          <Col sm="1">
            <FormLabel>UOM</FormLabel>{" "}
          </Col>

          <Col sm="2">
            <InputTextbox
              name="uomCode"
              // placeholder="Enter cost"
              // onChange={this.onLandingCostChange}
              value={purchaseOrderLineData.uomCode}
              disabled={true}
            />{" "}
          </Col>
        </Row>

        <br />
        <div>
          <div className="div_Custom_1">
            <Table id="fabrics_tables">
              <thead>
                <tr>
                  <th>Customer</th>
                  <th>CustomerName</th>
                  <th>Order Qty</th>
                  <th>Open Qty</th>
                </tr>
              </thead>
              <tbody>
                {/* {skuVendorCosts.map(
                    (line, i) =>
                      line.isDeleted != true && (
                        <tr key={i} data-item={line}>
                          <td>
                            <Button
                              size="sm"
                              variant="secondry"
                              className="hyperLinkText"
                              // onClick={() => this.getLineDetails(line)}
                            >
                              {line.customerCode}
                            </Button>
                          </td>
                          <td>{line.customerName}</td>
                          <td>{line.orderQuantity}</td>
                          <td>{line.openQuantity}</td>
                        
                        </tr>
                      )
                  )} */}
              </tbody>
            </Table>
          </div>
          <Row>
            <Col className="align-items-left" sm="1">
              <FormLabel>Customer#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                // ref={this.vendorCodeRef}
                // name="customerCode"
                // //type="vendorCode"
                // placeholder="Select customerCode"
                // onChange={this.onCustomerReservePopupChange}
                // value={reserveData.customerCode}
                // lookupRequired={true}
                // lookupHandler={this.state.customerLookupHandler}
                // enterKeyEventHandler={
                //   this.customerReservePopupEnterKeyEventHandler
                // }
                // autoCompleteListData={
                //   this.props.customerPageListForAutoCompleteList
                // }
                // enableAutoCompleteTextBox={true}
                // displayAutoCompleteList={
                //   this.displayAutoCompleteReservePopupCustomerList
                // }
                // showAutoCompleteList={this.props.showAutoCompleteCustomerList}
                disabled={true}
              />
            </Col>

            <Col sm="3">
              <InputTextbox
                name="customerName"
                placeholder="Enter customerName"
                // onChange={this.reserveLineChange}
                // value={reserveData.customerName}
                disabled={true}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>OrderQty</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                // name={"orderQty"}
                // value={reserveData.orderQty}
                // onChange={this.reserveLineChange}
                // className="text-right"
                // decimalScale={2}
                disabled={true}
              />
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>ReceivedQty</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                // name={"receivedQty"}
                // value={reserveData.receivedQty}
                // onChange={this.reserveLineChange}
                // className="text-right"
                // decimalScale={2}
                disabled={true}
              />
            </Col>
          </Row>{" "}
          <Row>
            <Col className="align-items-left" sm="1">
              <FormLabel>OpenQty</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                // name={"OpenQty"}
                // value={reserveData.OpenQty}
                // onChange={this.reserveLineChange}
                // className="text-right"
                // decimalScale={2}
                disabled={true}
              />
            </Col>
          </Row>
          <div>
            <Button
              id="fabric_Add_Button"
              // className="enterFocus"
              size="sm1"
              bssize="large"
              // onClick={() => this.addReserveAllocationLine()}
              disabled={true}
            >
              Add / Update{" "}
            </Button>
            <Button
              id="fabric_Add_Button"
              // className="enterFocus"
              size="sm1"
              bssize="large"
              // onClick={() => this.clearLineValues()}
              disabled={true}
            >
              Clear{" "}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
class AdjustedQuantityDetail extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      purchaseOrderData: new PurchaseOrderBean(),
      purchaseOrderLineData: new PurchaseOrderLineBean(),
      isShowElements: false,
      isShowPopup: false,
      inquiryDataList: [],
      criteria: new InventorySalesPurchasePositionCriteriaBean(),
      error_list: [],
      pageList: new PageListBean(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      purchaseAdjustmentReasons: [],
      adjReasonLookupHandler: null,
    };
    this.skyLightDialogRef = React.createRef();
    this.fabricStyleCodeRef = React.createRef();
    this.reasonCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };

    const purchaseAdjustmentReasons = new Array();
    if (!isEmptyArray(attribute_cache.purchaseOrderUnApprovalReasons))
      purchaseAdjustmentReasons.push(
        ...attribute_cache.purchaseOrderUnApprovalReasons,
      );
    this.state.purchaseAdjustmentReasons = purchaseAdjustmentReasons;

    if (this.reasonCodeRef.current != null) {
      this.reasonCodeRef.current.focus();
    }
    this.initLookupHandlers();
  }
  componentDidUpdate() {}
  customeOnKeyDown = (event) => {
    if (event.keyCode == 113) {
      this.initLookupHandlers();
    }
  };
  initLookupHandlers = () => {
    let adjReasonLookupHandler = new GenericAttributeLookupHandler(
      this.props.adjReason,
      "Adjustment Reason",
    );
    this.setState({ adjReasonLookupHandler: adjReasonLookupHandler });
  };
  onAdjLineClick = (e, rowData) => {
    if (e.detail == 1) this.props.onAdjLineClick(rowData);
  };
  deleteAdjustment = (e, rowData) => {
    if (e.detail == 1) this.props.deleteAdjustment(rowData);
  };
  // columnDefinitions = () => {
  //   let columnList = [];
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "Line#",
  //       "adjustmentLineNumber",
  //       0,
  //       true,
  //       this.onAdjLineClick
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Reason", "code")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Adj Qty", "adjustedQuantity")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Adj UOM", "uomCode")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition()
  //       .setDetails(
  //         "",
  //         <DeleteIcon />,
  //         // true,
  //         1,
  //         false,
  //         null,
  //         false,
  //         null, //image link call back
  //         "1em", //min-width
  //         "3%", //max-width
  //         false,
  //         null,
  //         false
  //       )
  //       .setEditableDetails(
  //         false,
  //         "",
  //         null,
  //         true,
  //         this.deleteAdjustment,
  //         false,
  //         null
  //       )
  //     //.setDisabled(disablePurchaseOrderFormFields)
  //   );

  //   return columnList;
  // };
  continue = () => {
    this.props.continue();
  };
  onAdjLineChange = (e) => {
    this.props.onAdjLineChange(e);
  };

  addOrUpdateAdj = (e) => {
    if (e.detail <= 1) {
      this.props.addOrUpdateAdj();
      this.clearAdjLines(e);
    }
  };
  clearAdjLines = (e) => {
    if (e.detail <= 1) this.props.clearAdjLines();
  };
  onAdjLineReasonChange = (e) => {
    this.props.onAdjLineReasonChange(e);
  };
  reasonEnterKeyEventHandler = (e) => {
    this.props.reasonEnterKeyEventHandler(e);
  };
  displayAutoCompleteReasonList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteReasonList(showAutoCompleteList);
  };
  render() {
    let purchaseOrderLineData = this.props.purchaseOrderLineData;
    let purchaseOrderLineDatas = this.props.purchaseOrderLineDatas;
    let purchaseOrderLineAdjustmentDataList =
      this.props.purchaseOrderLineAdjustmentDataList;
    let purchaseOrderLineAdjustmentData =
      this.props.purchaseOrderLineAdjustmentData;
    purchaseOrderLineAdjustmentData.uomCode = purchaseOrderLineDatas.uomCode;
    purchaseOrderLineAdjustmentData.lineNumber =
      purchaseOrderLineDatas.lineNumber;
    purchaseOrderLineAdjustmentData.companyCode = this.companyCode;
    const textAreaStyle = {
      maxHeight: "3em",
      minHeight: "2em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    let isDisabledFields = this.props.isDisabledFields;
    let is3PL = this.props.is3PL;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.props.alertMessage}
          alertErrorType={this.props.alertType}
          isShowAlert={this.props.isShowLineAlert}
          hideAlertCallBack={this.props.hideAlertCallBack}
        />
        <Row>
          <Col sm="1">
            <FormLabel>CompanyCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name={"companyCode"}
              value={purchaseOrderLineData.companyCode}
              className="text-end"
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>PO#</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name={"purchaseOrderNumber"}
              placeholder="Enter purchaseOrderNumber"
              value={purchaseOrderLineData.purchaseOrderNumber}
              className="text-end"
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Ln#</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name={"lineNumber"}
              value={purchaseOrderLineData.lineNumber}
              className="text-end"
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>

          <Col sm="1">
            <FormLabel>Width</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name={"widthCode"}
              value={purchaseOrderLineData.widthCode}
              className="text-end"
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          {is3PL ? (
            <Col sm="1">
              <FormLabel>Item</FormLabel>
            </Col>
          ) : (
            <Col sm="1">
              <FormLabel>FabricStyleCode</FormLabel>
            </Col>
          )}
          <Col sm="2">
            <InputTextbox
              name={"fabricStyleCode"}
              value={purchaseOrderLineData.fabricStyleCode}
              className="text-end"
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>

          <Col sm="3">
            <InputTextbox
              name={"fabricStyleName"}
              value={purchaseOrderLineData.fabricStyleName}
              className="text-end"
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Color</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name={"colorCode"}
              value={purchaseOrderLineData.colorCode}
              className="text-end"
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>

          <Col sm="1">
            <FormLabel>SKU</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name={"skuNumber"}
              value={purchaseOrderLineData.skuNumber}
              className="text-end"
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>UOM</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name={"uomCode"}
              value={purchaseOrderLineData.uomCode}
              className="text-end"
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>
        </Row>
        <div className="div_Custom_3">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th>Ln#</th>
                <th>Reason</th>
                <th>AdjustedQty</th>
                <th>AdjustedUOM</th>
                <th>Delete</th>
              </tr>
            </thead>
            {purchaseOrderLineAdjustmentDataList != null && (
              <tbody>
                {purchaseOrderLineAdjustmentDataList.map((ln, i) => (
                  <tr key={i} data-item={ln}>
                    <td>
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.onAdjLineClick(e, ln)}
                      >
                        {ln.adjustmentLineNumber}
                      </Button>
                    </td>
                    <td>{ln.code}</td>
                    <td>{ln.adjustedQuantity}</td>
                    <td>{ln.uomCode}</td>
                    <td>
                      {!ln.isFetched && (
                        <Button
                          size="sm"
                          variant="primary"
                          onClick={(e) => this.deleteAdjustment(e, ln)}
                        >
                          <DeleteIcon />
                        </Button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </Table>
        </div>
        <Row>
          <Col sm="1">
            <FormLabel>Ln#</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name={"adjustmentLineNumber"}
              onChange={this.onAdjLineChange}
              placeholder="Enter adjustmentLineNumber"
              value={purchaseOrderLineAdjustmentData.adjustmentLineNumber}
              className="text-end"
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Reason Code</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={this.reasonCodeRef}
              name="code"
              onChange={this.onAdjLineReasonChange}
              value={purchaseOrderLineAdjustmentData.code}
              placeholder="Reason"
              lookupRequired={true}
              lookupHandler={this.state.adjReasonLookupHandler}
              disabled={isDisabledFields}
              enterKeyEventHandler={this.reasonEnterKeyEventHandler}
              autoCompleteListData={
                this.props.reasonPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteReasonList}
              showAutoCompleteList={this.props.showAutoCompleteReasonList}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Adj Qty</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="adjustedQuantity"
              onChange={this.onAdjLineChange}
              value={purchaseOrderLineAdjustmentData.adjustedQuantity}
              className="text-end"
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>

          <Col sm="1">
            <FormLabel>UOM</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name={"uomCode"}
              onChange={this.onAdjLineChange}
              value={purchaseOrderLineAdjustmentData.uomCode}
              className="text-end"
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Description</FormLabel>
          </Col>
          <Col sm="7">
            <textarea
              style={textAreaStyle}
              className="form-control"
              name="description"
              type="text"
              onChange={this.onAdjLineChange}
              value={purchaseOrderLineAdjustmentData.description}
              disabled={isDisabledFields}
            />
          </Col>
          <Col sm="2">
            <Button
              id="fabric_Add_Button"
              className="enterFocus"
              size="sm1"
              onClick={(e) => this.addOrUpdateAdj(e)}
              disabled={isDisabledFields}
            >
              Add/Update
            </Button>
          </Col>
          <Col sm="1">
            <Button
              id="fabric_Add_Button"
              className="enterFocus"
              size="sm1"
              bssize="large"
              onClick={(e) => this.clearAdjLines(e)}
              disabled={isDisabledFields}
            >
              Clear{" "}
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}
// class ItemInventoryPositionDetails extends React.Component {
//   static contextType = AppContext;
//   constructor(props) {
//     super(props);
//     this.state = {
//       purchaseOrderData: new PurchaseOrderBean(),
//       purchaseOrderLineData: new PurchaseOrderLineBean(),
//       isShowElements: false,
//       isShowPopup: false,
//       inquiryDataList: [],
//       criteria: new InventorySalesPurchasePositionCriteriaBean(),
//       error_list: [],
//       pageList: new PageListBean(),
//       isShowPDFButton: false,
//       isShowExcelButton: false,
//     };
//     this.skyLightDialogRef = React.createRef();
//     this.fabricStyleCodeRef = React.createRef();
//   }
//   componentDidMount() {
//     const { appData } = this.context;
//     this.companyCode = appData.companyCode;
//     this.report_url = appData.reportURL;
//     let purchaseOrderLineData = this.props.purchaseOrderLineData;
//     let purchaseOrderData = this.props.purchaseOrderData;
//     let criteria = this.state.criteria;
//     criteria.fabricStyleCode = purchaseOrderLineData.fabricStyleCode;
//     criteria.companyCode = this.companyCode;
//     this.state.pageList = new PageListBean();
//     this.state.pageList.pageSize = 50;
//     this.setState({
//       criteria: criteria,
//     });

//     this.loadPage();
//   }
//   loadPage = () => {
//     let criteria = this.state.criteria;
//     this.loadItemInventoryPositionList(criteria);
//   };
//   loadItemInventoryPositionList = (criteria) => {
//     if (SecurityAccessManager.PurchaseOrderMaintenance_IsAccessible()) {
//       ReportService.inquireInventorySalesPurchasePositionResult(
//         criteria,
//         this.loadItemInventoryPositionListResponse,
//         this.loadItemInventoryPositionListError
//       );
//     } else {
//       let errMsg = "Access Denied";
//       let errList = [];
//       errList.push(errMsg);

//       this.setState({
//         alertMessage: errList,
//         alertType: "danger",
//         isShowAlert: true,
//       });
//     }
//   };
//   loadItemInventoryPositionListResponse = (response) => {
//     let inquiryDataList = response.data.result;

//     if (inquiryDataList != null) {
//       let itemInventoryDataList = [];
//       if (response.data.result.skuInfos)
//         itemInventoryDataList = response.data.result.skuInfos;
//       this.setState({
//         isInquiryDatasFound: true,
//         isShowResetButton: true,
//         inquiryDataList: itemInventoryDataList,
//         isShowPDFButton: true,
//         isShowExcelButton: true,
//       });
//     } else {
//       let errMsg = "No data Found";
//       let errList = this.state.error_list;
//       errList.push(errMsg);
//       this.setState({
//         alertMessage: errList,
//         alertType: "danger",
//         isShowAlert: true,
//       });
//       this.setState({
//         isInquiryDatasFound: false,
//       });
//     }
//   };
//   loadItemInventoryPositionListError = (error) => {
//     ShowError("Error : " + error);
//   };
//   columnDefinitions = () => {
//     let columnList = [];
//     columnList.push(
//       new DataGridColumnDefinition().setDetails("Color Code", "colorCode")
//     );
//     columnList.push(
//       new DataGridColumnDefinition().setDetails("SKU", "skuNumber")
//     );
//     columnList.push(
//       new DataGridColumnDefinition().setDetails("UOM", "inventoryUOMCode")
//     );
//     columnList.push(
//       new DataGridColumnDefinition().setDetails(
//         "OnHandQty",
//         "totalOnHandQuantity"
//       )
//     );
//     columnList.push(
//       new DataGridColumnDefinition().setDetails(
//         "VendorOnOrderQuantity",
//         "totalVendorOnOrderQuantity"
//       )
//     );

//     return columnList;
//   };
//   generateExcel = () => {
//     this.downloadReport(2, this.state.criteria);
//   };
//   generatePDF = () => {
//     this.downloadReport(1, this.state.criteria);
//   };
//   downloadReportResponse = (response) => {
//     let reportFilePath = response.data.reportResult.reportFileID;
//     window.open(this.report_url + reportFilePath);
//   };
//   downloadReportError = (error) => {
//     ShowError("Error : " + error);
//   };
//   downloadReport = (reportType, criteria) => {
//     let reportBean = new RestReportBean();
//     reportBean.reportType = reportType;
//     let requestInput = new SalesPurchasePositionCriteriaBeanRequest();
//     requestInput.companyCode = this.companyCode;
//     requestInput.criteria = criteria;
//     requestInput.reportBean = reportBean;
//     if (SecurityAccessManager.PurchaseOrderMaintenance_IsAccessible()) {
//       ReportService.generateInventorySalesPurchasePositionReport(
//         requestInput,
//         this.downloadReportResponse,
//         this.downloadReportError
//       );
//     } else {
//       let errMsg = "Access Denied";
//       let errList = [];
//       errList.push(errMsg);

//       this.setState({
//         alertMessage: errList,
//         alertType: "danger",
//         isShowAlert: true,
//       });
//     }
//   };
//   render() {
//     let inquiryDataList = this.state.inquiryDataList;
//     return (
//       <div className="PurchaseOrderPopup">
//         <BaseInquiryToolBar
//           isShowPDFButton={this.state.isShowPDFButton}
//           isShowExcelButton={this.state.isShowExcelButton}
//           generatePDF={this.generatePDF}
//           generateExcel={this.generateExcel}
//         />
//         <DataGrid
//           columnsList={this.columnDefinitions()}
//           dataList={inquiryDataList}
//         />
//       </div>
//     );
//   }
// }
// class VendorItemPurchaseHistoryDetails extends React.Component {
//   static contextType = AppContext;
//   constructor(props) {
//     super(props);
//     this.state = {
//       purchaseOrderData: new PurchaseOrderBean(),
//       purchaseOrderLineData: new PurchaseOrderLineBean(),
//       isShowElements: false,
//       isShowPopup: false,
//       inquiryDataList: [],
//       criteria: new VendorPurchaseTrackSearchCriteria(),
//       error_list: [],
//       pageList: new PageListBean(),
//       isShowPurchaseOrderModule: false,
//     };
//     this.skyLightDialogRef = React.createRef();
//     this.fabricStyleCodeRef = React.createRef();
//   }
//   componentDidMount() {
//     const { appData } = this.context;
//     this.companyCode = appData.companyCode;
//     let purchaseOrderLineData = this.props.purchaseOrderLineData;
//     let purchaseOrderData = this.props.purchaseOrderData;
//     let criteria = this.state.criteria;
//     criteria.fabricStyleCode = purchaseOrderLineData.fabricStyleCode;
//     criteria.vendorCode = purchaseOrderData.vendorCode;
//     criteria.companyCode = this.companyCode;
//     this.state.pageList = new PageListBean();
//     this.state.pageList.pageSize = 50;
//     this.setState({
//       criteria: criteria,
//     });
//     this.loadPage();
//   }
//   loadPage = () => {
//     let pageInput = new PageListBean();
//     pageInput.pageSize = 50;
//     let currentPage = this.state.pageList.currentPage;
//     if (currentPage == null || currentPage <= 0) {
//       pageInput.currentPage = 1;
//     } else {
//       pageInput.currentPage = currentPage;
//     }
//     let listrequest = new VendorPurchaseOrderDataRequest();
//     listrequest.criteria = this.state.criteria;
//     listrequest.pageInput = pageInput;
//     this.loadVendorItemPurchaseHistoryList(listrequest);
//   };
//   loadVendorItemPurchaseHistoryList = (listrequest) => {
//     if (SecurityAccessManager.PurchaseOrderMaintenance_IsAccessible()) {
//       ReportService.getVendorPurchaseOrderData(
//         listrequest,
//         this.loadVendorItemPurchaseHistoryResponse,
//         this.loadVendorItemPurchaseHistoryError
//       );
//     } else {
//       let errMsg = "Access Denied";
//       let errList = [];
//       errList.push(errMsg);
//       this.setState({
//         alertMessage: errList,
//         alertType: "danger",
//         isShowAlert: true,
//       });
//     }
//   };
//   loadVendorItemPurchaseHistoryResponse = (response) => {
//     let inquiryDataList = response.data.vendorPurchaseOrderDataPageList;
//     if (inquiryDataList != null) {
//       let itemInventoryDataList = [];
//       if (response.data.vendorPurchaseOrderDataPageList.vendorPurchaseOrders)
//         itemInventoryDataList =
//           response.data.vendorPurchaseOrderDataPageList.vendorPurchaseOrders;
//       this.setState({
//         isInquiryDatasFound: true,
//         isShowResetButton: true,
//         inquiryDataList: itemInventoryDataList,
//         isShowPDFButton: true,
//         isShowExcelButton: true,
//       });
//     } else {
//       let errMsg = "No data Found";
//       let errList = this.state.error_list;
//       errList.push(errMsg);
//       this.setState({
//         alertMessage: errList,
//         alertType: "danger",
//         isShowAlert: true,
//       });
//       this.setState({
//         isInquiryDatasFound: false,
//       });
//     }
//   };
//   loadVendorItemPurchaseHistoryError = (error) => {
//     ShowError("Error : " + error);
//   };
//   viewPurchaseOrderModule = (val, rowData) => {
//     let code = rowData.purchaseOrderNumber;
//     if (code !== "" && code !== undefined) {
//       this.setState({
//         isShowPurchaseOrderModule: true,
//         moduleForPopup: (
//           <PurchaseModule code={code} onModuleExit={this.onPopupModalExit} />
//         ),
//       });
//     }
//   };
//   columnDefinitions = () => {
//     let columnList = [];
//     columnList.push(
//       new DataGridColumnDefinition().setDetails("Vendor Code", "vendorCode")
//     );
//     columnList.push(
//       new DataGridColumnDefinition().setDetails("Vendor Name", "vendorName")
//     );
//     columnList.push(
//       new DataGridColumnDefinition().setDetails(
//         "PO",
//         "purchaseOrderNumber",
//         0,
//         true,
//         this.viewPurchaseOrderModule
//       )
//     );
//     columnList.push(
//       new DataGridColumnDefinition().setDetails(
//         "FabricStyle Code",
//         "fabricStyleCode"
//       )
//     );
//     columnList.push(
//       new DataGridColumnDefinition().setDetails(
//         "FabricStyle Name",
//         "fabricStyleName"
//       )
//     );
//     columnList.push(new DataGridColumnDefinition().setDetails("Cost", "cost"));
//     columnList.push(
//       new DataGridColumnDefinition().setDetails("UOM", "uomCode")
//     );
//     columnList.push(
//       new DataGridColumnDefinition().setDetails("Ord Date", "orderDate")
//     );
//     columnList.push(
//       new DataGridColumnDefinition().setDetails("Ord Qty", "orderQuantity")
//     );
//     columnList.push(
//       new DataGridColumnDefinition().setDetails(
//         "Ord Tot Amt",
//         "orderTotalAmount"
//       )
//     );

//     return columnList;
//   };
//   closePurchaseModalCallBack = (isOpen) => {
//     this.setState({ isShowPurchaseOrderModule: isOpen, moduleForPopup: [] });
//   };
//   render() {
//     let inquiryDataList = this.state.inquiryDataList;
//     return (
//       <div className="PurchaseOrderPopup">
//         <MultiViewPopup
//           popupLvlClass={"popupSizeLevel1"}
//           isModulePopup={true}
//           id="modulePopup"
//           isShowPopup={this.state.isShowPurchaseOrderModule}
//           closeModalCallBack={this.closePurchaseModalCallBack}
//           module={this.state.moduleForPopup}
//         ></MultiViewPopup>
//         <DataGrid
//           columnsList={this.columnDefinitions()}
//           dataList={inquiryDataList}
//         />
//       </div>
//     );
//   }
// }
// class ItemInventoryDetails extends React.Component {
//   static contextType = AppContext;
//   constructor(props) {
//     super(props);
//     this.state = {
//       purchaseOrderData: new PurchaseOrderBean(),
//       purchaseOrderLineData: new PurchaseOrderLineBean(),
//       isShowElements: false,
//       isShowPopup: false,
//       inquiryDataList: [],
//       criteria: new FabricStyleInventoryValuationCriteriaBean(),
//     };
//     this.skyLightDialogRef = React.createRef();
//     this.fabricStyleCodeRef = React.createRef();
//   }
//   componentDidMount() {
//     const { appData } = this.context;
//     this.companyCode = appData.companyCode;
//     let purchaseOrderLineData = this.props.purchaseOrderLineData;
//     let criteria = this.state.criteria;
//     criteria.fabricStyleCode = purchaseOrderLineData.fabricStyleCode;
//     this.setState({
//       criteria: criteria,
//     });
//     this.loadPage();
//   }
//   loadPage = () => {
//     let criteria = this.state.criteria;
//     criteria.companyCode = this.companyCode;
//     this.loadItemInventoryInquiryList(criteria);
//   };
//   loadItemInventoryInquiryList = (criteria) => {
//     if (SecurityAccessManager.PurchaseOrderMaintenance_IsAccessible()) {
//       ReportService.inquireFabricStyleInventoryValuationInfos(
//         criteria,
//         this.loadItemInventoryInquiryListResponse,
//         this.loadItemInventoryInquiryListError
//       );
//     } else {
//       let errMsg = "Access Denied";
//       let errList = [];
//       errList.push(errMsg);
//       this.setState({
//         alertMessage: errList,
//         alertType: "danger",
//         isShowAlert: true,
//       });
//     }
//   };
//   loadItemInventoryInquiryListResponse = (response) => {
//     let inquiryDataList = response.data.result;
//     if (inquiryDataList != null) {

//       let itemInventoryDataList = [];
//       if (response.data.result.valuationInfos)
//         itemInventoryDataList = response.data.result.valuationInfos;
//       this.setState({
//         isInquiryDatasFound: true,
//         isShowResetButton: true,
//         inquiryDataList: itemInventoryDataList,
//         isShowPDFButton: true,
//         isShowExcelButton: true,
//       });
//     } else {
//       let errMsg = "No data Found";
//       let errList = this.state.error_list;
//       errList.push(errMsg);
//       this.setState({
//         alertMessage: errList,
//         alertType: "danger",
//         isShowAlert: true,
//       });
//       this.setState({
//         isInquiryDatasFound: false,
//       });
//     }
//   };
//   loadItemInventoryInquiryListError = (error) => {
//     ShowError("Error : " + error);
//   };
//   columnDefinitions = () => {
//     let columnList = [];
//     columnList.push(
//       new DataGridColumnDefinition().setDetails(
//         "FabricStyle",
//         "fabricStyleCode"
//       )
//     );
//     columnList.push(
//       new DataGridColumnDefinition().setDetails("Color", "fabricStyleColorCode")
//     );
//     columnList.push(
//       new DataGridColumnDefinition().setDetails("SKU", "skuNumber")
//     );
//     columnList.push(
//       new DataGridColumnDefinition().setDetails(
//         "OnHandQuantity",
//         "onHandQuantity"
//       )
//     );
//     columnList.push(
//       new DataGridColumnDefinition().setDetails("UOM", "uomCode")
//     );

//     return columnList;
//   };
//   render() {
//     let inquiryDataList = this.state.inquiryDataList;
//     return (
//       <div className="PurchaseOrderPopup">
//         <DataGrid
//           columnsList={this.columnDefinitions()}
//           dataList={inquiryDataList}
//         />
//       </div>
//     );
//   }
// }
class PurchaseOrderHistoryDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }
   getCaption = (status) => {
      return ModuleUtils.getPurchaseOrderStatusCaption(status);
    };
    checkPrintColumns = () => {
    const columns = new Array();
     columns.push(
          new ColumnDefinition()
            .setDetails("Date", "updatedDate", true)
            .setStyleDetails("left", "10", "", "wt-4", "wt-4")
            // .setClickDetails(true, false, this.viewCustomerModule, null),
        );
        columns.push(
          new ColumnDefinition()
            .setDetails("Done By", "updatedby", true)
              
            .setStyleDetails("left", "10", "", "wt-4", "wt-4"),
        );
       
        columns.push(
          new ColumnDefinition()
            .setDetails("Changes", "description", true)
            .setStyleDetails("left", "10", "", "wt-4", "wt-4"),
        );
        
    return columns;
  }
  statusHistoryColumns = () => {
    const columns = new Array();
     columns.push(
          new ColumnDefinition()
            .setDetails("Date", "createdDate", true)
            .setStyleDetails("left", "10", "", "wt-4", "wt-4")
            // .setClickDetails(true, false, this.viewCustomerModule, null),
        );
        columns.push(
          new ColumnDefinition()
            .setDetails("Status", "currentStatus", true)
              .setStatusDetails(true, this.getCaption)
            .setStyleDetails("left", "10", "", "wt-4", "wt-4"),
        );
        columns.push(
          new ColumnDefinition()
            .setDetails("Previous Status", "previousStatus", true)
              .setStatusDetails(true, this.getCaption)
            .setStyleDetails("left", "10", "", "wt-4", "wt-4"),
        );
        columns.push(
          new ColumnDefinition()
            .setDetails("Done By", "createdBy", true)
            .setStyleDetails("left", "10", "", "wt-4", "wt-4"),
        );
        columns.push(
          new ColumnDefinition()
            .setDetails("Remarks", "remarks", true)
            .setStyleDetails("left", "", "", "wt-2", "wt-2"),
        );
    return columns;
  }
  render() {
    let purchaseOrderData = this.props.purchaseOrderData;

    let statusTracks = purchaseOrderData.statusTracks;
    if (!statusTracks) {
      statusTracks = new Array();
    }
    let changeHistoryTracks = purchaseOrderData.changeHistoryTracks;
    if (!changeHistoryTracks) {
      changeHistoryTracks = new Array();
    }
    return (
      <div className="header_div">
          <div className="so_changes_history_main_div">
        <div className="so_status_history_div">
          {" "}
          <div className="mt-3">
            {/* <FormLabel className="label_head">Status History</FormLabel>
            <Table id="fabrics_tables_default">
              <thead>
                <th>Date</th>
                <th>Status</th>
                <th>Previous Status</th>
                <th>Done By</th>
                <th>Remarks</th>
              </thead>
              <tbody>
                {statusTracks.map((list, index) => (
                  <tr key={index}>
                    <td className="text-end">
                      {ModuleUtils.getDateFormat_v1(list.createdDate)}
                    </td>
                    <td className="text-end">
                      {ModuleUtils.getPurchaseOrderStatusCaption(
                        list.currentStatus,
                      )}
                    </td>
                    <td className="text-end">
                      {ModuleUtils.getPurchaseOrderStatusCaption(
                        list.previousStatus,
                      )}
                    </td>
                    <td className="text-end">{list.createdBy}</td>
                    <td className="text-end">{list.remarks}</td>
                  </tr>
                ))}
              </tbody>
            </Table> */}
             <CustomTable
                            data={statusTracks}
                            columns={this.statusHistoryColumns()}
                            enableVritualizer={true}
                            // subHeaderData={statusTracks}
                            label={"Status History"}
                          />
            {statusTracks.length != 0 ? null : (
              <div className="no_Data_small">{"NO DATA"}</div>
            )}
          </div>
          </div>
          <div className="so_status_history_div">
          <div className="mt-3">
            {/* <FormLabel>Check Printed History</FormLabel> */}
            {/* <Table id="fabrics_tables_default">
              <thead>
                <th>Date</th>
                <th>Done By</th>
                <th>Changes</th>
              </thead>
              <tbody>
                {changeHistoryTracks.map((list, index) => (
                  <tr key={index}>
                    <td className="text-end">
                      {ModuleUtils.getDateFormat_v1(list.updatedDate)}
                    </td>
                    <td className="text-end">{list.updatedby}</td>
                    <td className="text-end">{list.description}</td>
                  </tr>
                ))}
              </tbody>
            </Table> */}
              <CustomTable
                            data={changeHistoryTracks}
                            columns={this.checkPrintColumns()}
                            enableVritualizer={true}
                            // subHeaderData={statusTracks}
                            label={"Check Printed History"}
                          />
            {changeHistoryTracks.length != 0 ? null : (
              <div className="no_Data_small">{"NO DATA"}</div>
            )}
          </div>
          </div>
        </div>
      </div>
    );
  }
}
class PurchaseReceiptForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      moduleForPopup: [],
      isShowPurchaseReceiptModule: false,
    };
  }
  onChange = (e) => {
    this.props.onChange(e);
  };

  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewPOReceiptModule = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseReceiptModule: true,
          moduleForPopup: (
            <PopupPurchaseReceiptModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({ isShowPurchaseReceiptModule: isOpen, moduleForPopup: [] });
  };

  render() {
    let purchaseOrderData = new PurchaseOrderBean();
    purchaseOrderData = this.props.purchaseOrderData;
    let dependenciesBean = new PurchaseOrderModuleDependenciesBean();
    dependenciesBean = this.props.dependenciesBean;
    let receiptList = [];
    if (!isEmpty(dependenciesBean) && !isEmptyArray(dependenciesBean.receipts))
      receiptList = dependenciesBean.receipts;

    return (
      <div className="header_div">
        <div className="div_Custom_1">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th>Receipt</th>
                <th>Date</th>
                <th>Status</th>
                <th>PackingSlip#</th>
              </tr>
            </thead>
            {receiptList != null ? (
              <tbody>
                {receiptList.map((ln, index) => (
                  <tr key={index}>
                    <td className="text-end">
                      <Button
                        size="sm"
                        className="hyperLinkText"
                        variant="secondry"
                        onClick={(e) => this.viewPOReceiptModule(e, ln.code)}
                      >
                        {ln.code}
                      </Button>
                    </td>
                    <td className="text-end">
                      {ModuleUtils.getDateFormat_v1(ln.createdDate)}
                    </td>
                    <td className="text-end">
                      {ModuleUtils.getPurchaseOrderReceiptStatusCaption(
                        ln.receiptStatus,
                      )}
                    </td>
                    <td className="text-end">{ln.packingSlipNumber}</td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {receiptList.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowPurchaseReceiptModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}

class PurchaseInvoicePaymentDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.loadPaymentdetail();
  }
  loadPaymentdetail = () => {
    this.props.loadPaymentdetail();
  };
  purchasePaymentDetailsColumn = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Line", "lineNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CheckTransaction", "checkTransactionNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Type", "paymentType", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Document#", "documentNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Applied Amount", "paymentAmount", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("BankName", "issuedBankName", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PaymentDate", "paymentDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("POReceiptNumber", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PaymentDate", "paymentDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ApprovedAmount", "approvedAmount", true, true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("AmountDue", "AmountDue", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5"),
    );

    return columns;
  };
  render() {
    let vendorInvoiceData = this.props.vendorInvoiceData;

    let paymentDetail = this.props.paymentDetailList;

    return (
      <div>
        <div className="header_div">
          <div className="mt-3">
            <CustomTable
              data={paymentDetail}
              columns={this.purchasePaymentDetailsColumn()}
              label={"paymentDetail"}
            />
            {/* <Table id="fabrics_tables_default">
                <thead>
                  <tr>
                    <th>CheckTransaction</th>
                    <th>Type</th>
                    <th>Document#</th>
                    <th>Applied Amount</th>
                    <th>Amount Due</th>
                    <th>Payment Date</th>
                    <th>Post Date</th>
                    <th>Status</th>
                  </tr>
                </thead>
                {this.props.isPaymentDetailsDatasFound && (
                  <tbody>
                    {paymentDetail.map((detailInfo, index) => (
                      <tr key={index}>
                        {/* <td>{detailInfo.checkTransactionNumber}</td>
                        <td>{detailInfo.paymentType}</td>
                        <td>{detailInfo.documentNumber}</td>
                        <td>{detailInfo.paymentAmount}</td>
                        <td>{ModuleUtils.getDateFormat_v1(detailInfo.amountDue)}</td>
                        <td>{ModuleUtils.getDateFormat_v1(detailInfo.paymentDate)}</td>
                        <td>{ModuleUtils.getDateFormat_v1(detailInfo.paymentPostDate)}</td>
                        <td>{detailInfo.status}</td> */}
            {/* /</div>* </tr> */}
            {/* ))} */}
            {/* </tbody> */}
            {/* )} */}
            {/* </Table> */}
          </div>
        </div>
      </div>
    );
  }
}
export function Images(props) {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(props.imgUrl);
  const [images, setImages] = useState([...props.images]);
  const [img_Url, setImageUrl] = useState([...props.preview_Url]);
  const [tempIndex, setIndex] = useState(null);
  const [tempImage, setTempImages] = useState([]);
  const [tempImg_Url, setTempImageUrl] = useState([]);
  const [isImagePreview, setIsImagePreview] = useState(false);
  const [isImageMainPreview, setIsImageMainPreview] = useState(false);
  const isShowDocLabel = props.isShowDocLabel;
  const [imageEntity, setImagesEntity] = useState(new PurchaseOrderImageBean());
  const [imgDetails, setTempFile] = useState(null);

  const [hover, setHover] = useState(false);
  const [hoverData, setHoverData] = useState(new PurchaseOrderImageBean());
  const [aftUpload, setAftUpload] = useState(false);
  useEffect(() => {
    setImagesEntity(imageEntity);
  }, [imageEntity]);
  const handleChange = (e) => {
    let tempImages = e.target.files;
    if (!isEmptyArray(tempImages)) {
      setIsImageMainPreview(true);
    }
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;
    let img_list = [];
    let previewList = [];
    if (!isEmptyArray(images)) {
      img_list = [...images];
    }
    if (!isEmptyArray(img_Url)) {
      previewList = [...img_Url];
    }
    for (let index = 0; index < tempImages.length; index++) {
      // const element = tempImages[i];
      let imgUrl = "";
      if (tempImages[index].size <= max_size) {
        img_list.push(tempImages[index]);
        imgUrl = URL.createObjectURL(tempImages[index]);

        previewList.push(imgUrl);
      } else {
        props.showToast("image size is greater", 2);
      }
    }
    setImages(img_list);
    setImageUrl(previewList);
  };
  useEffect(() => {
    setImageUrl(img_Url);
  }, [img_Url]);

  useEffect(() => {
    setImages(images);
  }, [images]);
  useEffect(() => {
    setIsImageMainPreview(isImageMainPreview);
  }, [isImageMainPreview]);
  useEffect(() => {
    setTempImages(tempImage);
  }, [tempImage]);
  useEffect(() => {
    setTempImageUrl(tempImg_Url);
  }, [tempImg_Url]);
  const handleImageEditChange = (e) => {
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;

    let images_temp = [];
    let url_temp = [];
    let imgUrl = "";
    if (e.target.files[0].size <= max_size) {
      images_temp = [...images];
      url_temp = [...img_Url];
      setIsImagePreview(true);
      setIsImageMainPreview(false);
      for (let i = 0; i < images_temp.length; i++) {
        if (i === tempIndex) {
          let file = e.target.files[0];
          setFile(file);
        }
      }
      for (let i = 0; i < url_temp.length; i++) {
        if (i === tempIndex) {
          imgUrl = URL.createObjectURL(e.target.files[0]);
          url_temp[i] = imgUrl; // Change the value at index 2
        }
      }
    } else {
      props.showToast("image size is greater", 2);
    }
    setPreviewUrl(imgUrl);
    setTempImages(images_temp);
    setTempImageUrl(url_temp);
  };
  useEffect(() => {
    setIsImagePreview(isImagePreview);
  }, [isImagePreview]);

  const handleSubmit = (e) => {
    e.preventDefault();
    props.setMultiImageUrl(img_Url);
    props.setMultiImgData(images);
    props.uploadMutiImage(images);
    props.showToast("Uploaded Sucessfully", 1);
    setIsImageMainPreview(false);
  };
  const handleEditSubmit = (e) => {
    e.preventDefault();
    let tempFile = file;
    for (let i = 0; i < tempImage.length; i++) {
      if (i === tempIndex) {
        tempFile.imageCode = tempImage[i].imageCode;
        tempImage[i] = tempFile;
      }
    }
    props.setMultiImageUrl(tempImg_Url);
    props.setMultiImgData(tempImage);
    props.uploadMutiImage(tempImage);
    setImageUrl(tempImg_Url);
    props.showToast("Uploaded Sucessfully", 1);
    setIndex(null);
    setIsImagePreview(false);
  };
  const deleteImage = (e) => {
    if (e.detail == 1) {
      setFile(null);
      setPreviewUrl("");
      props.showToast("Image deleted sucessfully", 1);
      setIsImageMainPreview(false);
      setImages(props.images);
      setImageUrl(props.preview_Url);
    }
  };

  const imageview = (e, index, image) => {
    if (!isImageMainPreview) {
      const files = e.target.currentSrc;
      let imgDetails = null;
      const urls = files;
      setPreviewUrl(urls);
      setIndex(index);
      setIsImagePreview(false);

      for (let i = 0; i < props.purchaseOrderData.orderImages.length; i++) {
        if (i === index) {
          imgDetails = props.purchaseOrderData.orderImages[i];
        }
      }

      setTempFile(imgDetails);

      const updatedImageEntity = {
        ...imgDetails, // Spread the class instance to convert to plain object
        tags: imgDetails.tags !== "" ? imgDetails.tags : "",
        notesCommunication: imgDetails.notesCommunication || "",
      };

      setImagesEntity(updatedImageEntity);
      //
    }
  };

  const hoverview = (e, index) => {
    setAftUpload(true);

    if (!aftUpload) return; // Prevent hover logic if 'aftUpload' is false
    if (props.purchaseOrderData.isFetched) {
      const hoverDetails = props.purchaseOrderData.orderImages[index]; // Get the hovered image by index
      if (hoverDetails) {
        setHoverData(hoverDetails); // Set hover data for the hovered image
      } else {
        setHoverData(new PurchaseOrderImageBean()); // Fallback to default or empty data
      }
    }
    setHover(true); // Set hover state to true when mouse is over the image
  };
  const deleteUploadedImage = (e) => {
    if (e.detail === 1) {
      let url_temp = [];
      url_temp = [...img_Url];
      for (let i = 0; i < url_temp.length; i++) {
        if (i === tempIndex) {
          url_temp.splice(i, 1); // Change the value at index 2
        }
      }
      setImageUrl(url_temp);
      props.deleteMutipleImage(tempIndex);
      setPreviewUrl("");
      setTempImageUrl(url_temp);
      setIndex(null);
      setIsImagePreview(false);
    }
  };

  const onImageChange = (e) => {
    const updatedImageEntity = {
      ...imageEntity, // Spread the existing properties
      [e.target.name]: e.target.value, // Update the property based on input name
    };
    setImagesEntity(updatedImageEntity);
  };
  const addImageLines = (e) => {
    if (e.detail === 1) {
      props.addImageLines(imageEntity);
      props.showToast("Details Uploaded Sucessfully", 1);
    }
  };
  const clearImageLines = (e) => {
    if (e.detail === 1) {
      //props.clearImageLines(imageEntity)

      const updatedImageEntity = {
        ...imageEntity, // Spread the existing properties
        tags: "", // Reset tags
        notesCommunication: "", // Reset notesCommunication
      };
      setImagesEntity(updatedImageEntity);
      props.clearImageLines(updatedImageEntity);
    }
  };
  return (
    <div className="header_div  div_default">
      <div className="div_inline">
        <div className="div_30_no_overflow">
          <form onSubmit={handleSubmit}>
            <div className="d-flex justify-content-around ">
              <div>
                <label for="imgTag" className="d-flex justify-content-around">
                  <div className="img_label">
                    Attach Image
                    <span className="img_icon">
                      <CameraIcon />
                    </span>
                  </div>

                  <input
                    type="file"
                    className="img-input"
                    id="imgTag"
                    multiple
                    accept="image/*"
                    onChange={handleChange}
                    disabled={isShowDocLabel}
                  />
                </label>
              </div>
              {isImageMainPreview && (
                <div className="d-flex justify-content-around align-middle">
                  <div className="align-middle-icon">
                    <button
                      id="fabric_Add_Button"
                      type="submit"
                      //  disabled={isShowDocLabel}
                    >
                      Upload
                    </button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteImage(e)}
                      //   disabled={isShowDocLabel}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>

            <div style={{ display: "flex", flexWrap: "wrap", gap: "0.8rem" }}>
              {!isEmptyArray(img_Url) &&
                img_Url.map((image, index) => (
                  <div key={index} className="column">
                    <div className="effect">
                      <div className="effect-img">
                        <img
                          src={image}
                          alt={`upload-${index}`}
                          style={{
                            width: "100px",
                            height: "100px",
                            border: "1px solid black",
                            marginBottom: "5px", // Space between image and text
                            marginRight: "2px",
                            marginLeft: "2px",
                          }}
                          onClick={(e) => imageview(e, index)}
                          onMouseOver={(e) => hoverview(e, index)}
                          onMouseOut={() => setHover(false)} // Reset hover state on mouse out
                        />
                      </div>
                      {hover == true && (
                        <div className="effect-text">
                          <div class="inner">
                            <p
                            // style={{ fontSize: "12px", margin: 0 }}
                            >
                              {hoverData.imageName}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Index Text Below Image */}
                  </div>
                ))}
            </div>
          </form>
          {/* </div> */}
        </div>
        <div className="div_60_no_overflow">
          {/* <div className="image-preview"> */}

          <form onSubmit={handleEditSubmit}>
            {
              !isEmpty(previewUrl) && (
                <div
                  style={{
                    position: "relative",

                    display: "flex",
                  }}
                >
                  <div className="image_grid">
                    {previewUrl != null && (
                      <div>
                        <div
                          style={{
                            padding: "10px",
                            width: "100%",
                          }}
                        >
                          <img
                            src={previewUrl}
                            style={{
                              maxWidth: "100%",
                              maxHeight: "200%",
                              float: "left",
                            }}
                          />

                          <label className="d-flex justify-content-around">
                            <div className="d-flex justify-content-around">
                              <span className="img_icon">
                                <CameraIcon />
                              </span>

                              <input
                                type="file"
                                className="img-input"
                                id="imgTag"
                                accept="image/*"
                                onChange={handleImageEditChange}
                                disabled={isShowDocLabel}
                              />

                              <div className="d-flex justify-content-around align-middle">
                                <div className="align-middle">
                                  {isImagePreview && (
                                    <button
                                      id="fabric_Add_Button"
                                      type="submit"
                                      disabled={isShowDocLabel}
                                    >
                                      Upload
                                    </button>
                                  )}
                                </div>
                                <div className="align-middle">
                                  <Button
                                    id="fabric_Add_Button"
                                    onClick={(e) => deleteUploadedImage(e)}
                                    disabled={isShowDocLabel}
                                  >
                                    <DeleteIcon />
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      padding: "20px",
                    }}
                  >
                    <Row>
                      <Col sm="2">
                        <FormLabel>Name</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          //  value={imageEntity.imageName}
                          value={imageEntity.imageName || ""}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Created By</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          value={imageEntity.createdBy || ""}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>created Date</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          value={imageEntity.createdDate || ""}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Tags</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          value={imageEntity.tags || ""}
                          name="tags"
                          onChange={onImageChange}
                          disabled={isShowDocLabel}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Notes</FormLabel>
                      </Col>
                      <Col sm="9">
                        <textarea
                          style={{
                            maxHeight: "10px",
                            width: "100%",
                            minHeight: "5em",
                            resize: "none",
                            padding: "9px",
                            boxSizing: "border-box",
                            fontSize: "15px",
                          }}
                          name="notesCommunication"
                          onChange={onImageChange}
                          value={imageEntity.notesCommunication || ""}
                          disabled={isShowDocLabel}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col className="text-center">
                        <Button
                          size="sm"
                          id="fabric_Add_Button"
                          className="header_buttons enterFocus"
                          onClick={(e) => addImageLines(e)}
                          disabled={isShowDocLabel}
                        >
                          Add/Update
                        </Button>
                        <Button
                          id="fabric_Add_Button"
                          size="sm1"
                          onClick={(e) => clearImageLines(e)}
                          disabled={isShowDocLabel}
                        >
                          Clear
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </div>
              )
              // ))
            }
          </form>
        </div>
      </div>
    </div>
  );
}

export function MutilpleDocuments(props) {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewDocs] = useState(props.preview_Docs);
  const [documents, setDocuments] = useState([...props.documents]);
  const [tempIndex, setIndex] = useState(null);
  const documentData = props.purchaseOrderData.purchaseOrderDocuments || [];
  const [isDocumentUpload, setIsDocumentUpload] = useState(false);
  const isShowDocLabel = props.isShowDocLabel;
  // const disabledImages =  props.isServiceLineDisablesFields;
  // useEffect(() => {
  //   setColumns(props.columns);
  // }, [props.columns]);

  const docHandler = (e) => {
    e.preventDefault();
    let tempDocs = e.target.files;
    let doc_list = [];
    let previewList = [];
    if (!isEmptyArray(documents)) {
      doc_list = [...documents];
    }
    if (!isEmptyArray(previewUrl)) {
      previewList = [...previewUrl];
    }
    for (let index = 0; index < tempDocs.length; index++) {
      let docUrl = "";
      doc_list.push(tempDocs[index]);
      docUrl = URL.createObjectURL(tempDocs[index]);
      previewList.push(docUrl);
    }
    setDocuments(doc_list);
    setPreviewDocs(previewList);
    setIsDocumentUpload(true);
  };

  useEffect(() => {
    setDocuments(documents);
  }, [documents]);

  const handleDocumentSubmit = (e) => {
    e.preventDefault();
    props.uploadMutiDouments(documents);
    props.uploadMutiDoumentsUrl(previewUrl);
    props.showToast("Uploaded Sucessfully", 1);
    setIsDocumentUpload(false);
  };
  const deleteDocs = (e) => {
    if (e.detail == 1) {
      setFile(null);
      setPreviewDocs("");
      props.showToast("Image deleted sucessfully", 1);
      setDocuments(props.documents);
      setIsDocumentUpload(false);
    }
  };

  const documentColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
              .setDetails("Document", "documentOriginalName", true)
        .setStyleDetails("left", "", "", "wt-10", "wt-10")
        .setClickDetails(true, false, editDocument, null)
        .setDocument(true)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Document Name", "documentName", true)
        .setStyleDetails("left", "", "", "wt-10", "wt-10"),
    );
    columns.push(
      new ColumnDefinition()
 .setDetails("", <DeleteIcon />, false)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2")
        .setClickDetails(false, true, deleteDocuments, <DeleteIcon />)
    );

    return columns;
  };
  const deleteDocuments = (e, value, rowData,index) => {
    let documentDataList = documents;
    let fileUrl = previewUrl;
    documentDataList.map((list, index) => {
      if (list.documentName === rowData.documentName) {
        fileUrl.splice(index, 1);
      }
    });
    setPreviewDocs(fileUrl);
    props.uploadMutiDoumentsUrl(fileUrl);
    props.deleteMultiDocument(rowData);
  };
  const editDocument = (e, name, tempIndex,rowIndex) => {
    let docUrl = previewUrl;
    let tempUrl = "";
    if (!isEmptyArray(docUrl)) {
      for (let index = 0; index < docUrl.length; index++) {
        if (index === rowIndex) {
          tempUrl = docUrl[index];
        }
      }

      window.open(tempUrl);
    }
  };
  return (
    <div className="header_div  div_default">
      <div className="div_inline">
        {/* <div className="div_80_no_overflow"> */}
        <div className="div_60_no_overflow">
          <div className="div_Equal_no_overflow">
            <form onSubmit={handleDocumentSubmit}>
              <div className="d-flex justify-content-around ">
                <div>
                  <label for="imgTag" className="d-flex justify-content-around">
                    <div className="img_label">
                      Attach Documents
                      <span className="img_icon">
                        <UploadDocIcon />
                      </span>
                    </div>

                    <input
                      type="file"
                      className="img-input"
                      id="imgTag"
                      multiple
                      accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
                      onChange={docHandler}
                      disabled={isShowDocLabel}
                    />
                  </label>
                </div>
                {isDocumentUpload && (
                  <div className="d-flex justify-content-around align-middle">
                    <div className="align-middle">
                      <button
                        id="fabric_Add_Button"
                        type="submit"
                        disabled={isShowDocLabel}
                      >
                        Upload
                      </button>
                    </div>
                    <div className="align-middle">
                      <Button
                        id="fabric_Add_Button"
                        onClick={(e) => deleteDocs(e)}
                        disabled={isShowDocLabel}
                      >
                        <DeleteIcon />
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>

       <div className="mt-3">
              <CustomTable
                data={documentData}
                columns={documentColumns()}
      
              />
              </div>
      {/* <div className="div_Custom_3">
        <Table id="fabrics_tables_default">
          <thead>
            <tr>
              <th>Document</th>
              <th>Document Name</th>
              <th>Delete</th>
            </tr>
          </thead>
          {documentData != null ? (
            <tbody>
              {documentData.map(
                (ln, index) =>
                  ln.isDeleted != true && (
                    <tr key={index}>
                      <td className="hyperLinkText">
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            editDocument(e, ln.documentName, index)
                          }
                        >
                          {ln.documentName}
                        </Button>
                      </td>
                      <td>{ln.documentName}</td>
                      <td className="text-end">
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            deleteDocuments(e, ln.documentCode, ln)
                          }
                          disabled={isShowDocLabel}
                        >
                          {<DeleteIcon />}
                        </Button>
                      </td>
                    </tr>
                  ),
              )}
            </tbody>
          ) : null}
        </Table>
      </div> */}
    </div>
  );
}

function PurchaseOrderModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div id="app_container"></div>
      <PurchaseOrderList {...props} name="" /> <br />
    </div>
  );
}

export default PurchaseOrderModule;
